"use strict";

// NOTE TO DEVELOPERS:
// Localizable strings should be double quoted "строка на другом языке",
// non-localizable strings should be single quoted 'non-localized'.

import AccessMode from "./access-mode.js";
import * as Const from "./config.js";
import CommError from "./comm-error.js";
import Connection from "./connection.js";
import DBCache from "./db.js";
import Drafty from "./drafty.js";
import LargeFileHelper from "./large-file.js";
import MetaGetBuilder from "./meta-builder.js";
import { Topic, TopicMe, TopicFnd } from "./topic.js";
import { isUrlRelative, mergeObj, rfc3339DateString } from "./utils.js";
import XMLParser from "@xmpp/xml/lib/parse";
import { $build, $iq, $msg, $pres } from "./builder.js";
import * as MC_CONST from "./constants.js";
import { getNodeFromJid, serialize } from "./utils2.js";
import lodash from "lodash";
import { profile } from "../stores/storages/ProfileStorage.js";
import sha1 from "sha1";
import MessagesUtil from "./messagesUtils";
import ContactService from "../services/contact.js";
import ChatServices from "../services/chat.js";
import RestoreServices from '../services/restore'
import axios from "axios";
import { blobToBase64 } from "../lib/blob-helpers";
import Helpers from "../lib/helpers";
import StickerService from "../services/sticker.js";
import BlockChatServices from "../services/blockchat.js"
import { stickers } from "../stores/storages/StickerStorage.js";
import { user } from "../stores/storages/UserStorage.js";
import { DOMAIN_IMG_OA_DEFAULT, QUOTED_REPLY_LENGTH, APP_NAME, MAX_IMAGE_DIM, AppName, XXTEA_KEY_DEFAULT } from '../config';
import { defineMessages } from "react-intl";
import PhoneUtils from "../lib/phone.js";
import GroupService from "../services/group.js";
import SettingsService from '../services/settings'
import formatter from '../services/formatter'
import StringUtils from "../lib/string.js";
import { PROGRESS_TYPE } from '../widgets/loading.jsx'
import fileService from '../services/file'
import Signal from '../services/signal-protocol/signal'
import { clientInfo } from '../version.js'
import TimeHelpers from "../lib/time.js";
import { JOIN_GROUP_STATE } from '../widgets/dialog/join-group-info.jsx'
import LoggerServices from "../services/logger.js";
import { APP_CODE_LOGGER } from "../services/constants.js";

const linkify = require('linkifyjs');

const messages = defineMessages({
  notify_rename_by_edit: {
    id: "notify_rename_by_edit",
    defaultMessage: "{fromName} renamed the group to {groupName}",
    description: "Notice of group name change to group members",
  },
  notify_create_group_by: {
    id: "notify_create_group_by",
    defaultMessage: "{fromName} created the group",
    description: "Notice create group by owner",
  },
  notify_invite_member_group: {
    id: "notify_invite_member_group",
    defaultMessage: "{inviteName} invited {invitePerson} to group",
    description: "Notice add member to group",
  },
  notify_rename_group: {
    id: 'notify_rename_group',
    defaultMessage: 'You renamed the group to "{groupName}"',
    description: 'Notice of group name change by creator',
  },
  notify_remove_admin: {
    id: 'notify_remove_admin',
    defaultMessage: '{onwer} have removed admin rights for {member}',
  },
  notify_add_admin: {
    id: 'notify_add_admin',
    defaultMessage: '{onwer} have granted administrator rights to {member}',
  },
  you: {
    id: 'calls_you_label',
    defaultMessage: 'You',
  },
  notify_leave_group: {
    id: 'notify_leave_group',
    defaultMessage: '{member} has left the group'
  },
  oa_dissolve_group_by_me: {
    id: 'oa_dissolve_group_by_me',
    defaultMessage: 'You deleted the group "{groupName}". You can no longer search and chat on this group',
    description: 'Notice OA dissolve group by me',
  },
  oa_dissolve_group_by_others: {
    id: 'oa_dissolve_group_by_others',
    defaultMessage: '{adminName} deleted the group "{groupName}". You can no longer search and chat on this group',
    description: 'Notice OA dissolve group by others',
  },
  unblockUser: {
    id: 'unblockUser',
    defaultMessage: 'Unblocked {phoneName} successfully',
    description: 'Unblocked successfully'
  },
  blockUser_content: {
    id: 'blockUser_content',
    defaultMessage: 'Blocked {phoneName} successfully',
    description: 'Blocked successfully'
  },
  leave_group_notify: {
    id: 'leave_group_notify',
    defaultMessage: 'You have left this group',
    description: 'You have left this group'
  },
  member_leave_group_notify: {
    id: 'member_leave_group_notify',
    defaultMessage: '{memberName} has left this group',
    description: 'memberName have left this group'
  },
  change_avatar_group_notify: {
    id: 'change_avatar_group_notify',
    defaultMessage: '{memberName} has changed the group avatar',
    description: 'memberName has changed the group avatar'
  },
  notify_changed_avatar_group: {
    id: 'notify_changed_avatar_group',
    defaultMessage: 'You changed group profile photo',
    description: 'Changed group profile photo'
  },
  pin_message_notify: {
    id: 'pin_message_notify',
    defaultMessage: '{member} pinned a message',
    description: '{member} pinned a message'
  },
  unpin_message_notify: {
    id: 'unpin_message_notify',
    defaultMessage: '{member} has deleted the pinned message',
    description: '{member} has deleted the pinned message'
  },
  make_your_admin: {
    id: 'make_your_admin',
    defaultMessage: 'You have become an administrator',
    description: 'You have become an administrator'
  },
  set_group_private_success: {
    id: "set_group_private_success",
    defaultMessage: "{member} have changed the group privacy settings to private",
    description: "Notify private success",
  },
  set_group_public_success: {
    id: "set_group_public_success",
    defaultMessage: "{member} have changed the group privacy settings to public",
    description: "Notify public success",
  },
  badge_you: {
    id: "badge_you",
    defaultMessage: "You",
    description: "You",
  },
  backup_success_message: {
    id: "backup_success_message",
    defaultMessage: "The sync process was successful",
    description: "The sync process was successful",
  },
  left_group_by_kick: {
    id: "left_group_by_kick",
    defaultMessage: "{memberName} removed you",
    description: "{memberName} removed you",
  },
  join_group: {
    id: "join_group",
    defaultMessage: "{newMemberName} has been invited to join the group by {memberInvite}",
    description: "{newMemberName} has been invited to join the group by {memberInvite}",
  },
  join_and_group: {
    id: "join_and_group",
    defaultMessage: "and",
    description: "and",
  },
  e2e_chat_on_notify: {
    id: "e2e_chat_on_notify",
    defaultMessage: "{fromName} enabled secret chat with {toName}. Secret chats have {appName}'s end-to-end encryption and message forwarding protection. You can also enable this feature with other people by opening the conversation's Settings then choosing Secret chat",
    description: "Notify when on E2E",
  },
  e2e_chat_off_notify: {
    id: "e2e_chat_off_notify",
    defaultMessage: "{fromName} disabled secret chat with {toName}",
    description: "Notify when off E2E",
  },
  e2e_encrypted_message: {
    id: "e2e_encrypted_message",
    defaultMessage: "Encrypted message",
    description: "Encrypted message",
  },
  image_message: {
    id: "image_message",
    defaultMessage: "Image message",
    description: "Image message",
  },
  video_message: {
    id: "video_message",
    defaultMessage: "Video message",
    description: "Video message",
  },
  file_message: {
    id: "file_message",
    defaultMessage: "File message",
    description: "File message",
  },
  audio_message: {
    id: "audio_message",
    defaultMessage: "Audio message",
    description: "Audio message",
  },
  location_message: {
    id: "location_message",
    defaultMessage: "Location message",
    description: "Location message",
  },
  voice_sticker_message: {
    id: "voice_sticker_message",
    defaultMessage: "Voice sticker message",
    description: "Voice sticker message",
  },
  contact_message: {
    id: "contact_message",
    defaultMessage: "Contact message",
    description: "Contact message",
  },
  group_invite_link_expired: {
    id: "group_invite_link_expired",
    defaultMessage: "The link to join the group you just accessed is no longer valid. Please contact the person who invited you for more details.",
    description: "The link to join the group you just accessed is no longer valid. Please contact the person who invited you for more details.",
  },
  db_not_exists: {
    id: "db_not_exists",
    defaultMessage: "Your local message data is lost or outdated.",
    description: "Your local message data is lost or outdated."
  }
});
// Re-export AccessMode
export { AccessMode };

let WebSocketProvider;
if (typeof WebSocket != "undefined") {
  WebSocketProvider = WebSocket;
}

let XHRProvider;
if (typeof XMLHttpRequest != "undefined") {
  XHRProvider = XMLHttpRequest;
}

let IndexedDBProvider;
if (typeof indexedDB != "undefined") {
  IndexedDBProvider = indexedDB;
}

// Re-export Drafty.
export { Drafty };

initForNonBrowserApp();

// Utility functions

// Polyfill for non-browser context, e.g. NodeJs.
function initForNonBrowserApp() {
  // Tinode requirement in native mode because react native doesn't provide Base64 method
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

  if (typeof btoa == "undefined") {
    global.btoa = function (input = "") {
      let str = input;
      let output = "";

      for (
        let block = 0, charCode, i = 0, map = chars;
        str.charAt(i | 0) || ((map = "="), i % 1);
        output += map.charAt(63 & (block >> (8 - (i % 1) * 8)))
      ) {
        charCode = str.charCodeAt((i += 3 / 4));

        if (charCode > 0xff) {
          throw new Error(
            "'btoa' failed: The string to be encoded contains characters outside of the Latin1 range."
          );
        }
        block = (block << 8) | charCode;
      }

      return output;
    };
  }

  if (typeof atob == "undefined") {
    global.atob = function (input = "") {
      let str = input.replace(/=+$/, "");
      let output = "";

      if (str.length % 4 == 1) {
        throw new Error(
          "'atob' failed: The string to be decoded is not correctly encoded."
        );
      }
      for (
        let bc = 0, bs = 0, buffer, i = 0;
        (buffer = str.charAt(i++));
        ~buffer && ((bs = bc % 4 ? bs * 64 + buffer : buffer), bc++ % 4)
          ? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
          : 0
      ) {
        buffer = chars.indexOf(buffer);
      }

      return output;
    };
  }

  if (typeof window == "undefined") {
    global.window = {
      WebSocket: WebSocketProvider,
      XMLHttpRequest: XHRProvider,
      indexedDB: IndexedDBProvider,
      URL: {
        createObjectURL: function () {
          throw new Error(
            "Unable to use URL.createObjectURL in a non-browser application"
          );
        },
      },
    };
  }

  Connection.setNetworkProviders(WebSocketProvider, XHRProvider);
  LargeFileHelper.setNetworkProvider(XHRProvider);
  DBCache.setDatabaseProvider(IndexedDBProvider);
}

// Detect find most useful network transport.
function detectTransport() {
  if (typeof window == "object") {
    if (window["WebSocket"]) {
      return "ws";
    } else if (window["XMLHttpRequest"]) {
      // The browser or node has no websockets, using long polling.
      return "lp";
    }
  }
  return null;
}

// btoa replacement. Stock btoa fails on on non-Latin1 strings.
function b64EncodeUnicode(str) {
  // The encodeURIComponent percent-encodes UTF-8 string,
  // then the percent encoding is converted into raw bytes which
  // can be fed into btoa.
  return btoa(
    encodeURIComponent(str).replace(
      /%([0-9A-F]{2})/g,
      function toSolidBytes(match, p1) {
        return String.fromCharCode("0x" + p1);
      }
    )
  );
}

// JSON stringify helper - pre-processor for JSON.stringify
function jsonBuildHelper(key, val) {
  if (val instanceof Date) {
    // Convert javascript Date objects to rfc3339 strings
    val = rfc3339DateString(val);
  } else if (val instanceof AccessMode) {
    val = val.jsonHelper();
  } else if (
    val === undefined ||
    val === null ||
    val === false ||
    (Array.isArray(val) && val.length == 0) ||
    (typeof val == "object" && Object.keys(val).length == 0)
  ) {
    // strip out empty elements while serializing objects to JSON
    return undefined;
  }

  return val;
}

// Trims very long strings (encoded images) to make logged packets more readable.
function jsonLoggerHelper(key, val) {
  if (typeof val == "string" && val.length > 128) {
    return (
      "<" +
      val.length +
      ", bytes: " +
      val.substring(0, 12) +
      "..." +
      val.substring(val.length - 12) +
      ">"
    );
  }
  return jsonBuildHelper(key, val);
}

// Parse browser user agent to extract browser name and version.
function getBrowserInfo(ua, product) {
  ua = ua || "";
  let reactnative = "";
  // Check if this is a ReactNative app.
  if (/reactnative/i.test(product)) {
    reactnative = "ReactNative; ";
  }
  let result;
  // Remove useless string.
  ua = ua.replace(" (KHTML, like Gecko)", "");
  // Test for WebKit-based browser.
  let m = ua.match(/(AppleWebKit\/[.\d]+)/i);
  if (m) {
    // List of common strings, from more useful to less useful.
    // All unknown strings get the highest (-1) priority.
    const priority = ["edg", "chrome", "safari", "mobile", "version"];
    let tmp = ua.substr(m.index + m[0].length).split(" ");
    let tokens = [];
    let version; // 1.0 in Version/1.0 or undefined;
    // Split string like 'Name/0.0.0' into ['Name', '0.0.0', 3] where the last element is the priority.
    for (let i = 0; i < tmp.length; i++) {
      let m2 = /([\w.]+)[\/]([\.\d]+)/.exec(tmp[i]);
      if (m2) {
        // Unknown values are highest priority (-1).
        tokens.push([
          m2[1],
          m2[2],
          priority.findIndex((e) => {
            return m2[1].toLowerCase().startsWith(e);
          }),
        ]);
        if (m2[1] == "Version") {
          version = m2[2];
        }
      }
    }
    // Sort by priority: more interesting is earlier than less interesting.
    tokens.sort((a, b) => {
      return a[2] - b[2];
    });
    if (tokens.length > 0) {
      // Return the least common browser string and version.
      if (tokens[0][0].toLowerCase().startsWith("edg")) {
        tokens[0][0] = "Edge";
      } else if (tokens[0][0] == "OPR") {
        tokens[0][0] = "Opera";
      } else if (tokens[0][0] == "Safari" && version) {
        tokens[0][1] = version;
      }
      result = tokens[0][0] + "/" + tokens[0][1];
    } else {
      // Failed to ID the browser. Return the webkit version.
      result = m[1];
    }
  } else if (/firefox/i.test(ua)) {
    m = /Firefox\/([.\d]+)/g.exec(ua);
    if (m) {
      result = "Firefox/" + m[1];
    } else {
      result = "Firefox/?";
    }
  } else {
    // Neither AppleWebKit nor Firefox. Try the last resort.
    m = /([\w.]+)\/([.\d]+)/.exec(ua);
    if (m) {
      result = m[1] + "/" + m[2];
    } else {
      m = ua.split(" ");
      result = m[0];
    }
  }

  // Shorten the version to one dot 'a.bb.ccc.d -> a.bb' at most.
  m = result.split("/");
  if (m.length > 1) {
    const v = m[1].split(".");
    const minor = v[1] ? "." + v[1].substr(0, 2) : "";
    result = `${m[0]}/${v[0]}${minor}`;
  }
  return reactnative + result;
}

const arrayMove = (arr, oldIndex, newIndex) => {
  if (newIndex >= arr.length) {
    let k = newIndex - arr.length + 1;
    while (k) {
      arr.push(undefined);
      k -= 1;
    }
  }
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
  return arr; // for testing
};

/**
 * The main class for interacting with Tinode server.
 */
export class Tinode {
  _host;
  _ws_host;
  _secure;

  _appName;

  // API Key.
  _apiKey;

  // Name and version of the browser.
  _browser = "";
  _platform;
  // Hardware
  _hwos = "undefined";
  _humanLanguage = "xx";

  // Logging to console enabled
  _loggingEnabled = false;
  // When logging, trip long strings (base64-encoded images) for readability
  _trimLongStrings = false;
  // UID of the currently authenticated user.
  _myUID = null;
  // Status of connection: authenticated or not.
  _authenticated = false;
  // Login used in the last successful basic authentication
  _login = null;
  // Token which can be used for login instead of login/password.
  _authToken = null;
  // Counter of received packets
  _inPacketCount = 0;
  // Counter for generating unique message IDs
  _messageId = Math.floor(Math.random() * 0xffff + 0xffff);
  // Information about the server, if connected
  _serverInfo = null;
  // Push notification token. Called deviceToken for consistency with the Android SDK.
  _deviceToken = null;

  // Cache of pending promises by message id.
  _pendingPromises = {};
  // The Timeout object returned by the reject expired promises setInterval.
  _expirePromises = null;

  // Websocket or long polling connection.
  _connection = null;

  // Use indexDB for caching topics and messages.
  _persist = false;
  // IndexedDB wrapper object.
  _db = null;
  _dbLog = null;

  // Tinode's cache of objects
  _cache = {};

  // Username/Token Authen XMPP
  _username = null;
  _token = null;

  _chatMessageRefs = {}
  _findMessageRefs = {}
  messageEditArea = null

  _isWaitKeyFromMobile = false

    // Console logger. Babel somehow fails to parse '...rest' parameter.
  logger = (str, ...args) => {
    try {
      if (this._loggingEnabled || profile.loggingEnabled) {
        const d = new Date();
        const dateString = TimeHelpers.getCurrentDateTime()

        const body = "[" + dateString + "]" + str + args.join(" ")

        console.log(body);

        if (this?._db?.log) {
          this._db.log(body)
        }

      }
    } catch (err) {
      console.error(err)
    }
  }

  /**
   * Create Tinode object.
   *
   * @param {Object} config - configuration parameters.
   * @param {string} config.appName - Name of the calling application to be reported in the User Agent.
   * @param {string} config.host - Host name and optional port number to connect to.
   * @param {string} config.apiKey - API key generated by <code>keygen</code>.
   * @param {string} config.transport - See {@link Tinode.Connection#transport}.
   * @param {boolean} config.secure - Use Secure WebSocket if <code>true</code>.
   * @param {string} config.platform - Optional platform identifier, one of <code>"ios"</code>, <code>"web"</code>, <code>"android"</code>.
   * @param {boolen} config.persist - Use IndexedDB persistent storage.
   * @param {function} onComplete - callback to call when initialization is completed.
   */
  constructor(config, onComplete) {
    this._host = config.host;
    this._ws_host = config.ws_host;
    this._secure = config.secure;

    // Client-provided application name, format <Name>/<version number>
    this._appName = config.appName || "Undefined";

    // API Key.
    this._apiKey = config.apiKey;

    // Name and version of the browser.
    this._platform = config.platform || "web";
    // Underlying OS.
    if (typeof navigator != "undefined") {
      this._browser = getBrowserInfo(navigator.userAgent, navigator.product);
      this._hwos = navigator.platform;
      // This is the default language. It could be changed by client.
      this._humanLanguage = navigator.language || "en-US";
    }

    Connection.logger = this.logger;
    Drafty.logger = this.logger;

    // WebSocket or long polling network connection.
    if (config.transport != "lp" && config.transport != "ws") {
      config.transport = detectTransport();
    }
    this._connection = new Connection(
      config,
      Const.PROTOCOL_VERSION,
      /* autoreconnect */ true
    );

    this._connection.onMessage = async (data) => {
      // Call the main message dispatcher.
      if (data.startsWith("<stream:stream")) {
        data = `${data}</stream:stream>`;
      }
      this.logger("[INPUT]" + data);
      try {
        const message = XMLParser(data);
        await this.#dispatchMessage(message);
      } catch (e) {
        console.error(e)
      }
    };

    // Ready to start sending.
    this._connection.onOpen = (_) => this.#connectionOpen();
    this._connection.onDisconnect = (err, code) => {
      this.rejectPingInterval()
      this.#disconnected(err, code);
    }


    // Wrapper for the reconnect iterator callback.
    this._connection.onAutoreconnectIteration = (timeout, promise) => {
      if (this.onAutoreconnectIteration) {
        this.onAutoreconnectIteration(timeout, promise);
      }
    };

    this._persist = config.persist;
    // Initialize object regardless. It simplifies the code.
    this._db = new DBCache((err) => {
      this.logger("DB", err);
    }, this.logger);

    if (this._persist) {
      this.#makeDBPersist(onComplete)
    } else {
      LoggerServices.createLog({
        'app-code': APP_CODE_LOGGER,
        content: `REQUEST_CLEAR_DB|${profile.username}|Reasion:_persist change`
      });

      this._db.deleteDatabase().then((_) => {
        if (onComplete) {
          onComplete();
        }
      });
    }
  }

  #makeDBPersist (onComplete = () => {}) {
    // Create the persistent cache.
    // Store promises to be resolved when messages load into memory.
    const prom = [];
    return this._db
      .initDatabase()
      .catch((err) => {
        try {
          console.log(profile.retryIndexedDBCOunt)
          profile.retryIndexedDBCOunt = profile.retryIndexedDBCOunt + 1
          console.log('2', profile.retryIndexedDBCOunt)
        } catch (e) {
          profile.retryIndexedDBCOunt = 0
        }
        if (profile.retryIndexedDBCOunt < 5) {
          window.location.reload()
        } else {
          if (!!this.handleShowAlert) {
            this.handleShowAlert(
              "ERROR",
              "Failed to load data. Please try again later.",
              () => {
                window.location.reload()
              },
              "Reload Page"
            )
          }
        }

      })
      .then((_) => {
        profile.retryIndexedDBCOunt = 0

        // First load topics into memory.
        return this._db.mapTopics((data) => {
          let topic = this.#cacheGet("topic", data.name);
          if (topic) {
            return;
          }
          if (data.name == Const.TOPIC_ME) {
            topic = new TopicMe();
          } else if (data.name == Const.TOPIC_FND) {
            topic = new TopicFnd();
          } else {
            topic = new Topic(data.name);
          }
          this._db.deserializeTopic(topic, data);
          this.#attachCacheToTopic(topic);
          topic._cachePutSelf();
          // Topic loaded from DB is not new.
          delete topic._new;
          // Request to load messages and save the promise.
          prom.push(topic._loadMessages(this._db));
        });
      })
      .then((_) => {
        // Then load users.
        return this._db.mapUsers((data) => {
          this.#cachePut("user", data.uid, mergeObj({}, data.public));
        });
      })
      .then((_) => {
        // Now wait for all messages to finish loading.
        return Promise.all(prom);
      })
      .then((_) => {
        if (onComplete) {
          onComplete();
        }
        this.logger("Persistent cache initialized.");
        this.cached_loaded = true
        this.updateMsgSendingToFail()
        this.requestOfflineMessage(true);
      })
      .catch((err) => {
        if (onComplete) {
          onComplete(err);
        }
        this.logger("Failed to initialize persistent cache:", err);
      });
  }


  // Private methods.

  // Generator of default promises for sent packets.
  #makePromise(id) {
    this.logger("MESSAGE_PROMISE|#makePromise", id)
    let promise = null;
    if (id) {
      promise = new Promise((resolve, reject) => {
        // Stored callbacks will be called when the response packet with this Id arrives
        this._pendingPromises[id] = {
          resolve: resolve,
          reject: reject,
          ts: new Date(),
        };
      });
    }
    return promise;
  }

  // Resolve or reject a pending promise.
  // Unresolved promises are stored in _pendingPromises.
  #execPromise(id, code, onOK, errorText) {
    this.logger("MESSAGE_PROMISE|#execPromise", id)
    const callbacks = this._pendingPromises[id];
    if (callbacks) {
      delete this._pendingPromises[id];
      if (code === 0) {
        // just delete promise
        return
      } else if (code >= 200 && code < 400) {
        if (callbacks.resolve) {
          callbacks.resolve(onOK);
        }
      } else if (callbacks.reject) {
        callbacks.reject(new CommError(errorText, code));
      }
    }
  }

  // Send a packet. If packet id is provided return a promise.
  #send(msg, id) {
    let promise;
    if (id) {
      promise = this.#makePromise(id);
    }
    this.logger("[OUTPUT] " + msg);
    try {
      this._connection.sendText(msg);
    } catch (err) {
      // If sendText throws, wrap the error in a promise or rethrow.
      if (id) {
        this.#execPromise(id, Connection.NETWORK_ERROR, null, err.message);
      } else {
        throw err;
      }
    }
    return promise;
  }

  // The main message dispatcher.
  async #dispatchMessage(data) {
    // Skip empty response. This happens when LP times out.
    if (!data) return;
    this._inPacketCount++;

    // Send raw message to listener
    if (this.onRawMessage) {
      this.onRawMessage(data);
    }

    if (data === "0") {
      // Server response to a network probe.
      if (this.onNetworkProbe) {
        this.onNetworkProbe();
      }
      // No processing is necessary.
      return;
    }

    if (this.onMessage) {
      await this.onMessage(data);
    }
  }

  // Connection open, ready to start sending.
  #connectionOpen() {
    this.openStream(MC_CONST.OPEN_STREAM_MSG_ID);

    if (!this._expirePromises) {
      // Reject promises which have not been resolved for too long.
      this._expirePromises = setInterval(_ => {
        const err = new CommError("timeout", 504);
        const expires = new Date(new Date().getTime() - Const.EXPIRE_PROMISES_TIMEOUT);
        for (let id in this._pendingPromises) {
          let callbacks = this._pendingPromises[id];
          if (callbacks && callbacks.ts < expires) {
            this.logger("Promise expired", id);
            delete this._pendingPromises[id];
            if (id === MC_CONST.OPEN_STREAM_MSG_ID) {
              this.openStream(MC_CONST.OPEN_STREAM_MSG_ID);
            } else {
              if (callbacks.reject) {
                // callbacks.reject(err);
                console.log(callbacks, err)
              }
              this.updateMessageFailedStatus(id)
            }

          }
        }
      }, Const.EXPIRE_PROMISES_PERIOD);
    }

  }

  #disconnected(err, code) {
    this._inPacketCount = 0;
    this._serverInfo = null;
    this._authenticated = false;

    if (this._expirePromises) {
      clearInterval(this._expirePromises);
      this._expirePromises = null;
    }

    // Mark all topics as unsubscribed
    this.#cacheMap("topic", (topic, key) => {
      topic._resetSub();
    });

    // Reject all pending promises
    for (let key in this._pendingPromises) {
      const callbacks = this._pendingPromises[key];
      if (callbacks && callbacks.reject) {
        console.log(key, callbacks)
        // callbacks.reject(err);
      }
    }
    this._pendingPromises = {};

    if (this.onDisconnect) {
      this.onDisconnect(err);
    }
  }

  // Generator of packets stubs
  #initPacket(type, data) {
    switch (type) {
      case "openStream":
        return '<stream:stream to="reeng" xmlns="jabber:client" xmlns:stream="http://etherx.jabber.org/streams" version="1.1">';

      case "auth": {
        return serialize(
          $iq({
            type: MC_CONST.MC.TYPE,
            authentype: MC_CONST.MC.AUTHENTYPE,
            id: data.id,
          })
            .c("query", { xmlns: MC_CONST.NS.AUTH })
            .c("mechanism", {}, MC_CONST.MC.MECHANISM)
            .c("username", {}, data.username)
            .c("digest", {}, sha1(data.id + data.token))
            .c("resource", {}, clientInfo.platform)
            .c("client_type", {}, clientInfo.platform)
            .c("revision", {}, clientInfo.revision)
            .c("country", {}, clientInfo.country)
            .c("ssid", {}, data.ssid)
            .c("new_ssid", {}, MC_CONST.MC.NEW_SSID)
            .c("web", {}, 1)
        );
      }
      case "login": {
        return {
          login: {
            id: this.getNextUniqueId(),
            scheme: null,
            secret: null,
          },
        };
      }
      case "logout": {
        return serialize(
          $pres({
            id: MessagesUtil.xmppid(),
            type: MC_CONST.NODE_TYPE_PRESENSE.UNAVAILABLE,
            subtype: MC_CONST.NODE_SUBTYPE_PRESENCE.DEACTIVE,
          }).c("status", {}, "unregister")
        );
      }
      case "ping": {
        const msg = serialize(
          $iq({
            id: MessagesUtil.xmppid(),
            type: "get",
          }).c(
            "query",
            {
              xmlns: MC_CONST.NS.PING,
            },
            ""
          )
        );
        return msg;
      }
      case MC_CONST.PACKAGE_TYPE.FOREGROUND:
      case MC_CONST.PACKAGE_TYPE.BACKGROUND: {
        const msg = serialize(
          $pres({
            id: MessagesUtil.xmppid(),
            subtype: data.subtype || type,
          }, {})
        );
        return msg;
      }
      case `${MC_CONST.NODE_TYPE_MESSAGE.CHAT}_${MC_CONST.NODE_TYPE_PRESENSE.SUBSCRIBE}`: {
        const { threadId, topicName } = data;
        const id = MessagesUtil.xmppid();
        const msg = serialize(
          $pres({
            to: `${threadId}@reeng/reeng`,
            id,
            type: MC_CONST.NODE_TYPE_PRESENSE.SUBSCRIBE,
          })
        );

        return {
          sub: {
            topic: topicName,
            id,
            set: {},
            get: {},
          },
          msg,
        };
      }
      case `${MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT}_${MC_CONST.NODE_TYPE_PRESENSE.SUBSCRIBE}`: {
        const { threadId, topicName } = data;
        const id = MessagesUtil.xmppid();
        const msg = serialize(
          $iq({
            to: `${threadId}@muc.reeng`,
            id,
            type: MC_CONST.NODE_TYPE_IQ.GET,
          }).c(
            "query",
            {
              xmlns: MC_CONST.NS.CONFIG,
            },
            null
          )
        );

        return {
          sub: {
            topic: topicName,
            id,
            set: {},
            get: {},
          },
          msg,
        };
      }
      case "leave":
        return {
          leave: {
            id: this.getNextUniqueId(),
            topic: data,
            unsub: false,
          },
        };

      case "set":
        return {
          set: {
            id: this.getNextUniqueId(),
            topic: data,
            desc: {},
            sub: {},
            tags: [],
            ephemeral: {},
          },
        };

      case `${MC_CONST.NODE_TYPE_MESSAGE.CHAT}_${MC_CONST.NODE_SUBTYPE_MESSAGE.TEXT}`:
      case `${MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT}_${MC_CONST.NODE_SUBTYPE_MESSAGE.TEXT}`: {
        const { from, to, id, crypt, body, sbody, type, subtype, replyMsg, replyBody, cstate, cdesktop, fOpr, tOpr, tags, tagAll } = data;
        const attributes = {
          id,
          from,
          to,
          type,
          f_opr: fOpr,
          subtype,
        };
        if (type === MC_CONST.NODE_TYPE_MESSAGE.CHAT) {
          attributes.t_opr = tOpr
        }
        const message = $build("message", attributes).c("cstate", {}, cstate);
        if (cdesktop) {
          message.c("cdesktop", {}, cdesktop);
        }
        if (crypt) {
          message.c("body", {}, body);
          message.c("sbody", {}, sbody);
          message.c("crypt", {}, crypt);
          if (replyMsg) {
            message.c("reply", {}, JSON.stringify(replyMsg))
          }
        } else {
          if (replyMsg) {
            message
              .c("reply", {}, JSON.stringify(replyMsg))
              .c("body", {}, replyBody);
          } else {
            message.c("body", {}, body);
          }
        }

        if (tags) {
          message.c('tag', {}, JSON.stringify(tags))
        }
        if (tagAll) {
          message.c('tag_all', {}, null)
        }
        return serialize(message);
      }
      case `${MC_CONST.NODE_TYPE_MESSAGE.CHAT}_${MC_CONST.NODE_SUBTYPE_MESSAGE.IMAGE}`:
      case `${MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT}_${MC_CONST.NODE_SUBTYPE_MESSAGE.IMAGE}`: {
        const { from, to, id, body, type, subtype, cstate, fOpr, tOpr, fname, mediaLink, mediaId, ratio, cdesktop } = data;
        const attributes = {
          id,
          from,
          to,
          type,
          f_opr: fOpr,
          subtype,
        };
        if (type === MC_CONST.NODE_TYPE_MESSAGE.CHAT) {
          attributes.t_opr = tOpr
        }
        const message = $msg(attributes)
          .c("cstate", {}, cstate)
          .c("name", {}, fname)
          .c("media_link", {}, mediaLink)
          .c("id", {}, mediaId)
          .c("ratio", {}, ratio)
        if (body) {
          message.c("body", {}, body);
        }
        if (cdesktop) {
          message.c("cdesktop", {}, cdesktop);
        }
        return serialize(message);
      }
      case `${MC_CONST.NODE_TYPE_MESSAGE.CHAT}_${MC_CONST.NODE_SUBTYPE_MESSAGE.FILE}`:
      case `${MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT}_${MC_CONST.NODE_SUBTYPE_MESSAGE.FILE}`: {
        const {
          from,
          to,
          id,
          body,
          type,
          subtype,
          cstate,
          fOpr,
          tOpr,
          fname,
          mediaLink,
          mediaId,
          size,
          cdesktop,
        } = data;
        const attributes = {
          id,
          from,
          to,
          type,
          f_opr: fOpr,
          subtype,
        };
        if (type === MC_CONST.NODE_TYPE_MESSAGE.CHAT) {
          attributes.t_opr = tOpr
        }
        const message = $msg(attributes)
          .c("cstate", {}, cstate)
          .c("name", {}, fname)
          .c("media_link", {}, mediaLink)
          .c("id", {}, mediaId)
          .c("size", {}, size)
        if (body) {
          message.c("body", {}, body);
        }
        if (cdesktop) {
          message.c("cdesktop", {}, cdesktop);
        }
        return serialize(message);
      }
      case `${MC_CONST.NODE_TYPE_MESSAGE.CHAT}_${MC_CONST.NODE_SUBTYPE_MESSAGE.VIDEO}`:
      case `${MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT}_${MC_CONST.NODE_SUBTYPE_MESSAGE.VIDEO}`: {
        const { from, to, id, body, type, subtype, cstate, fOpr, tOpr, fname, mediaLink, mediaId, thumb, duration, size, cdesktop } = data;
        const attributes = {
          id,
          from,
          to,
          type,
          f_opr: fOpr,
          t_opr: tOpr,
          subtype,
        };
        const message = $msg(attributes)
          .c("cstate", {}, cstate)
          .c("name", {}, fname)
          .c("thumb", {}, thumb)
          .c("media_link", {}, mediaLink)
          .c("duration", {}, duration)
          .c("size", {}, size)
          .c("id", {}, mediaId)
        if (body) {
          message.c("body", {}, body);
        }
        if (cdesktop) {
          message.c("cdesktop", {}, cdesktop);
        }
        return serialize(message);
      }
      case `${MC_CONST.NODE_TYPE_MESSAGE.CHAT}_${MC_CONST.NODE_SUBTYPE_MESSAGE.VOICE_STICKER}`:
      case `${MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT}_${MC_CONST.NODE_SUBTYPE_MESSAGE.VOICE_STICKER}`: {
        const { from, to, id, type, subtype, fOpr, tOpr, collectionId, stickerId, stikerType, cdesktop } = data;
        const attributes = {
          id,
          from,
          to,
          type,
          f_opr: fOpr,
          subtype,
        };
        if (type === MC_CONST.NODE_TYPE_MESSAGE.CHAT) {
          attributes.t_opr = tOpr
        }
        const message = $msg(attributes)
          .c("itemid", {}, stickerId)
          .c("item_type", {}, stikerType)
          .c("packageid", {}, collectionId);
        if (cdesktop) {
          message.c("cdesktop", {}, cdesktop);
        }
        return serialize(message);
      }
      case `${MC_CONST.NODE_TYPE_MESSAGE.CHAT}_${MC_CONST.NODE_SUBTYPE_MESSAGE.CONTACT}`:
      case `${MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT}_${MC_CONST.NODE_SUBTYPE_MESSAGE.CONTACT}`: {
        const { from, to, id, type, subtype, fOpr, tOpr, sharedContactName, sharedPhone, cdesktop } = data;
        const attributes = {
          id,
          from,
          to,
          type,
          f_opr: fOpr,
          subtype,
        };
        if (type === MC_CONST.NODE_TYPE_MESSAGE.CHAT) {
          attributes.t_opr = tOpr
        }
        const msg = $msg(attributes)
          .c('name', {}, sharedContactName)
          .c('tel', {}, sharedPhone)
          .c('cstate', {}, 1)
        if (cdesktop) {
          msg.c("cdesktop", {}, cdesktop);
        }
        return serialize(msg);
      }
      case `${MC_CONST.NODE_TYPE_MESSAGE.CHAT}_${MC_CONST.NODE_SUBTYPE_MESSAGE.EVENT}_${MC_CONST.NODE_TAG_NAME.REACT}`: {
        const { idref, reactOwner, motionId, threadId } = data;
        const to = `${threadId}@reeng/reeng`;
        const msg = $msg({
          id: MessagesUtil.xmppid(),
          to,
          type: MC_CONST.NODE_TYPE_MESSAGE.CHAT,
          subtype: MC_CONST.NODE_SUBTYPE_MESSAGE.EVENT,
          f_opr: "04", //fix tạm
        })
          .c(
            MC_CONST.NODE_TAG_NAME.REACT,
            {
              add: motionId,
              owner: reactOwner,
            },
            ""
          )
          .c("idref", {}, idref);
        return serialize(msg);
      }
      case MC_CONST.NODE_TYPE_PRESENSE.AVAILABLE: {
        return serialize(
          $pres({
            id: MessagesUtil.xmppid(),
            subtype: MC_CONST.NODE_TYPE_PRESENSE.AVAILABLE,
            xmlns: null,
          })
        );
      }
      case MC_CONST.PACKAGE_TYPE.DELIVERED_SEEN: {
        const { threadId, type, member, status, listId } = data;
        let to;
        switch (type) {
          case MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT:
            to = `${threadId}@muc.reeng`;
            break;
          case MC_CONST.NODE_TYPE_MESSAGE.CHAT:
          default:
            to = `${threadId}@reeng`;
            break;
        }
        const attrs = {
          id: MessagesUtil.xmppid(),
          to,
          type,
          subtype: "event",
        }
        if (member) {
          attrs.member = member
        }
        const msg = $build("message", attrs).c("delivered", status ? { seen: status } : {}, "");
        msg.c("cdesktop", {}, 1)
        listId.forEach((id) => {
          msg.c("id", {}, id);
        });
        return serialize(msg);
      }
      case MC_CONST.PACKAGE_TYPE.DELIVERED_SEEN_NO_ROUTE: {
        const { threadId, listId } = data;
        const to = `${threadId}@reeng/reeng`;
        const msg = $build("message", {
          id: MessagesUtil.xmppid(),
          to,
          type: "event",
          subtype: "no_route",
        }).c("delivered", {}, "");
        listId.forEach((id) => {
          msg.c("id", {}, id);
        });
        msg.c("no_store", {}, "");
        return serialize(msg);
      }
      case MC_CONST.PACKAGE_TYPE.CREATE_GROUP: {
        const { members, groupName, id } = data
        const msg = $iq({
          id: id || MessagesUtil.xmppid(),
          to: 'create@muc.reeng',
          type: 'set',
        })
        const query = $build('query', { xmlns: 'create' }).c('room', { name: groupName }, '')
        members.forEach((member) => {
          query.c('member', {
            jid: member,
            role: MC_CONST.GROUP_ROLE.MEMBER
          }, '')
        })
        msg.cnode(query.tree())

        return serialize(msg)
      }
      case MC_CONST.PACKAGE_TYPE.ADD_GROUP_MEMBER: {
        // <iq id="3lahtgxmpmw" from="0396783058@reeng/desktop" to="0396783058_1701074044815@muc.reeng" type="set"><query xmlns="invite"><member jid="0327043782" role="member"/></query></iq>
        const { topicId, membersToAdd, id } = data
        const groupId = Topic.getThreadId(topicId)
        const msg = $iq({
          from: `${profile.username}@reeng/desktop`,
          id: id || MessagesUtil.xmppid(),
          to: `${groupId}@muc.reeng`,
          type: 'set',
        })
        const query = $build('query', { xmlns: 'invite' })
        membersToAdd.forEach((member) => {
          query.c('member', {
            jid: member,
            role: MC_CONST.GROUP_ROLE.MEMBER
          }, '')
        })
        msg.cnode(query.tree())

        return serialize(msg)
      }
      case MC_CONST.PACKAGE_TYPE.LEAVE_GROUP: {
        // <iq id="indh6c3h2rl" to="0396783058_1701074044815@muc.reeng" type="set"><query xmlns="leave"/></iq>
        const { topicId, id } = data
        const groupId = Topic.getThreadId(topicId)
        const msg = $iq({
          from: `${profile.username}@reeng/desktop`,
          id: id || MessagesUtil.xmppid(),
          to: `${groupId}@muc.reeng`,
          type: 'set',
        })
        const query = $build('query', { xmlns: 'leave' })
        msg.cnode(query.tree())

        return serialize(msg)
      }
      case MC_CONST.PACKAGE_TYPE.CHANGE_KEEP_PRIVATE_GROUP: {
        // <iq id="nev1w25wzi" to="0856715196_1705313431794@muc.reeng" type="set"><query xmlns="groupPrivate"><keep_private value="1"/></query></iq>
        const { topicId, id, keepPrivate } = data
        const value = keepPrivate === '1' ? '1' : '0'
        const groupId = Topic.getThreadId(topicId)
        const msg = $iq({
          from: `${profile.username}@reeng/desktop`,
          id: id || MessagesUtil.xmppid(),
          to: `${groupId}@muc.reeng`,
          type: 'set',
        })
        const query = $build('query', { xmlns: MC_CONST.NS.GROUP_PRIVATE }).c('keep_private', { value })
        msg.cnode(query.tree())

        return serialize(msg)
      }
      case MC_CONST.PACKAGE_TYPE.ADD_GROUP_MEMBER: {
        // <iq id="3lahtgxmpmw" from="0396783058@reeng/desktop" to="0396783058_1701074044815@muc.reeng" type="set"><query xmlns="invite"><member jid="0327043782" role="member"/></query></iq>
        const { topicId, membersToAdd, id } = data
        const groupId = Topic.getThreadId(topicId)
        const msg = $iq({
          from: `${profile.username}@reeng/desktop`,
          id: id || MessagesUtil.xmppid(),
          to: `${groupId}@muc.reeng`,
          type: 'set',
        })
        const query = $build('query', { xmlns: 'invite' })
        membersToAdd.forEach((member) => {
          query.c('member', {
            jid: member,
            role: MC_CONST.GROUP_ROLE.MEMBER
          }, '')
        })
        msg.cnode(query.tree())

        return serialize(msg)
      }
      case MC_CONST.PACKAGE_TYPE.DISSOLVE_GROUP: {
        const { topicId, id } = data
        const groupId = Topic.getThreadId(topicId)
        const msg = $iq({
          from: `${profile.username}@reeng/desktop`,
          id: id || MessagesUtil.xmppid(),
          to: `${groupId}@muc.reeng`,
          type: 'set',
        })
        const query = $build('query', { xmlns: 'dissolve' })
        msg.cnode(query.tree())

        return serialize(msg)
      }

      case MC_CONST.PACKAGE_TYPE.RENAME_GROUP: {
        const { topicId, id } = data
        const groupId = Topic.getThreadId(topicId)
        const msg = serialize(
          $iq({
            id: id || MessagesUtil.xmppid(),
            to: `${groupId}@muc.reeng`,
            type: "set",
          })
            .c("query", { xmlns: MC_CONST.NS.RENAME })
            .c("room", { name: data.newgroupname }, '')
        );
        return msg;
      }

      case `${MC_CONST.NODE_TYPE_MESSAGE.CHAT}_${MC_CONST.NODE_SUBTYPE_MESSAGE.TYPING}`: {
        const { topic } = data;
        const to = `${Topic.getThreadId(topic)}@reeng/reeng`;
        return $msg({
          id: MessagesUtil.xmppid(),
          to,
          from: profile.changeDomain.from,
          type: MC_CONST.NODE_TYPE_MESSAGE.CHAT,
          subtype: MC_CONST.NODE_SUBTYPE_MESSAGE.TYPING,
          f_opr: "04", //fix tạm
        })
          .c("cdesktop", {}, 1)
          .c("cstate", {}, 1);
      }
      case MC_CONST.PACKAGE_TYPE.CLIENT_STATE: {
        const to = `${profile.username}@reeng/reeng`
        return $msg({
          id: MessagesUtil.xmppid(),
          to,
          type: MC_CONST.NODE_TYPE_MESSAGE.CHAT,
          subtype: MC_CONST.NODE_SUBTYPE_MESSAGE.CLIENT_STATE,
        }).c("pc", {
          login: 1,
          from_key_pc: 1,
        }, null)
      }
      case MC_CONST.PACKAGE_TYPE.ENABLE_E2E: {
        const { id, to, fOpr, tOpr, secretStatus } = data
        return $msg({
          id,
          to,
          f_opr: fOpr,
          t_opr: tOpr,
          type: MC_CONST.NODE_TYPE_MESSAGE.CHAT,
          subtype: MC_CONST.NODE_SUBTYPE_MESSAGE.ENABLE_E2E,
        }).c("cstate", {}, 1)
          .c("stateEnableE2E", {}, secretStatus)
      }
      default:
        window.logger(`Unknown packet type requested: ${type}`);
      // throw new Error(`Unknown packet type requested: ${type}`);
    }
  }

  // Cache management
  #cachePut(type, name, obj) {
    this._cache[type + ":" + name] = obj;
  }
  #cacheGet(type, name) {
    return this._cache[type + ":" + name];
  }
  #cacheDel(type, name) {
    delete this._cache[type + ":" + name];
  }
  #cacheDelAll() {
    delete this._cache;
  }
  // Enumerate all items in cache, call func for each item.
  // Enumeration stops if func returns true.
  #cacheMap(type, func, context) {
    const key = type ? type + ":" : undefined;
    for (let idx in this._cache) {
      if (!key || idx.indexOf(key) == 0) {
        if (func.call(context, this._cache[idx], idx)) {
          break;
        }
      }
    }
  }

  // Make limited cache management available to topic.
  // Caching user.public only. Everything else is per-topic.
  #attachCacheToTopic(topic) {
    topic._tinode = this;

    topic._cacheGetUser = (uid) => {
      const pub = this.#cacheGet("user", uid);
      if (pub) {
        return {
          user: uid,
          public: mergeObj({}, pub),
        };
      }
      return undefined;
    };
    topic._cachePutUser = (uid, user) => {
      this.#cachePut("user", uid, mergeObj({}, user.public));
    };
    topic._cacheDelUser = (uid) => {
      this.#cacheDel("user", uid);
    };
    topic._cachePutSelf = (_) => {
      this.#cachePut("topic", topic.name, topic);
    };
    topic._cacheDelSelf = (_) => {
      this.#cacheDel("topic", topic.name);
    };

    topic._cachePutMsgId = (id, msg) => {
      this.#cachePut("message-index", id, msg);
    };

    topic._cacheDelMsgId = (id) => {
      this.#cacheDel("message-index", id);
    };
  }

  // On successful login save server-provided data.
  #loginSuccessful(ctrl) {
    if (!ctrl.params || !ctrl.params.user) {
      return ctrl;
    }
    // This is a response to a successful login,
    // extract UID and security token, save it in Tinode module
    this._myUID = ctrl.params.user;
    this._authenticated = ctrl && ctrl.code >= 200 && ctrl.code < 300;
    if (ctrl.params && ctrl.params.token && ctrl.params.expires) {
      this._authToken = {
        token: ctrl.params.token,
        expires: ctrl.params.expires,
      };
    } else {
      this._authToken = null;
    }

    if (this.onLogin) {
      this.onLogin(ctrl.code, ctrl.text);
    }

    return ctrl;
  }

  // Static methods.
  /**
   * Helper method to package account credential.
   *
   * @param {string | Credential} meth - validation method or object with validation data.
   * @param {string=} val - validation value (e.g. email or phone number).
   * @param {Object=} params - validation parameters.
   * @param {string=} resp - validation response.
   *
   * @returns {Array.<Credential>} array with a single credential or <code>null</code> if no valid credentials were given.
   */
  static credential(meth, val, params, resp) {
    if (typeof meth == "object") {
      ({ val, params, resp, meth } = meth);
    }
    if (meth && (val || resp)) {
      return [
        {
          meth: meth,
          val: val,
          resp: resp,
          params: params,
        },
      ];
    }
    return null;
  }

  /**
   * Determine topic type from topic's name: grp, p2p, me, fnd, sys.
   * @param {string} name - Name of the topic to test.
   * @returns {string} One of <code>"me"</code>, <code>"fnd"</code>, <code>"sys"</code>, <code>"grp"</code>,
   *    <code>"p2p"</code> or <code>undefined</code>.
   */
  static topicType(name) {
    return Topic.topicType(name);
  }

  /**
   * Check if the given topic name is a name of a 'me' topic.
   * @param {string} name - Name of the topic to test.
   * @returns {boolean} <code>true</code> if the name is a name of a 'me' topic, <code>false</code> otherwise.
   */
  static isMeTopicName(name) {
    return Topic.isMeTopicName(name);
  }
  /**
   * Check if the given topic name is a name of a group topic.
   * @param {string} name - Name of the topic to test.
   * @returns {boolean} <code>true</code> if the name is a name of a group topic, <code>false</code> otherwise.
   */
  static isGroupTopicName(name) {
    return Topic.isGroupTopicName(name);
  }
  /**
   * Check if the given topic name is a name of a p2p topic.
   * @param {string} name - Name of the topic to test.
   * @returns {boolean} <code>true</code> if the name is a name of a p2p topic, <code>false</code> otherwise.
   */
  static isP2PTopicName(name) {
    return Topic.isP2PTopicName(name);
  }
  /**
   * Check if the given topic name is a name of a communication topic, i.e. P2P or group.
   * @param {string} name - Name of the topic to test.
   * @returns {boolean} <code>true</code> if the name is a name of a p2p or group topic, <code>false</code> otherwise.
   */
  static isCommTopicName(name) {
    return Topic.isCommTopicName(name);
  }
  /**
   * Check if the topic name is a name of a new topic.
   * @param {string} name - topic name to check.
   * @returns {boolean} <code>true</code> if the name is a name of a new topic, <code>false</code> otherwise.
   */
  static isNewGroupTopicName(name) {
    return Topic.isNewGroupTopicName(name);
  }
  /**
   * Check if the topic name is a name of a channel.
   * @param {string} name - topic name to check.
   * @returns {boolean} <code>true</code> if the name is a name of a channel, <code>false</code> otherwise.
   */
  static isChannelTopicName(name) {
    return Topic.isChannelTopicName(name);
  }
  /**
   * Get information about the current version of this Tinode client library.
   * @returns {string} semantic version of the library, e.g. <code>"0.15.5-rc1"</code>.
   */
  static getVersion() {
    return Const.VERSION;
  }
  /**
   * To use Tinode in a non browser context, supply WebSocket and XMLHttpRequest providers.
   * @static
   *
   * @param wsProvider <code>WebSocket</code> provider, e.g. for nodeJS , <code>require('ws')</code>.
   * @param xhrProvider <code>XMLHttpRequest</code> provider, e.g. for node <code>require('xhr')</code>.
   */
  static setNetworkProviders(wsProvider, xhrProvider) {
    WebSocketProvider = wsProvider;
    XHRProvider = xhrProvider;

    Connection.setNetworkProviders(WebSocketProvider, XHRProvider);
    LargeFileHelper.setNetworkProvider(XHRProvider);
  }
  /**
   * To use Tinode in a non browser context, supply <code>indexedDB</code> provider.
   * @static
   *
   * @param idbProvider <code>indexedDB</code> provider, e.g. for nodeJS , <code>require('fake-indexeddb')</code>.
   */
  static setDatabaseProvider(idbProvider) {
    IndexedDBProvider = idbProvider;

    DBCache.setDatabaseProvider(IndexedDBProvider);
  }
  /**
   * Return information about the current name and version of this Tinode library.
   * @static
   *
   * @returns {string} the name of the library and it's version.
   */
  static getLibrary() {
    return Const.LIBRARY;
  }
  /**
   * Check if the given string represents <code>NULL</code> value as defined by Tinode (<code>'\u2421'</code>).
   * @param {string} str - string to check for <code>NULL</code> value.
   * @returns {boolean} <code>true</code> if string represents <code>NULL</code> value, <code>false</code> otherwise.
   */
  static isNullValue(str) {
    return str === Const.DEL_CHAR;
  }

  doLogout() {
    this.rejectPingInterval()

    const msg = this.#initPacket("logout");
    this.#send(msg);
  }

  // Instance methods.

  // Generates unique message IDs
  getNextUniqueId() {
    return this._messageId != 0 ? "" + this._messageId++ : undefined;
  }

  /**
   * Connect to the server.
   *
   * @param {string} host_ - name of the host to connect to.
   * @return {Promise} Promise resolved/rejected when the connection call completes:
   *    <code>resolve()</code> is called without parameters, <code>reject()</code> receives the
   *    <code>Error</code> as a single parameter.
   */
  connect(host_) {
    return this._connection.connect(host_);
  }

  /**
   * Attempt to reconnect to the server immediately.
   *
   * @param {string} force - if <code>true</code>, reconnect even if there is a connection already.
   */
  reconnect(force) {
    this._connection.reconnect(force);
  }

  /**
   * Disconnect from the server.
   */
  disconnect() {
    this._connection.disconnect();
  }

  /**
   * Clear persistent cache: remove IndexedDB.
   *
   * @return {Promise} Promise resolved/rejected when the operation is completed.
   */
  clearStorage() {
    if (this._db.isReady()) {
      profile.reset();
      LoggerServices.createLog({
        'app-code': APP_CODE_LOGGER,
        content: `REQUEST_CLEAR_DB|${profile.username}|Reasion:clearStorage called`
      });
      return this._db.deleteDatabase();
    }
    return Promise.resolve();
  }

  /**
   * Initialize persistent cache: create IndexedDB cache.
   *
   * @return {Promise} Promise resolved/rejected when the operation is completed.
   */
  initStorage() {
    if (!this._db.isReady()) {
      return this._db.initDatabase();
    }
    return Promise.resolve();
  }

  /**
   * Send a network probe message to make sure the connection is alive.
   */
  networkProbe() {
    this._connection.probe();
  }

  /**
   * Check for live connection to server.
   *
   * @returns {boolean} <code>true</code> if there is a live connection, <code>false</code> otherwise.
   */
  isConnected() {
    return this._connection.isConnected();
  }

  /**
   * Check if connection is authenticated (last login was successful).
   *
   * @returns {boolean} <code>true</code> if authenticated, <code>false</code> otherwise.
   */
  isAuthenticated() {
    return this._authenticated;
  }

  /**
   * Add API key and auth token to the relative URL making it usable for getting data
   * from the server in a simple <code>HTTP GET</code> request.
   *
   * @param {string} URL - URL to wrap.
   * @returns {string} URL with appended API key and token, if valid token is present.
   */
  authorizeURL(url) {
    if (typeof url != "string") {
      return url;
    }

    if (isUrlRelative(url)) {
      // Fake base to make the relative URL parseable.
      const base = "scheme://host/";
      const parsed = new URL(url, base);
      if (this._apiKey) {
        parsed.searchParams.append("apikey", this._apiKey);
      }
      if (this._authToken && this._authToken.token) {
        parsed.searchParams.append("auth", "token");
        parsed.searchParams.append("secret", this._authToken.token);
      }
      // Convert back to string and strip fake base URL except for the root slash.
      url = parsed.toString().substring(base.length - 1);
    }
    return url;
  }

  /**
   * @typedef AccountParams
   * @type {Object}
   * @property {DefAcs=} defacs - Default access parameters for user's <code>me</code> topic.
   * @property {Object=} public - Public application-defined data exposed on <code>me</code> topic.
   * @property {Object=} private - Private application-defined data accessible on <code>me</code> topic.
   * @property {Object=} trusted - Trusted user data which can be set by a root user only.
   * @property {Array.<string>} tags - array of string tags for user discovery.
   * @property {string} scheme - Temporary authentication scheme for password reset.
   * @property {string} secret - Temporary authentication secret for password reset.
   * @property {Array.<string>=} attachments - Array of references to out of band attachments used in account description.
   */
  /**
   * @typedef DefAcs
   * @type {Object}
   * @property {string=} auth - Access mode for <code>me</code> for authenticated users.
   * @property {string=} anon - Access mode for <code>me</code> for anonymous users.
   */

  /**
   * Create or update an account.
   *
   * @param {string} uid - User id to update
   * @param {string} scheme - Authentication scheme; <code>"basic"</code> and <code>"anonymous"</code> are the currently supported schemes.
   * @param {string} secret - Authentication secret, assumed to be already base64 encoded.
   * @param {boolean=} login - Use new account to authenticate current session
   * @param {AccountParams=} params - User data to pass to the server.
   *
   * @returns {Promise} Promise which will be resolved/rejected when server reply is received.
   */
  account(uid, scheme, secret, login, params) {
    const pkt = this.#initPacket("acc");
    pkt.acc.user = uid;
    pkt.acc.scheme = scheme;
    pkt.acc.secret = secret;
    // Log in to the new account using selected scheme
    pkt.acc.login = login;

    if (params) {
      pkt.acc.desc.defacs = params.defacs;
      pkt.acc.desc.public = params.public;
      pkt.acc.desc.private = params.private;
      pkt.acc.desc.trusted = params.trusted;

      pkt.acc.tags = params.tags;
      pkt.acc.cred = params.cred;

      pkt.acc.tmpscheme = params.scheme;
      pkt.acc.tmpsecret = params.secret;

      if (Array.isArray(params.attachments) && params.attachments.length > 0) {
        pkt.extra = {
          attachments: params.attachments.filter((ref) => isUrlRelative(ref)),
        };
      }
    }

    return this.#send(pkt, pkt.acc.id);
  }

  authenticate(options = {}) {
    options = {
      ...options,
      ...profile.authAPI,
      ...{ ssid: profile.sessionId },
    };
    this.#execPromise(MC_CONST.OPEN_STREAM_MSG_ID, 0)
    const pkt = this.#initPacket("auth", options);
    return this.#send(pkt, options.id);
  }

  /**
   * Create a new user. Wrapper for {@link Tinode#account}.
   *
   * @param {string} scheme - Authentication scheme; <code>"basic"</code> is the only currently supported scheme.
   * @param {string} secret - Authentication.
   * @param {boolean=} login - Use new account to authenticate current session
   * @param {AccountParams=} params - User data to pass to the server.
   *
   * @returns {Promise} Promise which will be resolved/rejected when server reply is received.
   */
  createAccount(scheme, secret, login, params) {
    let promise = this.account(Const.USER_NEW, scheme, secret, login, params);
    if (login) {
      promise = promise.then((ctrl) => this.#loginSuccessful(ctrl));
    }
    return promise;
  }

  /**
   * Create user with <code>'basic'</code> authentication scheme and immediately
   * use it for authentication. Wrapper for {@link Tinode#account}.
   *
   * @param {string} username - Login to use for the new account.
   * @param {string} password - User's password.
   * @param {AccountParams=} params - User data to pass to the server.
   *
   * @returns {Promise} Promise which will be resolved/rejected when server reply is received.
   */
  createAccountBasic(username, password, params) {
    // Make sure we are not using 'null' or 'undefined';
    username = username || "";
    password = password || "";
    return this.createAccount(
      "basic",
      b64EncodeUnicode(username + ":" + password),
      true,
      params
    );
  }

  /**
   * Update user's credentials for <code>'basic'</code> authentication scheme. Wrapper for {@link Tinode#account}.
   *
   * @param {string} uid - User ID to update.
   * @param {string} username - Login to use for the new account.
   * @param {string} password - User's password.
   * @param {AccountParams=} params - data to pass to the server.
   *
   * @returns {Promise} Promise which will be resolved/rejected when server reply is received.
   */
  updateAccountBasic(uid, username, password, params) {
    // Make sure we are not using 'null' or 'undefined';
    username = username || "";
    password = password || "";
    return this.account(
      uid,
      "basic",
      b64EncodeUnicode(username + ":" + password),
      false,
      params
    );
  }

  /**
   * Send handshake to the server.
   *
   * @returns {Promise} Promise which will be resolved/rejected when server reply is received.
   */
  openStream(id) {
    const pkt = this.#initPacket("openStream");
    return this.#send(pkt, id);
  }

  /**
   * Set or refresh the push notifications/device token. If the client is connected,
   * the deviceToken can be sent to the server.
   *
   * @param {string} dt - token obtained from the provider or <code>false</code>,
   *    <code>null</code> or <code>undefined</code> to clear the token.
   *
   * @returns <code>true</code> if attempt was made to send the update to the server.
   */
  setDeviceToken(dt) {
    let sent = false;
    // Convert any falsish value to null.
    dt = dt || null;
    if (dt != this._deviceToken) {
      this._deviceToken = dt;
      if (this.isConnected() && this.isAuthenticated()) {
        this.#send({
          hi: {
            dev: dt || Tinode.DEL_CHAR,
          },
        });
        sent = true;
      }
    }
    return sent;
  }

  /**
   * @typedef Credential
   * @type {Object}
   * @property {string} meth - validation method.
   * @property {string} val - value to validate (e.g. email or phone number).
   * @property {string} resp - validation response.
   * @property {Object} params - validation parameters.
   */
  /**
   * Authenticate current session.
   *
   * @param {string} scheme - Authentication scheme; <code>"basic"</code> is the only currently supported scheme.
   * @param {string} secret - Authentication secret, assumed to be already base64 encoded.
   * @param {Credential=} cred - credential confirmation, if required.
   *
   * @returns {Promise} Promise which will be resolved/rejected when server reply is received.
   */
  login(scheme, secret, cred) {
    const pkt = this.#initPacket("login");
    pkt.login.scheme = scheme;
    pkt.login.secret = secret;
    pkt.login.cred = cred;

    return this.#send(pkt, pkt.login.id).then((ctrl) =>
      this.#loginSuccessful(ctrl)
    );
  }

  /**
   * Wrapper for {@link Tinode#login} with basic authentication
   *
   * @param {string} uname - User name.
   * @param {string} password  - Password.
   * @param {Credential=} cred - credential confirmation, if required.
   *
   * @returns {Promise} Promise which will be resolved/rejected on receiving server reply.
   */
  loginBasic(uname, password, cred) {
    return this.login(
      "basic",
      b64EncodeUnicode(uname + ":" + password),
      cred
    ).then((ctrl) => {
      this._login = uname;
      return ctrl;
    });
  }

  /**
   * Wrapper for {@link Tinode#login} with token authentication
   *
   * @param {string} token - Token received in response to earlier login.
   * @param {Credential=} cred - credential confirmation, if required.
   *
   * @returns {Promise} Promise which will be resolved/rejected on receiving server reply.
   */
  loginToken(token, cred) {
    return this.login("token", token, cred);
  }

  /**
   * Send a request for resetting an authentication secret.
   *
   * @param {string} scheme - authentication scheme to reset.
   * @param {string} method - method to use for resetting the secret, such as "email" or "tel".
   * @param {string} value - value of the credential to use, a specific email address or a phone number.
   *
   * @returns {Promise} Promise which will be resolved/rejected on receiving the server reply.
   */
  requestResetAuthSecret(scheme, method, value) {
    return this.login(
      "reset",
      b64EncodeUnicode(scheme + ":" + method + ":" + value)
    );
  }

  /**
   * @typedef AuthToken
   * @type {Object}
   * @property {string} token - Token value.
   * @property {Date} expires - Token expiration time.
   */
  /**
   * Get stored authentication token.
   *
   * @returns {AuthToken} authentication token.
   */
  getAuthToken() {
    if (
      this._authToken &&
      this._authToken.expires &&
      this._authToken.expires.getTime() > Date.now()
    ) {
      return this._authToken;
    } else {
      this._authToken = null;
    }
    return null;
  }

  /**
   * Application may provide a saved authentication token.
   *
   * @param {AuthToken} token - authentication token.
   */
  setAuthToken(token) {
    this._authToken = token;
  }

  getUsername() {
    return this._username;
  }

  setUsername(username) {
    this._username = username;
  }

  getToken() {
    return this._token;
  }

  setToken(token) {
    this._token = token;
  }

  /**
   * @typedef SetParams
   * @type {Object}
   * @property {SetDesc=} desc - Topic initialization parameters when creating a new topic or a new subscription.
   * @property {SetSub=} sub - Subscription initialization parameters.
   * @property {Array.<string>=} attachments - URLs of out of band attachments used in parameters.
   */
  /**
   * @typedef SetDesc
   * @type {Object}
   * @property {DefAcs=} defacs - Default access mode.
   * @property {Object=} public - Free-form topic description, publically accessible.
   * @property {Object=} private - Free-form topic description accessible only to the owner.
   * @property {Object=} trusted - Trusted user data which can be set by a root user only.
   */
  /**
   * @typedef SetSub
   * @type {Object}
   * @property {string=} user - UID of the user affected by the request. Default (empty) - current user.
   * @property {string=} mode - User access mode, either requested or assigned dependent on context.
   */
  /**
   * Send a topic subscription request.
   *
   * @param {string} topic - Name of the topic to subscribe to.
   * @param {GetQuery=} getParams - Optional subscription metadata query
   * @param {SetParams=} setParams - Optional initialization parameters
   *
   * @returns {Promise} Promise which will be resolved/rejected on receiving server reply.
   */
  subscribe(topicName, getParams, setParams) {
    const topicType = Topic.topicType(topicName);

    let type;
    switch (topicType) {
      case Const.TOPIC_GRP:
        type = MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT;
        break;
      default:
        type = MC_CONST.NODE_TYPE_MESSAGE.CHAT;
        break;
    }

    const threadId = Topic.getThreadId(topicName);

    const data = {
      threadId,
      topicName,
    };

    const subscribeKey = `${type}_${MC_CONST.NODE_TYPE_PRESENSE.SUBSCRIBE}`;

    const pkt = this.#initPacket(subscribeKey, data);
    if (!topicName) {
      topicName = Const.TOPIC_NEW;
    }

    pkt.sub.get = getParams;

    if (setParams) {
      if (setParams.sub) {
        pkt.sub.set.sub = setParams.sub;
      }

      if (setParams.desc) {
        const desc = setParams.desc;
        if (Tinode.isNewGroupTopicName(topicName)) {
          // Full set.desc params are used for new topics only
          pkt.sub.set.desc = desc;
        } else if (Tinode.isP2PTopicName(topicName) && desc.defacs) {
          // Use optional default permissions only.
          pkt.sub.set.desc = {
            defacs: desc.defacs,
          };
        }
      }

      // See if external objects were used in topic description.
      if (
        Array.isArray(setParams.attachments) &&
        setParams.attachments.length > 0
      ) {
        pkt.extra = {
          attachments: setParams.attachments.filter((ref) =>
            isUrlRelative(ref)
          ),
        };
      }

      if (setParams.tags) {
        pkt.sub.set.tags = setParams.tags;
      }
    }

    switch (type) {
      case MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT: {
        this.#send(pkt.msg, pkt.sub.id).then((resultData) => {
          switch (resultData.errorCode) {
            case MC_CONST.IQ_RESULT_CODE.SUCCESS: {
              this.loadGroupMembers(topicName);
              break
            }
            case MC_CONST.IQ_RESULT_CODE.INVALID_MEMBER: {
              const topicInfo = this.getTopicByName(topicName)
              if (topicInfo && lodash.has(topicInfo, 'acs') && topicInfo.acs.isWriter()) {
                topicInfo.updateMode(null, '-W')
              }
              break
            }
          }
        });
      }
      case MC_CONST.NODE_TYPE_MESSAGE.CHAT:
      default:
        this.#send(pkt.msg, pkt.sub.id);
    }

    return new Promise((resolve, reject) => {
      const rs = {
        topic: topicName,
        code: 200,
        text: "ok",
      };
      resolve(rs);
    });
  }

  /**
   * Detach and optionally unsubscribe from the topic
   *
   * @param {string} topic - Topic to detach from.
   * @param {boolean} unsub - If <code>true</code>, detach and unsubscribe, otherwise just detach.
   *
   * @returns {Promise} Promise which will be resolved/rejected on receiving server reply.
   */
  leave(topic, unsub) {
    return new Promise((resolve, reject) => {
      resolve(null);
    });
  }

  /**
   * Create message draft without sending it to the server.
   *
   * @param {string} topic - Name of the topic to publish to.
   * @param {Object} content - Payload to publish.
   * @param {boolean=} noEcho - If <code>true</code>, tell the server not to echo the message to the original session.
   *
   * @returns {Topic} new message which can be sent to the server or otherwise used.
   */
  createMessage(topicName, content, noEcho) {
    const threadId = Topic.getThreadId(topicName);
    let topic = this.getTopicByName(topicName, {
      threadId,
      isCreateWhenNotExist: false,
    });

    const type = Topic.getMessageType(topicName);

    const id = MessagesUtil.messagePacketId(type);
    const timesend = new Date();

    const to = Topic.getMessageTo(topic.name);
    const tOpr = topic.tOpr || "04";
    const cstate = topic.cstate || 1;

    let tags = null
    let tagAll = false
    let subtype;

    let data = {}

    if (lodash.has(content, "tags")) {
      // Tin nhắn có chứa mention tags
      subtype = MC_CONST.NODE_SUBTYPE_MESSAGE.TEXT;
      data = Object.assign({}, data, content);
      tags = data.tags
      tagAll = data.tagAll
      if (tagAll) {
        tags = tags.filter(t => t.msisdn !== MC_CONST.TAG_ALL.MEMBER_ID)
      }
      if (content.content) {
        content = content.content
      }
    }

    if (typeof content == "string") {
      subtype = MC_CONST.NODE_SUBTYPE_MESSAGE.TEXT;
    } else {
      if (lodash.has(content, "replyMsg")) {
        // Tin nhắn trả lời
        subtype = MC_CONST.NODE_SUBTYPE_MESSAGE.TEXT;
      } else {
        subtype = content.subtype;
      }
    }

    const msg = {
      topic: topicName,
      ts: timesend,
      timesend,
      to,
      tOpr,
      cstate,
      id,
      from: `usr${profile.username}`,
      type,
      subtype,
      content,
      tags,
      tagAll,
      _status: Tinode.MESSAGE_STATUS_SENDING,
    };

    return {
      msg, // Tin nhắn để thêm vào db
      topic,
    };
  }

  createPackageMessage(pub) {
    try {
      const type = pub.type
      const subtype = pub.subtype

      let data = {
        id: pub.id,
        from: profile.changeDomain.from,
        to: pub.to,
        type,
        fOpr: profile.changeDomain.opr,
        tOpr: pub.tOpr,
        timesend: pub.timesend.toString(),
        cstate: pub.cstate,
      };

      if (pub.desktop) {
        data.cdesktop = pub.desktop
      }

      data.subtype = subtype;

      if (typeof pub.content == "string") {
        data.content = pub.content;
        data.body = pub.content;
        data.tags = pub.tags;
        data.tagAll = pub.tagAll;
      } else {
        if (lodash.has(pub.content, "replyMsg")) {
          // Tin nhắn trả lời
          data.content = pub.content.replyBody
        }
        data = Object.assign({}, data, pub.content);
        if (subtype === MC_CONST.NODE_SUBTYPE_MESSAGE.FILE) {
          data.mediaLink = pub?.content?.ent[0]?.data?.ref
          data.mediaId = StringUtils.randomString(30)
        } else if (subtype === MC_CONST.NODE_SUBTYPE_MESSAGE.IMAGE) {
          data.mediaLink = pub?.content?.ent[0]?.data?.ref
          data.mediaId = StringUtils.randomString(30)
          data.ratio = pub.content.ratio
        }
      }

      // Tin nhắn mã hóa E2E
      if (pub.crypt) {
        data.crypt = pub.crypt
        data.body = pub.body
        data.sbody = pub.sbody
      }

      const packetKey = `${pub.type}_${pub.subtype}`;

      const pkt = this.#initPacket(packetKey, data);
      return pkt

    } catch (err) {
      console.error(err);
    }
    return null
  }

  /**
   * Publish {data} message to topic.
   *
   * @param {string} topicName - Name of the topic to publish to.
   * @param {Object} content - Payload to publish.
   * @param {boolean=} noEcho - If <code>true</code>, tell the server not to echo the message to the original session.
   *
   * @returns {Promise} Promise which will be resolved/rejected on receiving server reply.
   */
  publish(topicName, content, noEcho) {
    return this.publishMessage(this.createMessage(topicName, content, noEcho));
  }

  /**
   * Publish message to topic. The message should be created by {@link Tinode#createMessage}.
   *
   * @param {Object} pub - Message to publish.
   * @param {Array.<string>=} attachments - array of URLs with attachments.
   *
   * @returns {Promise} Promise which will be resolved/rejected on receiving server reply.
   */
  async publishMessage(pub, attachments, topic) {
    // Make a shallow copy. Needed in order to clear locally-assigned temp values;
    pub = Object.assign({}, topic.public, pub);
    // pub.seq = undefined;
    // pub.from = undefined;
    // pub.ts = undefined;

    if (pub.type === MC_CONST.NODE_TYPE_MESSAGE.CHAT && pub.subtype === MC_CONST.NODE_SUBTYPE_MESSAGE.TEXT) {
      if (topic.isCrypt) {
        try {
          let isReply = false
          let content = pub.content
          if (typeof content !== 'string') {
            content = pub.content.replyBody
            isReply = true
          }
          const threadId = Topic.getThreadId(topic.name)
          const data = {
            preKey: topic?.public?.e2e_prekey,
            preKeyMe: profile?.preKeyInfo?.pubKey,
          }
          const newContent = await Signal.getInstance().encryptMessage(content, threadId, data)
          if (!newContent?.error) {
            this.logger("EncryptMessage|", pub.id, JSON.stringify(newContent))

            pub.crypt = newContent.preKeyMe
            pub.body = newContent.encryptText
            pub.sbody = newContent.encryptMeText
          }
        } catch (err) {
          console.error(err)
        }
      }
    }

    if (topic?.isOfficial === true) {
      pub.to = pub.to.replace('@reeng', '@offical.reeng')
    }

    const pkt = this.createPackageMessage(pub);

    this.updateMediaImageFile(pub)

    return this.#send(pkt, pub.id);
  }

  updateMediaImageFile(pub) {
    try {
      const topic = this.getTopicByName(pub.topic)

      if (typeof pub.content !== undefined && pub.subtype === MC_CONST.NODE_SUBTYPE_MESSAGE.IMAGE) {
        //add to file image store from sender
        const mediaLink = pub?.content?.ent[0]?.data?.ref
        if (mediaLink) {
          const imageObj = {
            messageId: pub.id,
            media_link: mediaLink,
          }

          if (topic?.shareImage && Array.isArray(topic.shareImage)) {
            topic.shareImage.unshift(imageObj)
          } else {
            topic.shareImage = [imageObj]
          }

          //update database
          topic.udpTopicInfo(topic);
        }
      }

      if (typeof pub.content !== undefined && pub.subtype === MC_CONST.NODE_SUBTYPE_MESSAGE.FILE) {
        //add to file store from sender
        const mediaLink = pub?.content?.ent[0]?.data?.ref
        const fileName = pub?.content?.ent[0]?.data?.name
        if (mediaLink && fileName) {
          let timesend = new Date().getTime();
          if (pub.ts) {
            timesend = new Date(pub.ts).getTime();
          }
          const size = pub?.content?.ent[0]?.data?.size || 0
          const fileInfo = {
            messageId: pub.id,
            media_link: mediaLink,
            size,
            name: fileName,
            timesend
          }
          if (topic?.shareFile && Array.isArray(topic.shareFile)) {
            topic.shareFile.unshift(fileInfo)
          } else {
            topic.shareFile = [fileInfo]
          }

          //update database
          topic.udpTopicInfo(topic);
        }
      }
    } catch (e) {
      console.error(e);
    }

  }

  /**
   * Hàm gửi bản tin available lên server, sau khi server nhận được bản tin sẽ bắn tuần tự các tin nhắn offline về máy
   */
  requestOfflineMessage(hard = false) {
    this.logger('requestOfflineMessage|hard|', hard, '|this.cached_loaded|', this.cached_loaded)
    if (hard || this.cached_loaded) {
      const pkt = this.#initPacket(MC_CONST.NODE_TYPE_PRESENSE.AVAILABLE);
      return this.#send(pkt);
    }
  }

  /**
   * Hàm gửi tin nhắn presence background khi ẩn trình duyệt
   */
  sendBackgroundMessage() {
    this.backgroundApp = true
    const data = {
      subtype: MC_CONST.PACKAGE_TYPE.BACKGROUND
    }
    const msg = this.#initPacket(MC_CONST.PACKAGE_TYPE.BACKGROUND, data)
    return this.#send(msg);
  }

  /**
   * Hàm gửi tin nhắn presence foreground khi ẩn trình duyệt
   */
  sendForeGroundMessage() {
    this.backgroundApp = false
    const data = {
      subtype: MC_CONST.PACKAGE_TYPE.FOREGROUND
    }
    const msg = this.#initPacket(MC_CONST.PACKAGE_TYPE.FOREGROUND, data)
    return this.#send(msg);
  }

  sendSecretChatMessage(topic, secretStatus, id) {
    const threadId = Topic.getThreadId(topic.name)
    const data = {
      id,
      to: `${threadId}@reeng/reeng`,
      fOpr: profile?.changeDomain?.opr || '',
      tOpr: topic?.public?.currOperator || '',
      secretStatus
    }
    const msg = this.#initPacket(MC_CONST.PACKAGE_TYPE.ENABLE_E2E, data)
    return this.#send(msg, id);
  }

  getKeyE2EInfo() {
    if (Helpers.isNullOrEmptyObject(profile.preKeyInfo)) {
      const msg = this.#initPacket(MC_CONST.PACKAGE_TYPE.CLIENT_STATE, {})
      return this.#send(msg);
    } else {
      if (!profile?.preKeyInfo?.isDecrypted) {
        this.decryptPrivateE2EKey(profile.preKeyInfo)
      } else {
        this.logger('GET_KEY_E2E|Key is exist => do not process',)
      }
    }
    this.loadSignalProtocol()
  }

  loadSignalProtocol() {

  }

  getPreKeyFromMsisdn

  /**
   * @param {String} threadId: id cuộc trò chuyện
   * @param {Object} args: Các tham số đi kèm
   * @param {Array} args.listId : Danh sách id các tin nhắn cần gửi bản tin delivered seen lên server
   * @param {int} args.status : Trạng thái tin nhắn. Có các giá trị tương ứng sau
   *    - status = MC_CONST.MESSAGE_DELIVERED.RECEIVED_FROM_MOBILE: Tin nhắn gửi từ chính mình, gửi bản tin delivered nhưng không kèm thông tin seen
   *    - status = MC_CONST.MESSAGE_DELIVERED.RECEIVED: Đã nhận bản tin
   *    - status = MC_CONST.MESSAGE_DELIVERED.SEEN_1_MESSAGE: Đã xem 1 tin nhắn (listId chỉ có duy nhất 1 tin)
   *    - status = MC_CONST.MESSAGE_DELIVERED.SEEN_MULTI_MESSAGES: Đã xem cùng lúc nhiều tin nhắn (listId có nhiều tin)
   *
   * @returns {Promise} hành động gửi bản tin xmpp tương ứng
   */
  sendDeliveredSeen(threadId, args) {
    const { type, listId, status, member } = args;
    let messagesArray = [];
    const topicId = MessagesUtil.getTopicId(type, threadId);
    const topic = this.getTopicByName(topicId, {
      threadId,
      isCreateWhenNotExist: false,
    });
    if (topic) {
      messagesArray = listId.map(msgId => {
        const msg = topic.findMessageById(msgId);
        if (msg && msg?.from && Tinode.isP2PTopicName(msg?.from)) {
          const newMember = Topic.getThreadId(msg.from)
          return {
            msgId,
            member: newMember
          }
        } else {
          return {
            msgId,
            member: member
          }
        }
      })
    }
    const groupByMember = messagesArray.reduce((result, message) => {
      const { msgId, member } = message
      if (!result[member]) {
        result[member] = []
      }
      result[member].push(msgId);
      return result;
    }, {})
    const listDeliveredSeen = []

    for (const key in groupByMember) {
      const data = {
        threadId,
        type,
        member: key,
        listId: groupByMember[key],
        status,
      };
      const pkt = this.#initPacket(MC_CONST.PACKAGE_TYPE.DELIVERED_SEEN, data);
      listDeliveredSeen.push(this.#send(pkt));
    }

    return Promise.all(listDeliveredSeen)
    // const data = {
    //   threadId,
    //   type,
    //   member,
    //   listId,
    //   status,
    // };
    // const pkt = this.#initPacket(MC_CONST.PACKAGE_TYPE.DELIVERED_SEEN, data);
    // return this.#send(pkt);
  }

  sendMotions(msg, motionId, type) {
    const topic = this.getTopicByName(msg.topic);
    const msgXmpp = topic.getMessageXmpp();
    const pkt = msgXmpp.createMessageReact(msg, motionId, type);
    this._db
      .updMessageMotion(msg, motionId, profile.username, type)
      .then((msg) => this.onUpdateMotion(msg)).catch((err) => {
        console.error("MessageReact", err);
      });

    return this.#send(pkt);
  }

  onUpdateMotion(message) {
    const { topic: topicId, id: msgId, myMotion, motions } = message;
    const topic = this.getTopicByName(topicId);
    const msg = topic.findMessageById(msgId);
    msg.myMotion = myMotion;
    msg.motions = motions;
    if (topic.onData) {
      topic.onData(msg);
    }
  }

  sendMakeAdmin(topicId, member, role) {
    const topic = this.getTopicByName(topicId);
    const msgXmpp = topic.getMessageXmpp();
    const pkt = msgXmpp.createIqMakeAdmin(topicId, member, role);
    return this.#send(pkt);
  }

  sendKickMember(topicId, member, role) {
    const topic = this.getTopicByName(topicId);
    const msgXmpp = topic.getMessageXmpp();
    const pkt = msgXmpp.createIqKick(topicId, member, role);
    return this.#send(pkt);
  }

  changeBackground(topicId, brgId) {
    const topic = this.getTopicByName(topicId);
    topic.brgId = brgId;
    this._db.updTopic(topic);
    if (topic.onData) {
      topic.onData(topic);
    }
  }

  sendDeliveredSeenNoRoute(threadId, args) {
    const { listId } = args;
    const data = {
      threadId,
      listId,
    };
    const pkt = this.#initPacket(
      MC_CONST.PACKAGE_TYPE.DELIVERED_SEEN_NO_ROUTE,
      data
    );
    return this.#send(pkt);
  }

  /**
   *
   * @param {String} threadId : id cuộc trò chuyện
   * @param {Object} args : Các tham số đi kèm
   * @param {Array} args.listMessages: danh sách các tin nhắn
   * @param {status} Trạng thái tin nhắn. Có các giá trị tương ứng sau:
   *    - status = MC_CONST.MESSAGE_DELIVERED.RECEIVED: Đã nhận bản tin
   *    - status = MC_CONST.MESSAGE_DELIVERED.SEEN_1_MESSAGE: Đã xem 1 tin nhắn (listId chỉ có duy nhất 1 tin)
   *    - status = MC_CONST.MESSAGE_DELIVERED.SEEN_MULTI_MESSAGES: Đã xem cùng lúc nhiều tin nhắn (listId có nhiều tin)
   */
  sendDeliveredMessage(threadId, args) {
    const { status, listMessages, type, noRoute } = args;
    const listIdIndividual = [];
    const listId = [];

    listMessages.forEach((message) => {
      const id = message.attrs.id;
      const isMe = MessagesUtil.isMe(message);
      if (isMe) {
        listIdIndividual.push(id);
      } else {
        listId.push(id);
      }
    });

    let member = null
    if (type === MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT) {
      member = profile.username
    }

    if (noRoute) {
      this.sendDeliveredSeenNoRoute(threadId, {
        status: MC_CONST.MESSAGE_DELIVERED.RECEIVED_FROM_MOBILE,
        type,
        listId: listIdIndividual.concat(listId),
      });
    } else {
      // Gửi tin delivered seen cho các tin nhận từ mobile của chính mình
      if (listIdIndividual.length > 0) {
        this.sendDeliveredSeen(threadId, {
          status: MC_CONST.MESSAGE_DELIVERED.RECEIVED_FROM_MOBILE,
          type,
          member,
          listId: listIdIndividual,
        });
      }

      // Gửi tin delivered seen cho các tin nhắn của người khác
      if (listId.length > 0) {
        this.sendDeliveredSeen(threadId, {
          status,
          type,
          member,
          listId: listId,
        });
      }
    }
  }

  sendPin(msg, action) {
    const topic = this.getTopicByName(msg.topic);
    const msgXmpp = this.getMessageXmpp(msg.topic);
    const pkt = msgXmpp.createMessagePin(msg, action);
    const id = MessagesUtil.xmppid();
    if (action === MC_CONST.MESSAGE_ACTION_PIN.PIN) {
      topic.pinMessage = msg;
      this.addMessageNotify(topic.name, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
        body: this.formatMessage(messages.pin_message_notify, {
          member: this.formatMessage(messages.you)
        }),
        timesend: new Date().getTime(),
        id,
      })
    } else {
      topic.pinMessage = {};
      this.addMessageNotify(topic.name, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
        body: this.formatMessage(messages.unpin_message_notify, {
          member: this.formatMessage(messages.you)
        }),
        timesend: new Date().getTime(),
        id,
      })
    }
    topic._processMetaSubs();
    this._db.updTopic(topic)
    return this.#send(pkt);
  }

  updateMsgSendingToFail() {
    this.mapTopics((cont) => {

      const msgs = cont.findSendingMessage()
      if (Array.isArray(msgs)) {
        const topic = cont.name
        msgs.forEach(msg => {
          try {
            this.updateFailedMessage(cont, topic, msg)
          } catch (e) {
            console.error(e)
          }

        })
      }
    })
  }

  createPingInterval = () => {
    if (this.pingInterval) {
      clearInterval(this.pingInterval);
    }
    this.pingInterval = setInterval(async () => {
      const isDBExits = await this._db.checkDBExists();
      // kiểm tra xem có database không, nếu không có tiến hành tạo lại database, cập nhật trạng thái restoreStatus, gọi yêu cầu backup tin nhắn
      if (!isDBExits && this._persist) {
        Helpers.showWarningToasts(this.formatMessage(messages.db_not_exists));
        await this.#makeDBPersist();
        profile.restoreStatus = undefined;
        this.backupMsg(this);
      }
      const msg = this.#initPacket("ping");
      this.#send(msg);
    }, MC_CONST.PING_INTERVAL_SECONDS);
  };

  rejectPingInterval = () => {
    if (this.pingInterval) {
      clearInterval(this.pingInterval);
    }
  };

  isExistMessageId = async (id) => {
    try {
      const msgIndex = await this._db.getMessageIndex(id)
      return !!msgIndex
    } catch (err) {
      console.error(err);
      return false
    }
  }

  onIqMessage(message) {
    const { attrs, children } = message;
    if (lodash.has(attrs, "type")) {
      switch (attrs.type) {
        case MC_CONST.NODE_TYPE_PRESENSE.AVAIABLE: {
          this.requestOfflineMessage()
          break;
        }
        case MC_CONST.NODE_TYPE_IQ.ERROR: {
          const error = children.find(item => item.name === 'error')
          const errorCode = Number(error.attrs.code) || MC_CONST.IQ_RESULT_CODE.ERROR
          switch (errorCode) {
            case MC_CONST.IQ_RESULT_CODE.ERROR: {
              const resultData = {
                errorCode,
              }
              this.#execPromise(attrs.id, 200, resultData)
              break
            }
            case MC_CONST.IQ_RESULT_CODE.INVALID_MEMBER: {
              const resultData = {
                errorCode,
              }
              this.#execPromise(attrs.id, 200, resultData)
              const groupId = MessagesUtil.getMsisdnFrom(attrs.from)
              const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, groupId)
              const topic = this.getTopicByName(topicId)

              if (topic && topic?.acs && topic?.acs.isWriter()) {
                topic.updateMode(null, '-W')
              }

              break
            }
            case MC_CONST.IQ_RESULT_CODE.NOT_AUTHEN: {
              if (this.onLogout) {
                this.onLogout();
                this.#cacheDelAll()
              }
              break
            }
          }
          break
        }
        case MC_CONST.NODE_TYPE_IQ.RESULT: {
          if (attrs.authentype === "token") {
            this._authenticated = true;
            this.onConnect();
            const authInfo = children.find((item) => item.name === "auth_info");
            const authenKey = {
              publicKey: authInfo.public_key,
              apisec: authInfo.apisec,
            };
            profile.authenKey = authenKey;
            profile.save();
            this._myUID = `usr${profile.username}`;
            this.createMeTopic();

            this.#execPromise(attrs.id, 200, {})

            if (this.onLoginSuccessfully) {
              this.onLoginSuccessfully();
            }

            this.requestOfflineMessage()
          } else {
            const query = children.find((item) => item.name === "query");
            if (query) {
              const xmlns =
                query.attrs && query.attrs.xmlns ? query.attrs.xmlns : null;
              switch (xmlns) {
                case MC_CONST.NS.PING: {
                  break;
                }
                // Thông tin group
                // <iq from='0396783058_1700789931004@muc.reeng' to='0396783058@reeng/desktop' type='result' id='fujjqyi5ll'>
                // 	<query
                //   xmlns='config'>
                //   <room name='nhóm 23' jid='0396783058_1700789931004'/>
                //   <member jid='0327983782' name='hà' role='member' notification='1' lavatar='0'/>
                //   <member jid='0397585436' name='Test 1' role='member' notification='1' lavatar='0'/>
                //   <member jid='0396783058' name='thanhbh3' role='owner' notification='1' lavatar='1659944073554'/>
                //   <avatar_created></avatar_created>
                //   <gtype>0</gtype>
                //   <keep_private value='0'/>
                //   <notification>1</notification>
                //   <dhvtt>0</dhvtt>
                //   <chatbot>0</chatbot>
                //   <setting_group_permission></setting_group_permission>
                // </query>
                // </iq>
                case MC_CONST.NS.CONFIG: {
                  const roomInfo = query.children.find(item => item.name === 'room')
                  const avatarCreatedInfo = query.children.find(item => item.name === 'avatar_created')
                  const keepPrivateInfo = query.children.find(item => item.name === 'keep_private')
                  const listMembersInfo = query.children.filter(item => item.name === 'member')

                  const groupId = roomInfo.attrs.jid
                  const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, groupId)
                  const groupName = roomInfo.attrs.name
                  const groupSecurity = keepPrivateInfo.attrs.value
                  const sub = []

                  listMembersInfo.forEach((member) => {
                    const jid = member.attrs.jid
                    const role = member.attrs.role;
                    const mem = this.makeGroupMember(jid, role, member.attrs)
                    sub.push(mem)
                  })
                  const avatarCreated = avatarCreatedInfo.children && avatarCreatedInfo.children.length > 0 ? avatarCreatedInfo.children : null
                  let groupAvatar = null
                  if (avatarCreated) {
                    groupAvatar = Helpers.getAvatarGroupURL(groupId, avatarCreated)
                  }

                  const topic = this.getTopicByName(topicId, {
                    isCreateWhenNotExist: true,
                  })

                  const pub = {
                    fn: groupName,
                    security: groupSecurity
                  }

                  if (groupAvatar) {
                    pub.photo = {
                      ref: groupAvatar,
                      type: 'png'
                    }
                  }

                  topic.public = pub
                  topic.last_update = Date.now()
                  topic.sub = sub

                  const desc = {
                    public: pub,
                  }

                  topic._processMetaDesc(desc)
                  this.loadGroupMembers(topicId)

                  const resultData = {
                    errorCode: MC_CONST.IQ_RESULT_CODE.SUCCESS,
                  }
                  this.#execPromise(attrs.id, 200, resultData)

                  break;
                }
                // Tạo nhóm từ MOCHA WEB
                // <iq from='0396783058_1701076137192@muc.reeng' to='0396783058@reeng/desktop' type='result' id='2io0myos8a'>
                // 	<query
                //   xmlns='create'>
                //   <room name='g123' jid='0396783058_1701076137192'/>
                //   <member jid='+8562091000172' code='200' name='' role='member' lavatar='0'/>
                //   <member jid='+8562091000030' code='200' name='' role='member' lavatar='0'/>
                //   <member jid='0396783058' code='200' name='thanhbh3' role='owner' lavatar='1659944073554'/>
                // </query>
                // </iq>
                case MC_CONST.NS.CREATE: {
                  const groupId = MessagesUtil.getMsisdnFrom(attrs.from)
                  const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, groupId)

                  const roomInfo = query.children.find(info => info.name === 'room')
                  const groupName = roomInfo ? roomInfo.attrs.name : ''
                  const sub = children[0].children
                    .filter(info => info.name === 'member')
                    .map((info) => {
                      const jid = info.attrs.jid
                      const role = info.attrs.role
                      const mem = this.makeGroupMember(jid, role, info.attrs)
                      return mem
                    })

                  const topic = this.getTopicByName(topicId, {
                    isCreateWhenNotExist: true,
                  })

                  const pub = {
                    fn: groupName,
                  }

                  topic.public = pub
                  topic.last_update = Date.now()
                  topic.sub = sub

                  const desc = {
                    public: pub,
                  }

                  topic._processMetaDesc(desc)

                  this.loadGroupMembers(topicId)

                  const resultData = {
                    errorCode: MC_CONST.IQ_RESULT_CODE.SUCCESS,
                    topicId
                  }
                  this.#execPromise(attrs.id, 200, resultData)

                  break;
                }

                case MC_CONST.NS.INVITE: {
                  const groupId = MessagesUtil.getMsisdnFrom(attrs.from)
                  const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, groupId)

                  const topic = this.getTopicByName(topicId, {
                    isCreateWhenNotExist: true,
                  })


                  let sub = topic && topic.sub || []
                  const invited = children[0].children
                    .filter(info => info.name === 'member')
                    .map((info) => {
                      const jid = info.attrs.jid
                      const role = info.attrs.role
                      const mem = this.makeGroupMember(jid, role, info.attrs)
                      return mem
                    })

                  sub = sub.concat(invited)
                  topic.sub = sub

                  topic._processMetaDesc({})

                  this.loadGroupMembers(topicId)

                  const resultData = {
                    errorCode: MC_CONST.IQ_RESULT_CODE.SUCCESS,
                    invited
                  }
                  this.#execPromise(attrs.id, 200, resultData)
                  break;
                }
                // <iq from='0396783058_1701074044815@muc.reeng' to='0396783058@reeng/desktop' type='result' id='indh6c3h2rl'><query xmlns='leave'/></iq>
                case MC_CONST.NS.LEAVE: {
                  const groupId = MessagesUtil.getMsisdnFrom(attrs.from)
                  const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, groupId)

                  const topic = this.getTopicByName(topicId, {
                    isCreateWhenNotExist: true,
                  })


                  let sub = topic && topic.sub || []
                  sub = sub.filter(s => s.jid !== profile.username)
                  topic.sub = sub

                  topic._processMetaDesc({})

                  this.loadGroupMembers(topicId)

                  const resultData = {
                    errorCode: MC_CONST.IQ_RESULT_CODE.SUCCESS,
                  }
                  this.#execPromise(attrs.id, 200, resultData)

                  break;
                }
                case MC_CONST.NS.GROUP_PRIVATE: {
                  // <iq from='0856715196_1705313431794@muc.reeng' to='0856715196@reeng/desktop' type='result' id='nev1w25wzi'><query xmlns='groupPrivate'><keep_private value='1'/></query></iq>
                  const groupId = MessagesUtil.getMsisdnFrom(attrs.from)
                  const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, groupId)

                  const topic = this.getTopicByName(topicId, {
                    isCreateWhenNotExist: true,
                  })

                  const keepPrivateInfo = query.children.find(item => item.name === 'keep_private')
                  const groupSecurity = keepPrivateInfo.attrs.value

                  let pub = topic && topic.public || {}
                  pub.security = groupSecurity
                  topic.public = pub

                  topic._processMetaDesc({})

                  const resultData = {
                    errorCode: MC_CONST.IQ_RESULT_CODE.SUCCESS,
                    groupPrivate: groupSecurity,
                  }
                  this.#execPromise(attrs.id, 200, resultData)

                  break;
                }
                case MC_CONST.NS.DISSOLVE: {
                  const groupId = MessagesUtil.getMsisdnFrom(attrs.from)
                  const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, groupId)
                  const topic = this.getTopicByName(topicId)
                  if (topic) {
                    topic.dissolveTopic()
                    this.sendFakeDissolveOA(topic, Const.TOPIC_ME)
                  }
                  const resultData = {
                    errorCode: MC_CONST.IQ_RESULT_CODE.SUCCESS,
                  }
                  this.#execPromise(attrs.id, 200, resultData)
                  break;
                }

                case MC_CONST.NS.RENAME: {
                  const groupId = MessagesUtil.getMsisdnFrom(attrs.from)
                  const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, groupId)

                  const topic = this.getTopicByName(topicId, {
                    isCreateWhenNotExist: true,
                  })

                  const roomInfo = query.children.find(item => item.name === 'room')
                  const groupName = roomInfo.attrs.name

                  topic.public.fn = groupName
                  topic.last_update = Date.now()
                  const pub = {
                    fn: groupName,
                  }
                  const desc = {
                    public: pub,
                  }

                  topic._processMetaDesc(desc)
                  const resultData = {
                    errorCode: MC_CONST.IQ_RESULT_CODE.SUCCESS,
                    topicId,
                    groupName,
                  }
                  this.#execPromise(attrs.id, 200, resultData)

                  break;
                }

                case MC_CONST.NS.MAKE_ADMIN: {
                  const groupId = MessagesUtil.getMsisdnFrom(attrs.from)
                  const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, groupId);
                  const members = query.children.filter(item => item.name === 'member');
                  this.onMakeRole(topicId, members, profile.username);
                  break;
                }

                case MC_CONST.NS.KICK: {
                  const groupId = MessagesUtil.getMsisdnFrom(attrs.from)
                  const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, groupId);
                  const members = query.children.filter(item => item.name === 'member');
                  this.onKickMember(topicId, members);
                  break;
                }
              }
            }
          }

          break;
        }
        case MC_CONST.NODE_TYPE_IQ.ERROR: {
          if (lodash.has(attrs, "authentype") && attrs.authentype === "token") {
            window.logger("Authen token fail");
          }
          break;
        }
        default: {
          window.logger("receive iq message: ", message);
          break;
        }
      }
    }
  }

  onPresenceMessage(message) {
    const { attrs, children } = message;
    if (lodash.has(attrs, "subtype")) {
      switch (attrs.subtype) {
        case MC_CONST.NODE_SUBTYPE_PRESENCE.CHANGE_DOMAIN: {
          // Lấy bản tin offline từ server
          profile.changeDomain = attrs;
          profile.save();

          // Tạo interval gửi bản tin ping/pong XMPP
          this.createPingInterval();

          break;
        }
        case MC_CONST.NODE_SUBTYPE_PRESENCE.BACKGROUND:
        case MC_CONST.NODE_SUBTYPE_PRESENCE.FOREGROUND: {
          const threadId = MessagesUtil.getFrom(
            MC_CONST.NODE_TYPE_MESSAGE.CHAT,
            message
          );
          const topicId = MessagesUtil.getTopicId(
            MC_CONST.NODE_TYPE_MESSAGE.CHAT,
            threadId
          );

          const data = this.getDataFromStanza(message);

          const topic = this.getTopicByName(topicId, {
            threadId,
            isCreateWhenNotExist: true,
          });

          topic._attached = true;
          topic._deleted = false;
          topic.updated = new Date();

          if (attrs.subtype === MC_CONST.NODE_SUBTYPE_PRESENCE.FOREGROUND) {
            topic.online = true;
            topic.seen = {
              when: new Date(),
            };
          } else {
            topic.online = false;
            topic.seen = {
              when: new Date(parseInt(data.timestamp)),
            };
          }

          topic._cachePutSelf();

          const me = this.getMeTopic();
          if (me.onMetaSub) {
            me.onMetaSub(topic);
          }
          if (me.onSubsUpdated) {
            me.onSubsUpdated([topicId], 1);
          }

          this.#execPromise(attrs.id, 200, {
            text: 'ok',
          })

          break;
        }
        case MC_CONST.NODE_SUBTYPE_PRESENCE.CHANGE_OPERATOR:
        default: {
          this.#execPromise(attrs.id, 200, {
            text: 'ok',
          })
          break
        }
      }
    } else {
    }
  }

  onMessageMessage(message) {
    const { attrs } = message;
    if (lodash.has(attrs, "type")) {
      switch (attrs.type) {
        case MC_CONST.NODE_TYPE_MESSAGE.CHAT:
          this.onMessageChat(message);
          break;
        case MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT:
          this.onMessageGroupChat(message);
          break;
        case MC_CONST.NODE_TYPE_MESSAGE.EVENT:
          this.onMessageEvent(message);
          break;
        case MC_CONST.NODE_TYPE_MESSAGE.OFFICIAL:
          this.onMessageOfficial(message)
          break
        default:
          break;
      }
    } else {
      this.onMessageOther(message);
    }
  }

  async onMessageChat(message) {
    const { attrs, children } = message;
    const { type, subtype } = attrs;

    const threadId = MessagesUtil.getThreadId(
      MC_CONST.NODE_TYPE_MESSAGE.CHAT,
      message
    );
    const topicId = MessagesUtil.getTopicId(
      MC_CONST.NODE_TYPE_MESSAGE.CHAT,
      threadId
    );

    // Biến quyết định xem bản tin gửi đi có được route sang cho các thành viên khác trong cuộc trò chuyện hay không
    let noRoute = false;

    // Nếu đã tồn tại tin nhắn => không xử lý
    const isExistMessage = await this.isExistMessageId(attrs.id)
    if (isExistMessage) {
      this.logger('Message existed => do not process', attrs.id)
    } else {
      const topic = this.getTopicByName(topicId)
      if (topic && topic.isBlockUser && subtype !== MC_CONST.NODE_SUBTYPE_MESSAGE.DELETE) {
        this.logger('=================Topic is blocked', topicId)
      } else {
        switch (subtype) {
          case MC_CONST.NODE_SUBTYPE_MESSAGE.EVENT:
            noRoute = true
          case MC_CONST.NODE_SUBTYPE_MESSAGE.TEXT:
          case MC_CONST.NODE_SUBTYPE_MESSAGE.IMAGE:
          case MC_CONST.NODE_SUBTYPE_MESSAGE.VIDEO:
          case MC_CONST.NODE_SUBTYPE_MESSAGE.FILE:
          case MC_CONST.NODE_SUBTYPE_MESSAGE.VOICE_STICKER:
          case MC_CONST.NODE_SUBTYPE_MESSAGE.CONTACT:
          case MC_CONST.NODE_SUBTYPE_MESSAGE.LOCATION:
          case MC_CONST.NODE_SUBTYPE_MESSAGE.AUDIO: {
            this.onMessageBase(topicId, type, subtype, message)
            break
          }
          case MC_CONST.NODE_SUBTYPE_MESSAGE.DELETE: {
            const msgId = children.find((item) => item.name === "id").children[0];

            this._db.getMessageIndex(msgId).then((msgIndex) => {
              if (msgIndex) {
                const topicId = msgIndex.topic;
                const id = msgIndex.id;
                const seq = msgIndex.seq;
                const topic = this.getTopic(topicId);
                let msg = topic.findMessageById(id);
                topic.recallMessage(seq, msg, false);
              }
            });

            break;
          }
          case MC_CONST.NODE_SUBTYPE_MESSAGE.TYPING: {
            const topic = this.getTopicByName(topicId);
            const fromMe = getNodeFromJid(attrs.from) === user.username;
            if (!fromMe) {
              topic._routeInfo({ what: 'kp' });
            }
            break;
          }
          case MC_CONST.NODE_SUBTYPE_MESSAGE.CLIENT_STATE: {
            const keyChainInfo = children.find(item => item.name === 'keychain')

            if (keyChainInfo) {
              const keyInfo = { ...keyChainInfo.attrs }
              const preKeyInfo = profile.preKeyInfo
              if (preKeyInfo && preKeyInfo.timestamp) {
                if (keyInfo.timestamp && keyInfo.timestamp > preKeyInfo.timestamp) {
                  keyInfo.isDecrypted = false
                  profile.preKeyInfo = keyInfo
                  this.logger(`SYNC_E2E_KEY|save|${JSON.stringify(keyInfo)}`)
                  this.decryptPrivateE2EKey(keyInfo)
                }
              } else {
                profile.preKeyInfo = keyInfo
                this.logger(`SYNC_E2E_KEY|save|${JSON.stringify(keyInfo)}`)
                this.decryptPrivateE2EKey(keyInfo)
              }
            }

            break
          }
          case MC_CONST.NODE_SUBTYPE_MESSAGE.ENABLE_E2E: {
            /*
              <message from="0396783058@reeng/reeng" to="0396783058@reeng/desktop" desk_revision="10084" revision="15270" id="0101000_9F215A9D2F4C400F90CCC26E7819231C" type="chat" subtype="enable_e2e" f_opr="04" t_opr="02" f_ip="113.185.40.253" timesend="1606987538484" src="reeng" timereceive="1606987538485">
                <cstate>1</cstate>
                <cdesktop>1</cdesktop>
                <stateEnableE2E>0</stateEnableE2E>
                <threadRef toref="0814834755@reeng/reeng" />
              </message>
            */
            const stateEnableE2E = children.find(item => item.name === 'stateEnableE2E')
            let secretStatus = null
            if (stateEnableE2E) {
              secretStatus = String(children.find(item => item.name === 'stateEnableE2E').children[0])
            }

            if (!!secretStatus) {
              const topic = this.getTopicByName(topicId);
              const fromMe = getNodeFromJid(attrs.from) === user.username;
              const fromName = fromMe ? this.formatMessage(messages.you) : Topic.getTopicName(topic)
              const toName = fromMe ? Topic.getTopicName(topic) : this.formatMessage(messages.you)
              const data = {
                topicId,
                fromName,
                toName,
                timesend: attrs.timesend,
                id: attrs.id,
              }
              this.setSecretChat(topic, secretStatus, data)
            }

            break
          }

          default: {
            break;
          }
        }
      }
    }

    // Gửi bản tin delivered seen
    const fromMe = getNodeFromJid(attrs.from) === user.username;
    let status = MC_CONST.MESSAGE_DELIVERED.RECEIVED;
    if (!fromMe && topicId === this.topicSelected && this.backgroundApp === false) {
      status = MC_CONST.MESSAGE_DELIVERED.SEEN_MULTI_MESSAGES;
    }
    this.sendDeliveredMessage(threadId, {
      status,
      noRoute,
      type,
      listMessages: [message],
    });
  }

  async onMessageGroupChat(message) {
    const { attrs, children } = message;
    const { type, subtype, timesend } = attrs;

    const threadId = MessagesUtil.getThreadId(
      MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT,
      message
    );
    const topicId = MessagesUtil.getTopicId(
      MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT,
      threadId
    );

    // Biến quyết định xem bản tin gửi đi có được route sang cho các thành viên khác trong cuộc trò chuyện hay không
    let noRoute = false;

    // Nếu đã tồn tại tin nhắn => không xử lý
    const isExistMessage = await this.isExistMessageId(attrs.id)
    if (isExistMessage) {
      this.logger('Message existed => do not process', attrs.id)
    } else {
      const groupName = attrs.room ? attrs.room : 'Group'
      const groupData = {
        isGroup: true,
        groupName: groupName,
      }

      switch (subtype) {
        case MC_CONST.NODE_SUBTYPE_MESSAGE.EVENT:
          noRoute = true
        case MC_CONST.NODE_SUBTYPE_MESSAGE.TEXT:
        case MC_CONST.NODE_SUBTYPE_MESSAGE.IMAGE:
        case MC_CONST.NODE_SUBTYPE_MESSAGE.VIDEO:
        case MC_CONST.NODE_SUBTYPE_MESSAGE.FILE:
        case MC_CONST.NODE_SUBTYPE_MESSAGE.VOICE_STICKER:
        case MC_CONST.NODE_SUBTYPE_MESSAGE.CONTACT:
        case MC_CONST.NODE_SUBTYPE_MESSAGE.LOCATION:
        case MC_CONST.NODE_SUBTYPE_MESSAGE.AUDIO: {
          this.onMessageBase(topicId, type, subtype, message, groupData)
          break
        }
        case MC_CONST.NODE_SUBTYPE_MESSAGE.CREATE: {
          /**
           *  <message from='0396783058_1710153953501@muc.reeng' to='0396783058@reeng/desktop' subtype='create' type='groupchat' member='0396783058' timesend='1710153953516' id='30231370581710153953516329'>
                <room name='345' jid='0396783058_1710153953501'/>
                <member jid='0396783058' code='200' name='thanhbui' role='owner' lavatar='1706510476719'/>
                <member jid='0369945878' code='200' name='Mimi mute 🥰🥰🥰' role='member' lavatar='0'/>
                <member jid='0828351153' code='200' name='thanhbh111' role='member' lavatar='1652167076840'/>
                <cdesktop>1</cdesktop>
              </message>
           */
          const roomInfo = children.find((item) => item.name === "room");
          const groupName = roomInfo.attrs.name;
          const members = children
            .filter((info) => info.name === "member")
            .map((info) => {
              const mem = {
                ...info.attrs,
              };
              return mem;
            });
          this.createGroup(topicId, threadId, groupName, members);

          const ownerMember = members.filter((owner) => owner.role === "owner")
          const ownerGroup = ownerMember && ownerMember.length > 0 ? ownerMember[0] : null
          if (ownerGroup) {
            const fromName = lodash.has(ownerGroup, 'name') ? ownerGroup.name : ''
            if (fromName) {
              const body = this.formatMessage(messages.notify_create_group_by, { fromName })
              const id = MessagesUtil.xmppid();
              this.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
                body,
                timesend: timesend ? Number(timesend) : new Date().getTime(),
                id,
              })
            }
          }
          break;
        }

        case MC_CONST.NS.RENAME: {
          /**
           *  <message from='0396783058_1710153953501@muc.reeng' to='0396783058@reeng/desktop' subtype='rename' type='groupchat' member='0396783058' timesend='1710154092135' id='42927407291710154092134836'>
                <room name='3456' fromJid='0396783058'/>
                <cdesktop>1</cdesktop>
              </message>
           */
          const roomInfo = children.find((item) => item.name === "room");
          const groupName = roomInfo.attrs.name;
          const phoneEdit = lodash.has(roomInfo, 'attrs.fromJid') ? roomInfo.attrs.fromJid : '';
          const topic = this.getTopicByName(topicId, {
            isCreateWhenNotExist: true,
          })
          topic.public.fn = groupName
          topic.last_update = Date.now()
          const pub = {
            fn: groupName,
          }
          const desc = {
            public: pub,
          }
          topic._processMetaDesc(desc)
          const topicName = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, phoneEdit)
          const topicFrom = this.getTopicByName(topicName, { isCreateWhenNotExist: true })
          const fromName = Topic.getTopicName(topicFrom) || phoneEdit
          let body = this.formatMessage(messages.notify_rename_by_edit, { fromName, groupName })
          const id = MessagesUtil.xmppid();
          if (Topic.isMeTopicName(topicName) || profile.username === phoneEdit) {
            body = this.formatMessage(messages.notify_rename_group, { groupName })
          }
          this.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
            body,
            timesend: timesend ? Number(timesend) : new Date().getTime(),
            id,
          })

          break;
        }

        case MC_CONST.NS.KICK: {
          const { dissolve } = attrs
          const topic = this.getTopicByName(topicId)
          if (topic && dissolve && dissolve === '1') {
            topic.dissolveTopic()
            this.sendFakeDissolveOA(topic, attrs.member)
          } else {
            const id = attrs?.id ? attrs.id : MessagesUtil.xmppid();
            const userKick = attrs.member
            const userLeft = children.find((item) => item.name === "member");
            if (userKick && userLeft) {
              if (lodash.has(userLeft, 'attrs.jid')) {
                const phoneLeft = userLeft?.attrs?.jid ? userLeft.attrs.jid : ''
                if (phoneLeft && phoneLeft === profile.username) {
                  const topickick = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, userKick)
                  const topicInfokick = this.getTopicByName(topickick, { isCreateWhenNotExist: true })
                  const nameUserKick = Topic.getTopicName(topicInfokick) || userKick
                  if (topic && topic?.acs && topic?.acs.isWriter()) {
                    topic.updateMode(null, '-W')
                  }
                  const body = this.formatMessage(messages.left_group_by_kick, { memberName: nameUserKick });
                  this.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
                    body,
                    timesend: timesend ? Number(timesend) : new Date().getTime(),
                    id,
                  })
                }
              }
            }
          }
          break;
        }

        case MC_CONST.NODE_SUBTYPE_MESSAGE.LEAVE: {
          /**
           *  <message from='0396783058_1710153953501@muc.reeng' to='0396783058@reeng/desktop' subtype='leave' type='groupchat' member='0369945878' name='3456' timesend='1710154171087' id='4251947496171015417187285'>
                <body>You kicked out of group</body>
                <room name='3456'/>
                <cdesktop>1</cdesktop>
                <silent>1</silent>
              </message>
           */
          const userLeave = attrs.member
          const id = MessagesUtil.xmppid();
          const topic = this.getTopicByName(topicId, {
            isCreateWhenNotExist: true,
          })
          if (userLeave) {
            const silentInfo = children.find((item) => item.name === "silent");
            const silent = silentInfo ? silentInfo.children[0] : '0'

            const fullSilent = children.find((item) => item.name === "full_silent");

            const topicUser = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, userLeave)
            const isLeaveMyself = Topic.isMeTopicName(topicUser) || profile.username === userLeave

            const isAdmin = topic.isAdmin(profile.username)

            let isNotify = true;

            if (fullSilent !== null || typeof fullSilent !== 'undefined') {
              isNotify = false
            } else if (silent === '1' && !isAdmin) {
              isNotify = false
            }

            if (isNotify) {
              const topicInfoLeave = this.getTopicByName(topicUser, { isCreateWhenNotExist: true })
              const nameUserLeave = Topic.getTopicName(topicInfoLeave) || userLeave
              let body = this.formatMessage(messages.member_leave_group_notify, { memberName: nameUserLeave });
              if (isLeaveMyself) {
                body = this.formatMessage(messages.leave_group_notify)
              }
              this.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
                body,
                timesend: timesend ? Number(timesend) : new Date().getTime(),
                id,
              })
            }

            if (isLeaveMyself) {
              if (topic && topic.acs && topic.acs.isWriter()) {
                topic.updateMode(null, '-W')
              }
            }

            if (topic && topic.sub) {
              const topicSub = topic.sub ? topic.sub : []
              const sub = Helpers.filterSubsJid(topic.sub);
              sub.map(v => {
                if (v.jid == userLeave) {
                  v.deleted = true;
                }
                return v;
              });

              topic.sub = sub
              topic.last_update = Date.now()
              topic._processMetaDesc({});
              this.loadGroupMembers(topicId);
              topic._processMetaSubs();
            }
          }
          break;
        }

        case MC_CONST.NS.INVITE: {
          /**
           *  <message from='0396783058_1710153953501@muc.reeng' to='0396783058@reeng/desktop' subtype='invite' type='groupchat' member='0396783058' timesend='1710154249983' id='11135096481710154249982838'>
                <room name='3456' jid='0396783058_1710153953501'/>
                <member jid='0326695346' code='200' invitedFrom='0396783058' name='Cô nàng tinh nghịch' role='member' lavatar='1701057795331'/>
                <avatar_created></avatar_created>
                <gtype>0</gtype>
                <keep_private value='0'/>
                <cdesktop>1</cdesktop>
              </message>
           */
          const listMemberAdd = children
            .filter((info) => info.name === "member")
            .map((info) => {
              if (lodash.has(info, 'attrs.jid')) {
                const invitedPerson = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, info.attrs.jid)
                const topicPerson = this.getTopicByName(invitedPerson, { isCreateWhenNotExist: true })
                const personName = Topic.getTopicName(topicPerson) || info.attrs.jid
                const memInfo = {
                  ...info.attrs,
                  memberInfo: personName
                };
                return memInfo;
              }
            });

          //ban thong bao
          if (listMemberAdd && listMemberAdd.length > 0) {
            const inviteUser = listMemberAdd[0];
            const phoneInvite = lodash.has(inviteUser, 'invitedFrom') ? inviteUser.invitedFrom : ''
            if (phoneInvite) {
              const topicName = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, phoneInvite)
              if (Topic.isMeTopicName(topicName) || profile.username === phoneInvite) {
                window.logger("No push notification.")
              } else {
                const topicFrom = this.getTopicByName(topicName, { isCreateWhenNotExist: true })
                const fromName = Topic.getTopicName(topicFrom) || phoneInvite
                const invitePerson = listMemberAdd.map(item => item.memberInfo).join(", ");
                const body = this.formatMessage(messages.notify_invite_member_group, { inviteName: fromName, invitePerson })
                const id = MessagesUtil.xmppid();
                this.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
                  body,
                  timesend: timesend ? Number(timesend) : new Date().getTime(),
                  id,
                })
              }
            }
          }
          break;
        }

        case MC_CONST.NODE_SUBTYPE_MESSAGE.GROUP_AVATAR: {
          /**
           *  <message from='0396783058_1710153953501@muc.reeng' to='0396783058@reeng/desktop' member='0396783058' subtype='groupAvatar' type='groupchat' timesend='1710154301838' id='0500000_6260865542E84D7C9E24B7580F143007' room='3456'>
                <avatar_created>20240311105141</avatar_created>
                <queue t='1710154302001'>xmpp01@mocha-hl-178</queue>
                <cstate>1</cstate>
                <cdesktop>1</cdesktop>
                <gtype>0</gtype>
              </message>
           */
          const userChangeAvatar = attrs.member
          const id = attrs.id || MessagesUtil.xmppid();
          if (userChangeAvatar) {
            const topicUser = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, userChangeAvatar)
            const topicChangeAvatar = this.getTopicByName(topicUser, { isCreateWhenNotExist: true })
            const nameChangeAvatar = Topic.getTopicName(topicChangeAvatar) || userChangeAvatar
            let body = this.formatMessage(messages.change_avatar_group_notify, { memberName: nameChangeAvatar });
            if (Topic.isMeTopicName(topicUser) || profile.username === userChangeAvatar) {
              body = this.formatMessage(messages.notify_changed_avatar_group)
            }
            this.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
              body,
              timesend: timesend ? Number(timesend) : new Date().getTime(),
              id,
            })
          }

          const topic = this.getTopicByName(topicId)
          const avatar_date = children.find((item) => item.name === "avatar_created").children[0];
          window.logger("changeAvatar|topic=", topic, "|topicId=", topicId, "|avatar_date=", avatar_date)
          const groupAvatar = Helpers.getAvatarGroupURL(threadId, avatar_date);

          if (topic.public.photo) {
            topic.public.photo.ref = groupAvatar;
          } else {
            topic.public.photo = {
              ref: groupAvatar,
              type: 'png',
            };
          }
          topic._processMetaDesc({});
          window.logger("changeAvatar|topic=", topic, "|topicId=", topicId)
          break;
        }
        case MC_CONST.NODE_SUBTYPE_MESSAGE.PIN_MSG: {
          /**
           *  <message from='0396783058_1710153953501@muc.reeng' to='0396783058@reeng/desktop' member='0396783058' desk_revision='10221' revision='15536' id='0100000_DD80832655B34ED88D851817BFADAC62' type='groupchat' subtype='pin_msg' name='thanhbui' lastavatar='1706510476719' f_opr='04' f_ip='113.185.45.158' timesend='1710154344457' src='reeng' room='3456'>
                <body>Hjkl</body>
                <pin action='1' type='1' target='0102001_EEBF4F9F4D1B4227AE569EF57E791DE0' title='0396783058'/>
                <cdesktop>1</cdesktop>
                <gtype>0</gtype>
                <cstate>1</cstate>
              </message>
           */
          const pin = children.find((item) => item.name === "pin");
          const action = pin?.attrs?.action;
          const topic = this.getTopicByName(topicId);
          const member = attrs?.member;
          const owner = member == profile.username ? true : false;
          const memberTopicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, member)
          const topicMember = this.getTopicByName(memberTopicId);
          const memberName = owner ? this.formatMessage(messages.you) : topicMember ? topicMember.getTopicName() : member;
          const id = MessagesUtil.xmppid();
          const addNoti = children.find((item) => item.name === "show")?.children[0] != 0 || id.startsWith('CHAT_SERVER_');
          if (topic) {
            if (action == MC_CONST.MESSAGE_ACTION_PIN.PIN) {
              const target = pin?.attrs?.target;
              this.getMessageById(target).then((response) => {
                if (response) {
                  topic.pinMessage = response?.msg ? response.msg : {};
                } else {
                  const bodymsg = children.find((item) => item.name === "body");
                  if (bodymsg.children[0]) {
                    topic.pinMessage = {
                      content: bodymsg.children[0],
                      from: MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, pin?.attrs?.title),
                      id: target,
                      type,
                      subtype,
                      topic: topicId
                    }
                  }
                }
                if (addNoti) {
                  this.addMessageNotify(topic.name, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
                    body: this.formatMessage(messages.pin_message_notify, {
                      member: memberName
                    }),
                    timesend: timesend ? Number(timesend) : new Date().getTime(),
                    id,
                  })
                }

              });
            } else {
              topic.pinMessage = {};
              if (addNoti) {
                this.addMessageNotify(topic.name, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
                  body: this.formatMessage(messages.unpin_message_notify, {
                    member: memberName
                  }),
                  timesend: timesend ? Number(timesend) : new Date().getTime(),
                  id,
                })
              }
            }
            topic._processMetaSubs();
          }
          break;
        }
        case MC_CONST.NODE_SUBTYPE_MESSAGE.VOTE: {
          this.onMessagePoll(topicId, type, subtype, message, groupData);
          break;
        }
        case MC_CONST.NODE_SUBTYPE_MESSAGE.MAKE_ADMIN: {
          const creator = message?.attrs?.member;
          const members = message.children.filter(item => item.name === 'member');
          this.onMakeRole(topicId, members, creator);
          break;
        }
        case MC_CONST.NODE_SUBTYPE_MESSAGE.GROUP_PRIVATE: {
          /**
           *  <message from='0397585436_1570618626862@muc.reeng' to='0396783058@reeng/desktop' subtype='groupPrivate' type='groupchat' member='0396783058' name='Nhóm 2223' timesend='1706233208445' id='18162050391706233208445383'>
                <keep_private value='1'/>
              </message> 
           */
          const member = message?.attrs?.member;
          let memberName = member
          if (member === profile.username) {
            memberName = StringUtils.capitalizeFirstLetter(this.formatMessage(messages.badge_you))
          } else {
            const memberId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, member)
            const topicMember = this.getTopicByName(memberId)
            if (topicMember) {
              memberName = Topic.getTopicName(topicMember)
            }
          }

          let body = null
          const security = children.find(info => info.name === 'keep_private')
          const groupPrivateValue = security?.attrs?.value


          const topic = this.getTopicByName(topicId)
          if (topic) {
            let pub = topic && topic.public || {}
            pub.security = groupPrivateValue
            topic.public = pub

            topic._processMetaDesc({})

            if (groupPrivateValue === MC_CONST.GROUP_PRIVATE_STATE.PRIVATE) {
              body = this.formatMessage(messages.set_group_private_success, {
                member: memberName
              })
            } else if (groupPrivateValue === MC_CONST.GROUP_PRIVATE_STATE.NON_PRIVATE) {
              body = this.formatMessage(messages.set_group_public_success, {
                member: memberName
              })
            }

            if (body) {
              this.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
                body,
                timesend: timesend ? Number(timesend) : new Date().getTime(),
                id: attrs.id,
              })
            }
          }

          break
        }
        case MC_CONST.NODE_SUBTYPE_MESSAGE.NOTIFICATION: {
          const body = children.find(item => item.name === 'body').children[0]
          const id = attrs?.id ? attrs.id : MessagesUtil.xmppid();
          if (body) {
            this.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
              body,
              timesend: new Date().getTime(),
              id
            })
          }
          break;
        }
        case MC_CONST.NODE_SUBTYPE_MESSAGE.JOIN_GROUP: {

          const topic = this.getTopicByName(topicId, {
            isCreateWhenNotExist: true,
          })
          //add name topic
          const roomInfo = children.find(item => item.name === 'room')
          if (roomInfo && roomInfo.attrs) {
            const roomName = roomInfo?.attrs?.name
            if (roomName) {
              if (topic && topic.public) {
                const pub = topic.public
                pub.fn = roomName
                topic.public = pub
                const desc = {
                  public: pub,
                }
                topic._processMetaDesc(desc)
              } else {
                const publicTopic = {
                  fn: roomName,
                }
                topic.public = publicTopic
                const desc = {
                  public: publicTopic,
                }
                topic._processMetaDesc(desc)
              }
            }
          }

          const memberAdd = attrs?.member
          let memberName = memberAdd
          if (memberAdd === profile.username) {
            memberName = StringUtils.capitalizeFirstLetter(this.formatMessage(messages.badge_you))
          } else {
            const memberId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, memberAdd)
            const topicMember = this.getTopicByName(memberId)
            if (topicMember) {
              memberName = Topic.getTopicName(topicMember)
            }
          }
          let listMemberName = ''
          const lMember = children.filter(info => info.name === 'member')
          const members = lMember.filter(m => m.attrs.invitedFrom === memberAdd)
          const listMember = []
          const membersLength = members.length
          for (let i = 0; i < membersLength; i += 1) {
            const mem = members[i]
            const memMsisdn = mem.attrs.jid
            let memName = memMsisdn
            if (memMsisdn === profile.username) {
              memName = StringUtils.capitalizeFirstLetter(this.formatMessage(messages.badge_you))
              if (topic) {
                topic.updateMode(null, '+W')
              }
            } else {
              const memberThreadId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, memMsisdn)
              const topicNewMember = this.getTopicByName(memberThreadId)
              if (topicNewMember) {
                memName = Topic.getTopicName(topicNewMember)
              }
            }
            if (i === 0) {
              listMemberName = memName
            } else if (i === membersLength - 1) {
              listMemberName += ` ` + this.formatMessage(messages.join_and_group) + ` ${memName}`
            } else {
              listMemberName += `, ${memName}`
            }
            listMember.push({
              jid: memMsisdn,
              role: mem.attrs.role,
              name: mem.attrs.name,
            })
          }
          const body = this.formatMessage(messages.join_group, { newMemberName: listMemberName, memberInvite: memberName })
          if (body) {
            this.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
              body,
              timesend: timesend ? Number(timesend) : new Date().getTime(),
              id: attrs?.id ? attrs.id : MessagesUtil.xmppid(),
            })
          }
          if (topic && topic.sub) {
            let sub = topic.sub;
            if (sub && Array.isArray(sub)) {
              let newListSub = sub.concat(listMember.filter(bItem => !sub.some(aItem => aItem.jid === bItem.jid)));
              sub = newListSub
              topic.sub = newListSub
              this.loadGroupMembers(topicId);
              topic._processMetaDesc({});
            }
          }
          break;
        }
        case MC_CONST.NODE_SUBTYPE_MESSAGE.LIXI_NOTIFICATION: {
          /**
           * <message from='0396783058_1705983795537@muc.reeng' to='0396783058@reeng/desktop' member='0396783058' id='MOCHASERVER_LIB_A9GDOW3OOD907GMXIM' type='groupchat' subtype='lixi_notification' timesend='1707123578674' expired='1709715578674' room='Group Lixi'><body>%1$s nhận được 7.114 VNĐ từ %2$s</body><receiver>0396783058</receiver><sender>0976493913</sender><queue t='1707123578730'>xmpp01@mocha-hl-091</queue><cstate>1</cstate><cdesktop>1</cdesktop><gtype>0</gtype></message> 
           */
          const body = children.find(item => item.name === 'body').children[0]
          const id = attrs?.id ? attrs.id : MessagesUtil.xmppid();
          if (body) {
            const receiver = children.find(item => item.name === 'receiver').children[0]
            const receiverName = this.getTopicName(receiver)
            const sender = children.find(item => item.name === 'sender').children[0]
            const senderName = this.getTopicName(sender)
            const lixiBody = body.replace('%1$s', receiverName).replace('%2$s', senderName)

            this.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
              body: lixiBody,
              timesend: timesend ? Number(timesend) : new Date().getTime(),
              id
            })
          }
          break;
        }
      }
    }

    const fromMe = attrs.member === profile.username;
    // Gửi bản tin delivered seen
    let status = MC_CONST.MESSAGE_DELIVERED.RECEIVED;
    if (!!fromMe && topicId === this.topicSelected && this.backgroundApp === false) {
      status = MC_CONST.MESSAGE_DELIVERED.SEEN_MULTI_MESSAGES;
    }

    this.sendDeliveredMessage(threadId, {
      status,
      noRoute,
      type,
      listMessages: [message],
    });
  }

  onMessageDelivered(data, retry) {
    this.logger('OnMessageDelivered|', data.id, '|retry|', retry)
    if (retry < 3) {
      const topic = data.topic
      const id = data.id
      const children = data.children
      const message = data.message
      const topicId = data.topicId
      const type = data.type
      const attrs = data.attrs
      const msg = topic.findMessageById(id);
      if (msg) {
        const deliveredInfo = children.find(
          (item) => item.name === "delivered"
        );
        const delivered = parseInt(deliveredInfo.attrs.seen);
        const isUpdateStatus = msg.delivered < delivered

        if (isUpdateStatus) {
          msg.delivered = delivered;
        }

        let isUpdateRead = delivered === MC_CONST.MESSAGE_DELIVERED.SEEN_1_MESSAGE || delivered === MC_CONST.MESSAGE_DELIVERED.SEEN_MULTI_MESSAGES

        // Thêm trạng thái seen trong nhóm
        if (type === MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT) {
          let seen = msg.seen || []
          const member = message.attrs.member
          if (member !== profile.username) {
            isUpdateRead = false

            const memberTopicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, message.attrs.member)

            let isHave = seen.filter(m => m.member === member).length > 0
            if (isHave) {
              seen = seen && Array.isArray(seen) ? seen.map((m) => {
                if (m.member === member && m.delivered < delivered) {
                  m.delivered = delivered
                  m.timestamp = attrs.timesend || new Date().getTime()
                }
                return m
              }) : []
            } else {
              seen.push({
                member: member,
                topicId: memberTopicId,
                delivered,
                timestamp: attrs.timesend || new Date().getTime(),
              })
            }
            msg.seen = seen
          }
        }

        const status = topic.msgStatus(msg, true, true);
        msg._status = status

        if (isUpdateRead) {
          if (msg && topic.read < msg.seq) {
            topic._updateMyReadRecv('read', msg.seq);

            topic.read = msg.seq
            topic.recv = msg.seq

            // Update DB
            topic._routeMeta({
              desc: {
                read: msg.seq,
                recv: msg.seq,
              },
              topic: topic.name,
            })
          }
        }

        if (isUpdateStatus) {
          const data = {
            delivered,
            msg,
          };
          this.updateMessageStatus(topic, data);
        }
        this._db.updMessage(topicId, msg.seq, msg)
      } else {
        const newRetry = retry + 1
        setTimeout(() => this.onMessageDelivered(data, newRetry), 5000)
      }
    }
  }

  async onMessageBase(topicId, type, subtype, message, data = {}) {
    const { children, attrs } = message;
    const threadId = Topic.getThreadId(topicId)

    const messageData = MessagesUtil.getMessageData(type, message);
    const topicData = Object.assign({}, data, {
      threadId,
      isCreateWhenNotExist: true,
      attrs,
    })
    const topic = this.getTopicByName(topicId, topicData);
    if (topic.isHide && this.onMessageHide && subtype !== MC_CONST.NODE_SUBTYPE_MESSAGE.EVENT) {
      this.onMessageHide(message);
    }

    messageData._status = Const.MESSAGE_STATUS_RECEIVED;
    if (subtype !== MC_CONST.NODE_SUBTYPE_MESSAGE.EVENT) {
      topic.seq ? (topic.seq += 1) : (topic.seq = 1);
      messageData.seq = topic.seq;
    }

    messageData.type = type;
    messageData.subtype = subtype;
    if (!topic.acs) {
      topic.acs = new AccessMode({
        given: "JRWPASDO",
        want: "JRWPASDO",
        mode: "JRWPASDO",
      });
    }

    let updateSub = {}
    let notifyData = {
      ...messageData,
    }

    switch (subtype) {
      case MC_CONST.NODE_SUBTYPE_MESSAGE.EVENT: {
        const topic = this.getTopicByName(topicId, {
          isCreateWhenNotExist: false,
        });
        if (topic) {

          const idList = [];
          children.forEach((item) => {
            if (item.name === "id") {
              if (item && item.children && item.children[0]) {
                idList.push(item.children[0]);
              }
            }
          });

          idList.forEach((id) => {
            this.onMessageDelivered({
              message,
              attrs,
              children,
              type,
              topicId,
              topic,
              id,
            }, 0)
          });
          this.onMessageReact(message, topic, type);
        }

        break;
      }
      case MC_CONST.NODE_SUBTYPE_MESSAGE.TEXT: {
        let msgData = messageData;
        if (typeof msgData.content === 'string') {
          const listLinkContent = linkify.find(msgData.content);
          if (listLinkContent.length > 0) {
            topic.updMessagePreview(listLinkContent, msgData.id);
            listLinkContent.forEach((link, index) => {
              //them link tu nguoi nhan
              const { id, timesend } = attrs;
              const rand = Math.random() * 10000000
              let timeMsgSend = new Date().getTime();
              if (timesend) {
                timeMsgSend = Number(timesend);
              }
              const linkObj = {
                messageId: id,
                url: link.value ? link.value : '',
                rand,
                timesend: timeMsgSend
              }
              topic.shareLink = Array.isArray(topic.shareLink) ? topic.shareLink.concat(linkObj) : [linkObj]
            })
          }
        }

        let msgContent = messageData.content
        const isCrypt = !!messageData.crypt
        if (isCrypt) {
          const targetIdElement = children.find(item => item.name === 'targetIdE2E')
          const targetId = targetIdElement ? targetIdElement.children[0] : attrs.id
          const isDecryptExistMessage = targetIdElement !== null || false

          let targetMsg = null
          if (targetIdElement) {
            targetMsg = topic.findMessageById(targetId)
          }

          const data = {
            from: threadId,
            preKey: messageData.crypt.children[0],
            msgId: targetId,
            isReDecrypt: isDecryptExistMessage,
            resendCount: 0,
            message: messageData,
          }

          let content = messageData.content
          if (messageData.fromMsisdn === profile.username) {
            content = messageData.scontent
          }

          if (targetMsg) {
            msgData.id = targetId
            msgData.ts = null
            msgData.seq = targetMsg.seq
          }

          // Giải mã Prekey nếu chưa giải mã
          const preKeyInfo = profile.preKeyInfo
          if (preKeyInfo || preKeyInfo === null) {
            if (preKeyInfo.isDecrypted === false) {
              this.logger('Prekey null ==> Decrypt Prekey Again', preKeyInfo)
              this.decryptPrivateE2EKey(preKeyInfo)
            }
          } else {
            this.getKeyE2EInfo()
          }
          

          const decrypted = await Signal.getInstance().decryptMessage(content, data)
          console.log(decrypted)
          if (decrypted.decryptedText) {
            msgContent = decrypted.decryptedText
          } else {
            msgContent = this.formatMessage(messages.e2e_encrypted_message)
          }
        }
        messageData.content = msgContent
        notifyData.content = msgContent


        if (lodash.has(messageData, "reply")) {
          const { reply } = messageData;
          const { msgId } = reply;
          const replyMsg = topic.findMessageById(msgId);
          if (replyMsg && typeof replyMsg !== "undefinded") {
            let senderName = Topic.getThreadId(replyMsg.from);
            const topicSender = this.getTopicByName(replyMsg.from)
            if (topicSender) {
              senderName = Topic.getTopicName(topicSender)
            }
            const senderId = replyMsg.from;
            const content = Drafty.replyContent(replyMsg.content, QUOTED_REPLY_LENGTH);
            const replyContent = {
              content: Drafty.quote(senderName, senderId, content),
              seq: replyMsg.seq,
            };
            replyContent.content.txt = replyContent.content.txt + messageData.content;
            replyContent.content.replyBody = messageData.content
            replyContent.content.replyMsg = replyMsg
            msgData.content = replyContent.content;
            msgData.head = {
              mime: Drafty.getContentType(),
              reply: "" + replyContent.seq,
            };
          }
        }

        // Kiểm tra thông tin stranger
        const externalStranger = attrs.external
        if (externalStranger && (externalStranger === 'mocha_stranger' || externalStranger === 'talk_stranger' || externalStranger === 'music_stranger')) {
          if (profile.username === threadId) {
            const threadRef = children.find(item => item.name === 'threadRef')
            if (threadRef) {
              const receiver = threadRef?.attrs?.toref
              if (receiver && receiver !== profile.username) {
                await this.getUserProfile(receiver);
              }
            }
          } else {
            await this.getUserProfile(threadId);
          }
        }

        topic._routeData(msgData);

        // Thông báo
        if (!messageData.offline) {
          topic.notification(notifyData, this.onNotificationClick);
        }

        updateSub = {
          shareLink: topic.shareLink,
          isCrypt,
          stranger: externalStranger,
        }

        break;
      }
      case MC_CONST.NODE_SUBTYPE_MESSAGE.IMAGE: {
        const data = {};
        children.forEach((info) => {
          data[info.name] = info.children[0];
        });

        const fname = data.name;
        const mediaLink = data.media_link;
        const size = data.size;

        const insertImg = (width, height) => {
          const imageMsg = Drafty.insertImage(null, 0, {
            mime: Helpers.getMimeType(fname),
            width: width,
            height: height,
            filename: fname,
            size,
            refurl: mediaLink,
          });

          imageMsg.subtype = MC_CONST.NODE_SUBTYPE_MESSAGE.IMAGE
          imageMsg.fname = fname
          imageMsg.ratio = data.ratio
          imageMsg.mediaLink = mediaLink
          imageMsg.mediaId = data.id

          messageData.content = imageMsg;
          messageData.head = { mime: Drafty.getContentType() };

          //them anh tu nguoi nhan
          const { id } = attrs;
          const imageObj = {
            messageId: id,
            media_link: mediaLink,
          }
          if (topic?.shareImage && Array.isArray(topic.shareImage)) {
            topic.shareImage.unshift(imageObj)
          } else {
            topic.shareImage = [imageObj]
          }

          topic._routeData(messageData);

          // Thông báo
          notifyData.content = this.formatMessage(messages.image_message)
          if (!messageData.offline) {
            topic.notification(notifyData, this.onNotificationClick);
          }
        }

        const img = new Image();
        img.src = "https://" + profile.changeDomain.domain_img + mediaLink;

        img.onload = (e) => {
          const width = e.target.width;
          const height = e.target.height;

          insertImg(width, height)
        };

        img.onerror = () => {
          console.error('Error loading image')

          let width = MAX_IMAGE_DIM / 2
          let height = MAX_IMAGE_DIM / 2

          insertImg(width, height)
        }
        break;
      }
      case MC_CONST.NODE_SUBTYPE_MESSAGE.VIDEO: {
        const data = {};
        children.forEach((info) => {
          data[info.name] = info.children[0];
        });

        const fname = data.name;
        const mediaLink = data.media_link;
        const size = data.size;
        const thumb = Helpers.formatURL(data.thumb)
        const duration = data.duration;

        const videoUrl = "https://" + profile.changeDomain.domain_img + mediaLink;

        let i64 = null

        axios({
          url: thumb,
          method: "GET",
          responseType: "blob",
        }).then((response) => {
          const imageBlob = response.data;
          if (imageBlob) {
            return blobToBase64(imageBlob);
          }
          return new Promise((resolve, reject) => {
            resolve(null);
          });
        }).then((res) => {
          i64 = res
        }).catch((e) => {
          console.error(e)
        }).finally(() => {
          const videoElement = document.createElement("video");
          videoElement.src = videoUrl;
          videoElement.addEventListener("loadedmetadata", () => {
            const width = videoElement.videoWidth;
            const height = videoElement.videoHeight;

            const videoData = {
              mime: Helpers.getMimeType(fname),
              width: width,
              height: height,
              duration: duration,
              filename: fname,
              size: size,
              refurl: mediaLink,
              preref: thumb,
            }

            if (i64) {
              videoData.premime = i64.mime;
              videoData.preview = i64.bits
            }

            const videoMsg = Drafty.insertVideo(null, 0, videoData);

            videoMsg.subtype = MC_CONST.NODE_SUBTYPE_MESSAGE.VIDEO
            videoMsg.fname = fname
            videoMsg.mediaLink = mediaLink
            videoMsg.thumb = thumb
            videoMsg.size = size
            videoMsg.duration = duration

            messageData.content = videoMsg;
            messageData.head = { mime: Drafty.getContentType() };

            // URL.revokeObjectURL(videoUrl);
            topic._routeData(messageData);

            // Thông báo
            notifyData.content = this.formatMessage(messages.video_message)
            if (!messageData.offline) {
              topic.notification(notifyData, this.onNotificationClick);
            }
          });


          videoElement.load();
        });

        break;
      }
      case MC_CONST.NODE_SUBTYPE_MESSAGE.FILE: {
        const data = {};
        children.forEach((info) => {
          data[info.name] = info.children[0];
        });

        const fname = data.name;
        const mediaLink = data.media_link;
        const size = data.size;

        const imageMsg = Drafty.attachFile(null, {
          mime: Helpers.getMimeType(fname),
          filename: fname,
          size,
          refurl: mediaLink,
        });

        imageMsg.subtype = MC_CONST.NODE_SUBTYPE_MESSAGE.FILE
        imageMsg.fname = fname
        imageMsg.mediaLink = mediaLink
        imageMsg.mediaId = data.id
        imageMsg.size = size


        messageData.content = imageMsg;
        messageData.head = { mime: Drafty.getContentType() };

        //thêm quản lý file chung
        const { id, timesend } = attrs;
        let timeMsgSend = new Date().getTime();
        if (timesend) {
          timeMsgSend = Number(timesend);
        }
        const fileInfo = {
          messageId: id,
          media_link: mediaLink,
          size,
          name: fname,
          timesend: timeMsgSend
        }
        if (Array.isArray(topic.shareFile)) {
          topic.shareFile.unshift(fileInfo)
        } else {
          topic.shareFile = [fileInfo]
        }

        topic._routeData(messageData);

        // Thông báo
        notifyData.content = this.formatMessage(messages.file_message)
        if (!messageData.offline) {
          topic.notification(notifyData, this.onNotificationClick);
        }

        break;
      }
      case MC_CONST.NODE_SUBTYPE_MESSAGE.VOICE_STICKER: {
        const data = {};
        children.forEach((info) => {
          data[info.name] = info.children[0];
        });

        const stickerId = data.itemid;
        const collectionId = data.packageid;

        let img = null
        let url = null
        let audio = null;

        const listStickersStore = stickers.sticker || [];
        const collectionF = listStickersStore.filter(
          (s) => s.collectionId === Number(collectionId)
        );
        const collection = collectionF.length > 0 ? collectionF[0] : null;
        if (collection && collection.stickers) {
          const stickerF = collection.stickers.filter(
            (s) => s.stickerId === Number(stickerId)
          );
          const sticker = stickerF.length > 0 ? stickerF[0] : null;
          const collectionPrefix = collection.prefix;
          if (sticker) {
            img = sticker.img;
            url = `${collectionPrefix}/${img}`;
            audio = `${collectionPrefix}/${sticker.voice}`;
          }
        }

        if (img === null || url === null) {
          img = `${Number(collectionId) === -1 ? Number(stickerId) + 1 : stickerId}.png`
          url = `/sticker/${collectionId}/${img}`
        }

        const stickerMsg = Drafty.insertSticker(null, 0, {
          mime: Helpers.getMimeType(img),
          refurl: url,
          width: 150,
          height: 150,
          audio: audio
        });
        messageData.content = stickerMsg;
        messageData.head = { mime: Drafty.getContentType() };

        topic._routeData(messageData);

        // Thông báo
        notifyData.content = this.formatMessage(messages.voice_sticker_message)
        if (!messageData.offline) {
          topic.notification(notifyData, this.onNotificationClick);
        }

        break;
      }
      case MC_CONST.NODE_SUBTYPE_MESSAGE.CONTACT: {
        const data = {};
        children.forEach((info) => {
          data[info.name] = info.children[0];
        });

        const phone = data.tel;
        const name = data.name;

        const topicContactName = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, phone)
        const topicContact = this.getTopicByName(topicContactName)
        let avatar = null
        if (topicContact && lodash.has(topicContact, 'public.photo.ref')) {
          avatar = topicContact.public.photo.ref
        }

        const contactMsg = Drafty.insertContact(null, 0, {
          phone,
          name,
          topic: topicContactName,
          avatar,
        });
        messageData.content = contactMsg;
        messageData.head = { mime: Drafty.getContentType() };

        topic._routeData(messageData);

        // Thông báo
        notifyData.content = this.formatMessage(messages.contact_message)
        if (!messageData.offline) {
          topic.notification(notifyData, this.onNotificationClick);
        }

        break;
      }
      case MC_CONST.NODE_SUBTYPE_MESSAGE.LOCATION: {
        const data = {};
        children.forEach((info) => {
          data[info.name] = info.children[0];
        });

        const body = data.body;
        const latitude = data.lat;
        const longitude = data.lng;

        const contactMsg = Drafty.insertLocation(null, 0, {
          body,
          latitude,
          longitude,
        });
        messageData.content = contactMsg;
        messageData.head = { mime: Drafty.getContentType() };

        topic._routeData(messageData);

        // Thông báo
        notifyData.content = this.formatMessage(messages.location_message)
        if (!messageData.offline) {
          topic.notification(notifyData, this.onNotificationClick);
        }

        break;
      }
      case MC_CONST.NODE_SUBTYPE_MESSAGE.AUDIO: {
        const data = {};
        children.forEach((info) => {
          data[info.name] = info.children[0];
        });

        const fname = data.name;
        const mediaLink = data.media_link;
        const size = data.size;
        const duration = data.duration * 1000;

        const audioMsg = Drafty.appendAudio(null, {
          mime: Helpers.getMimeType(fname),
          name: fname,
          size: size,
          duration: duration,
          refurl: mediaLink,
        });
        messageData.content = audioMsg;
        messageData.head = { mime: Drafty.getContentType() };

        topic._routeData(messageData);

        // Thông báo
        notifyData.content = this.formatMessage(messages.audio_message)
        if (!messageData.offline) {
          topic.notification(notifyData, this.onNotificationClick);
        }

        break;
      }
    }

    // Cập nhật giao diện chat list
    const sub = Object.assign({
      topic: messageData.topic,
      public: topic.public,
      read: topic.read,
      recv: topic.recv,
      seq: topic.seq,
      touched: topic.touched,
      updated: topic.updated,
    }, updateSub);

    const topicMe = this.getMeTopic();
    topicMe._processMetaSubs([sub]);
  }

  setSecretChat(topic, secretStatus, data) {
    const { topicId, fromName, toName, timesend, id } = data
    let body
    let isCrypt = false
    if (secretStatus === '1') {
      body = this.formatMessage(messages.e2e_chat_on_notify, { fromName, toName, appName: APP_NAME })
      isCrypt = true
    } else {
      body = this.formatMessage(messages.e2e_chat_off_notify, { fromName, toName, appName: APP_NAME })
      isCrypt = false
    }

    const topicMe = this.getTopicByName(Const.TOPIC_ME)
    const sub = {
      topic: topicId,
      isCrypt: isCrypt,
      updated: topic.updated,
    };
    topicMe._processMetaSubs([sub])

    this.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.CHAT, {
      body,
      timesend: timesend ? Number(timesend) : new Date().getTime(),
      id: id,
    })
  }

  onMessagePoll(topicId, type, subtype, message, data = {}) {
    const { children } = message;
    const action = children.find(v => v.name === 'action');
    const typeAction = action?.attrs?.type;
    const threadId = Topic.getThreadId(topicId)
    const messageData = MessagesUtil.getMessageData(type, message);
    const topicData = Object.assign({}, data, {
      threadId,
      isCreateWhenNotExist: true,
    })
    const topic = this.getTopicByName(topicId, topicData);
    messageData._status = Const.MESSAGE_STATUS_RECEIVED;
    messageData.type = type;
    messageData.subtype = subtype;
    if (!topic.acs) {
      topic.acs = new AccessMode({
        given: "JRWPASDO",
        want: "JRWPASDO",
        mode: "JRWPASDO",
      });
    }
    const member = message?.attrs?.member;
    const { children: childrenAction } = action;
    const msgPoll = Helpers.parse(childrenAction[0]);
    switch (typeAction) {
      case MC_CONST.NODE_ACTION_POLL.CREATE_POLL:
        topic.seq ? (topic.seq += 1) : (topic.seq = 1);
        messageData.seq = topic.seq;
        this.createPollMessage(topicId, msgPoll);
        break;
      case MC_CONST.NODE_ACTION_POLL.SEND_POLL:
        this.updatePollMessage(topicId, msgPoll, member);
        break;
      case MC_CONST.NODE_ACTION_POLL.ADD_ITEM_POLL:
        this.addPollMessage(topicId, msgPoll, member);
        break;
      default:
        break;
    }
  }

  addPollMessage(topicId, msgPoll, member) {
    const topic = this.getTopicByName(topicId);
    let msgMessage = topic.findMessageById(msgPoll.id);
    return new Promise((resolve, reject) => {
      this._db.getPollMessages(msgPoll.id).then((msg) => {
        let typeMsg = msgMessage != undefined ? '1' : '2';
        let typeMsgPoll = msg != undefined ? '1' : '2';
        switch (typeMsg + typeMsgPoll) {
          case '11':
            msg.options = msg.options.concat(msgPoll.options);
            this._db.updPollMessage(msg);
            const options = {
              member,
              type: MC_CONST.NODE_ACTION_POLL.ADD_ITEM_POLL,
              msgPoll: msgPoll
            };
            topic._routePollData(msg, options);
            resolve(msg);
            break;
          case '12':
          case '22':
            GroupService.getVoteInfo(msgPoll.id).then((res) => {
              if (res != null) {
                const { code, data } = res;
                if (code == 200) {
                  this.createPollMessage(topicId, data).then((msg) => {
                    this.addPollMessage(topicId, msgPoll, member);
                  });
                }
              }
            })
            break;
          case '21':
            GroupService.getVoteInfo(msgPoll.id).then((res) => {
              if (res != null) {
                const { code, data } = res;
                if (code == 200) {
                  this.createPollMessage(topicId, data, false).then((msg) => {
                    this.addPollMessage(topicId, msgPoll, member);
                  });
                }
              }
            })
            break;
          default:
            break;
        }
      }).catch((err) => {
        reject(err);
      });
    })

  }

  createPollMessage(topicId, msgPoll, createPollMsg = true) {
    const topic = this.getTopicByName(topicId);

    const options = {
      member: msgPoll.creator,
      type: MC_CONST.NODE_ACTION_POLL.CREATE_POLL
    };
    topic._routePollData(msgPoll, options);
    const { createdAt, id } = msgPoll
    const msg = {
      content: Drafty.insertPoll(null, null, { id }),
      id,
      from: Topic.getThreadId(topic.name),
      topic: topic.name,
      ts: new Date(Number(createdAt)),
      type: MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT,
      subtype: MC_CONST.NODE_SUBTYPE_MESSAGE.VOTE,
    }
    msg.head = { mime: Drafty.getContentType() };
    topic.seq ? (topic.seq += 1) : (topic.seq = 1);
    msg.seq = topic.seq;
    topic._routeData(msg);
    const sub = {
      topic: msg.topic,
      public: topic.public,
      read: topic.read,
      recv: topic.recv,
      seq: topic.seq,
      touched: topic.touched,
      updated: topic.updated,
    };
    const topicMe = this.getMeTopic();
    topicMe._processMetaSubs([sub]);
    return new Promise((resolve, reject) => {
      if (createPollMsg) {
        this._db.addPollMessage(msgPoll).then((msg) => {
          resolve(msg);
        }).catch((err) => {
          reject(err)
        })
      } else {
        resolve(true);
      }
    });

  }

  updatePollMessage(topicId, msgPoll, member) {
    const topic = this.getTopicByName(topicId);
    let msgMessage = topic.findMessageById(msgPoll.id);
    this._db.getPollMessages(msgPoll.id).then((msg) => {
      let typeMsg = msgMessage != undefined ? '1' : '2';
      let typeMsgPoll = msg != undefined ? '1' : '2';
      switch (typeMsg + typeMsgPoll) {
        case '11':
          msg.options = Helpers.addMemberInVotes(msg.options, msgPoll.options, member);
          this._db.updPollMessage(msg);
          const options = {
            member,
            type: MC_CONST.NODE_ACTION_POLL.SEND_POLL,
            msgPoll: msgPoll
          };
          topic._routePollData(msg, options);
          break;
        case '12':
        case '22':
          GroupService.getVoteInfo(msgPoll.id).then((res) => {
            if (res != null) {
              const { code, data } = res;
              if (code == 200) {
                this.createPollMessage(topicId, data).then((msg) => {
                  this.updatePollMessage(topicId, msgPoll, member);
                });
              }
            }
          })
          break;
        case '21':
          GroupService.getVoteInfo(msgPoll.id).then((res) => {
            if (res != null) {
              const { code, data } = res;
              if (code == 200) {
                this.createPollMessage(topicId, data, false).then((msg) => {
                  this.updatePollMessage(topicId, msgPoll, member);
                });
              }
            }
          })
          break;
        default:
          break;
      }
    })

  }

  onMakeRole(topicId, members, creator) {
    const topic = this.getTopicByName(topicId);
    const sub = Helpers.filterSubsJid(topic.sub);
    members.forEach((member) => {
      const jid = member.attrs.jid;
      const role = member.attrs.role;
      sub.map(v => {
        if (v.jid == jid) {
          v.role = role;
          this.addNotifyForMakeRole(topicId, v, role, creator);
        }
        return v;
      });
    });
    topic.sub = sub;
    this.loadGroupMembers(topicId);
  }

  onKickMember(topicId, members, timesend) {
    const topic = this.getTopicByName(topicId);
    const sub = Helpers.filterSubsJid(topic.sub);
    if (typeof members == 'string') {
      sub.map(v => {
        if (v.jid == members) {
          v.deleted = true;
          const name = Topic.getTopicName(v);
          this.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
            body: this.formatMessage(messages.notify_leave_group, {
              member: name
            }),
            timesend: timesend || new Date().getTime(),
            id: MessagesUtil.xmppid(),
          })
        }
        return v;
      });
    } else {
      members.forEach((member) => {
        const jid = member.attrs.jid;
        sub.map(v => {
          if (v.jid == jid) {
            v.deleted = true;
            const name = Topic.getTopicName(v);
            this.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
              body: this.formatMessage(messages.notify_leave_group, {
                member: name
              }),
              timesend: timesend || new Date().getTime(),
              id: MessagesUtil.xmppid(),
            })
          }
          return v;
        });
      });
    }
    topic.sub = sub;
    topic._processMetaDesc({});
    this.loadGroupMembers(topicId);
  }

  addNotifyForMakeRole(topicId, subTopic, role, creator) {
    const meCreator = (creator == profile.username);
    const isYou = subTopic.jid == profile.username;
    const name = Topic.getTopicName(subTopic);

    let msgTrans = (role == MC_CONST.GROUP_ROLE.ADMIN) ? messages.notify_add_admin : messages.notify_remove_admin;
    let trans = {
      onwer: '',
      member: ''
    }

    if (meCreator) {
      if (isYou) {
        msgTrans = messages.make_your_admin
      } else {
        trans = {
          onwer: this.formatMessage(messages.you),
          member: name
        }
      }
    } else {
      const onwerName = this.getTopicByName(MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, creator))?.getTopicName();
      trans = {
        onwer: onwerName,
        member: isYou ? this.formatMessage(messages.you) : name
      }
    }
    this.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
      body: this.formatMessage(msgTrans, trans),
      timesend: new Date().getTime(),
      id: MessagesUtil.xmppid(),
    })
  }
  updateSharedLinks = (topic, messageId, value, rand) => {
    const sharedLink = { messageId, url: value, rand }
    if (topic) {
      if (topic.sharedLink) {
        topic.sharedLink.unshift(sharedLink)
      } else {
        topic.sharedLink = [sharedLink]
      }
      return topic.sharedLink;
    }
  }

  onMessageEvent(message) {
    const { attrs, children } = message;
    const { timesend } = attrs
    const threadId = MessagesUtil.getThreadId(
      MC_CONST.NODE_TYPE_MESSAGE.CHAT,
      message
    );

    // Gửi bản tin delivered seen
    this.sendDeliveredMessage(threadId, {
      status: MC_CONST.MESSAGE_DELIVERED.RECEIVED,
      type: "event",
      listMessages: [message],
      noRoute: true,
    });

    if (lodash.has(attrs, "subtype")) {
      switch (attrs.subtype) {
        case MC_CONST.NODE_SUBTYPE_EVENT.CONFIG: {
          const key = children.find((item) => item.name === "key").children[0];
          switch (key) {
            case MC_CONST.MESSAGE_EVENT_CONFIG_KEY.GET_CONTACT:
              this.syncContact(true);
              break;
            case MC_CONST.MESSAGE_EVENT_CONFIG_KEY.GET_USER_INFO:
              setTimeout(() => {
                this.getMyUserProfile();
              }, 3000)
              break;
            case MC_CONST.MESSAGE_EVENT_CONFIG_KEY.UPLOAD_LOG:
            case MC_CONST.MESSAGE_EVENT_CONFIG_KEY.UPLOG_DEBUG: {
              /* <message from="support@reeng/reeng" to="0338252123@reeng/desktop" type="event" subtype="config" id='i3Gej-1111'>
                    <key>UPLOG_DEBUG</key>
                  </message>
               */
              this.uploadLog();
              break
            }
            case MC_CONST.MESSAGE_EVENT_CONFIG_KEY.ENABLE_DEBUG: {
              /* <message from="support@reeng/reeng" to="0338252123@reeng/desktop" type="event" subtype="config" id='i3Gej-1111'>
                    <key>ENABLE_DEBUG</key>
                  </message>
               */
              profile.logDebbugEnabled = true
              profile.loggingEnabled = true
              break
            }
            case MC_CONST.MESSAGE_EVENT_CONFIG_KEY.DISABLE_DEBUG: {
              /* <message from="support@reeng/reeng" to="0338252123@reeng/desktop" type="event" subtype="config" id='i3Gej-1111'>
                    <key>DISABLE_DEBUG</key>
                  </message>
               */
              profile.logDebbugEnabled = false
              profile.loggingEnabled = false
              break
            }
          }
          break;
        }
        case MC_CONST.NODE_SUBTYPE_EVENT.BLOCK_USER: {
          const key = children.find((item) => item.name === "block");
          if (key) {
            let userBlock = key?.attrs?.user
            const statusBlock = key?.attrs?.state
            const blocker = MessagesUtil.getFrom(MC_CONST.NODE_TYPE_MESSAGE.CHAT, message)
            const blockLists = profile.listBlockChat ? profile.listBlockChat : [];
            if (userBlock) {
              const id = MessagesUtil.xmppid();
              const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, userBlock);
              const topic = this.getTopicByName(topicId, { isCreateWhenNotExist: true })
              const topicName = Topic.getTopicName(topic) || userBlock
              if (statusBlock && statusBlock === '1') {
                const body = this.formatMessage(messages.blockUser_content, { phoneName: topicName })
                this.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.CHAT, {
                  body,
                  timesend: timesend ? Number(timesend) : new Date().getTime(),
                  id,
                })

                if (blockLists && Array.isArray(blockLists)) {
                  profile.listBlockChat = blockLists.concat(userBlock)
                }
                topic.isBlockUser = true;
                topic.udpTopicInfo(topic);
                topic._processMetaDesc({});

              } else if (statusBlock && statusBlock === '0') {
                const body = this.formatMessage(messages.unblockUser, { phoneName: topicName })
                this.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.CHAT, {
                  body,
                  timesend: timesend ? Number(timesend) : new Date().getTime(),
                  id,
                })
                if (blockLists && Array.isArray(blockLists)) {
                  profile.listBlockChat = blockLists.filter(c => c !== userBlock)
                }
                topic.isBlockUser = false;
                topic.udpTopicInfo(topic);
                topic._processMetaDesc({});
              }
            } else {
              const toUser = attrs?.to
              if (toUser) {
                userBlock = MessagesUtil.getMsisdnFrom(toUser)
              } else {
                userBlock = profile.username
              }
              if (userBlock && blocker && statusBlock) {
                this.handleEventBlockchat(blocker, userBlock, statusBlock)
              }
            }
          }
          break;
        }
        default: {
          break;
        }
      }
    }
  }

  onMessageOfficial(message) {
    const { attrs, children } = message
    const { id, type, subtype } = attrs

    const threadId = MessagesUtil.getThreadId(
      MC_CONST.NODE_TYPE_MESSAGE.CHAT,
      message
    );
    const topicId = MessagesUtil.getTopicId(
      MC_CONST.NODE_TYPE_MESSAGE.CHAT,
      threadId
    );

    let officialName = ''
    const officialNameTag = children.find(item => item.name === 'officalname')
    if (officialNameTag && officialNameTag.children[0]) officialName = officialNameTag.children[0]

    let officialAvatar = null
    const officialAvatarTag = children.find(item => item.name === 'avatar')
    if (officialAvatarTag && officialAvatarTag.children[0]) officialAvatar = officialAvatarTag.children[0]

    const topic = this.getTopicByName(topicId, {
      threadId,
      isCreateWhenNotExist: true,
      isOfficial: true,
      officialName,
      officialAvatar,
    });


    let offline = false
    const offlineTag = children.find(item => item.name === 'offline')
    if (offlineTag) offline = true


    let officialBody = ''
    const officialBodyTag = children.find(item => item.name === 'body')
    if (officialBodyTag && officialBodyTag.children[0]) officialBody = officialBodyTag.children[0]

    let officialImage = null
    const officialImageTag = children.find(item => item.name === 'image_url')
    if (officialImageTag && officialImageTag.children[0]) officialImage = officialImageTag.children[0]

    let officialLink = null
    const officialLinkTag = children.find(item => item.name === 'linkto')
    if (officialLinkTag && officialLinkTag.children[0]) officialLink = officialLinkTag.children[0]

    const messageData = {
      threadId: threadId,
      content: officialBody,
      id,
      from: topicId,
      topic: topicId,
      ts: new Date(),
      attributes: message.attrs,
    }
    switch (subtype) {
      case MC_CONST.NODE_SUBTYPE_MESSAGE.TEXT:
      case MC_CONST.NODE_SUBTYPE_MESSAGE.IMAGE: {
        this.onMessageBase(topicId, type, subtype, message)
        break;
      }
      case MC_CONST.NODE_SUBTYPE_OFFICIAL.DEEP_LINK: {

        let officialLeftActionDeepLink = null
        let officialLeftLabelDeepLink = null
        const officialLeftActionDeepLinkTag = children.find(item => item.name === 'leftaction')
        if (officialLeftActionDeepLinkTag && officialLeftActionDeepLinkTag.children[0]) officialLeftActionDeepLink = officialLeftActionDeepLinkTag.children[0]
        if (officialLeftActionDeepLinkTag && officialLeftActionDeepLinkTag.attrs && officialLeftActionDeepLinkTag.attrs.label) officialLeftLabelDeepLink = officialLeftActionDeepLinkTag.attrs.label

        let officialRightActionDeepLink = null
        let officialRightLabelDeepLink = null
        const officialRightActionDeepLinkTag = children.find(item => item.name === 'rightaction')
        if (officialRightActionDeepLinkTag && officialRightActionDeepLinkTag.children[0]) officialRightActionDeepLink = officialRightActionDeepLinkTag.children[0]
        if (officialRightActionDeepLinkTag && officialRightActionDeepLinkTag.attrs && officialRightActionDeepLinkTag.attrs.label) officialRightLabelDeepLink = officialRightActionDeepLinkTag.attrs.label

        const deeplink = {}
        if (officialLeftActionDeepLink) {
          deeplink.left = {
            link: officialLeftActionDeepLink,
            button: officialLeftLabelDeepLink,
          }
        }
        if (officialRightActionDeepLink) {
          deeplink.right = {
            link: officialRightActionDeepLink,
            button: officialRightLabelDeepLink,
          }
        }

        const deeplinkMsg = Drafty.insertDeeplink(null, 0, {
          deeplink,
          body: officialBody
        });

        messageData.content = deeplinkMsg;
        messageData.head = { mime: Drafty.getContentType() };

        topic.seq ? (topic.seq += 1) : (topic.seq = 1);
        messageData.seq = topic.seq;


        topic._routeData(messageData);


        // Cập nhật giao diện chat list
        const sub = {
          topic: messageData.topic,
          public: topic.public,
          read: topic.read,
          recv: topic.recv,
          seq: topic.seq,
          touched: topic.touched,
          updated: topic.updated,
        };
        const topicMe = this.getMeTopic();
        topicMe._processMetaSubs([sub]);

        break;
      }
    }



    // Gửi bản tin delivered seen
    this.sendDeliveredMessage(threadId, {
      status: MC_CONST.MESSAGE_DELIVERED.RECEIVED,
      noRoute: true,
      type,
      listMessages: [message],
    });
  }

  onMessageOther(message) {
    const { attrs, children } = message;
    if (lodash.has(attrs, "ns")) {
      if (attrs.ns === MC_CONST.NS.VT_MESSAGE_EVENT) {
        /*
        <message ns='vt:message:event' from='0962627547@reeng/desktop' to='0962627547@reeng/desktop'>
          <no_store/>
          <received delta='30'/>
          <id>0502000_NCCUZQKAHADK3HS1RHNJ806D4MFIT91L</id>
          <threadOrg from='0962627547@reeng/desktop' to='0919372466-1446016671293@muc.reeng'/>
        </message>
        */
        const received = children.find((item) => item.name === "received");
        const threadOrg = children.find((item) => item.name === "threadOrg");
        if (received && threadOrg) {
          const messageIdTag = children.find((item) => item.name === "id");
          const id = messageIdTag && messageIdTag.children[0];
          const threadId = MessagesUtil.getFromVtMessageEvent(message);
          let seq = -1
          const type = (threadOrg?.attrs?.to && threadOrg.attrs.to.includes('@muc.reeng'))
            ? MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT
            : MC_CONST.NODE_TYPE_MESSAGE.CHAT;
          const topicId = MessagesUtil.getTopicId(type, threadId);
          const topic = this.getTopicByName(topicId, {
            threadId,
            isCreateWhenNotExist: false,
          });
          if (topic) {
            const msg = topic.findMessageById(id);
            this.logger(`UPDATE_MSG_STATUS|findMessageById|${JSON.stringify(msg)}`)
            if (msg) {
              seq = msg.seq
              msg._sending = false;
              const delivered = MC_CONST.MESSAGE_DELIVERED.SENT;
              msg.delivered = delivered;
              // topic.msgStatus(msg, true);
              const data = { delivered, msg };
              this.updateMessageStatus(topic, data);
            }
          } else {
            this.logger(`UPDATE_MSG_STATUS|Topic null|${topicId}`)
            console.log("topic", topicId, topic);
          }

          this.#execPromise(id, 0)
        }
      }
    }
  }

  onMessageReact(message, topic, type) {
    const { children, attrs } = message;
    const { from } = attrs;
    const react = children.find(
      (item) => item.name === "reactNew" || item.name === "react"
    );
    const idref = children.find((item) => item.name === "idref");
    if (react && idref) {
      const id = lodash.has(idref, 'children') && Array.isArray(idref.children) && idref.children.length > 0 ? idref.children[0] : null;

      const msg = topic.findMessageById(id);
      let owner = (type == MC_CONST.NODE_TYPE_MESSAGE.CHAT) ? MessagesUtil.getMsisdnFrom(from) : attrs.member;
      let type2 = react.attrs.add ? 'add' : react.attrs.remove ? 'remove' : '';
      let idReact = react.attrs.add ? react.attrs.add : (react.attrs.remove ? react.attrs.remove : 0);
      if (type2 && msg) {
        this._db
          .updMessageMotion(msg, parseInt(idReact), owner, type2)
          .then((msg) => this.onUpdateMotion(msg)).catch((err) => {
            console.error("MessageReact", err);
          });
      }
    }
  }

  get isWaitKeyFromMobile() {
    return this._isWaitKeyFromMobile
  }

  set isWaitKeyFromMobile(payload) {
    this._isWaitKeyFromMobile = payload
  }

  decryptPrivateE2EKey = (preKeyInfo) => {
    if (this._isWaitKeyFromMobile) return

    if (preKeyInfo.from_key_pc && preKeyInfo.from_key_pc === '1') {
      const { username, token } = profile

      const password = localStorage.getItem('prekey_decrypt_key')
      const key = `${username}${token}${preKeyInfo.timestamp}${password}`
      if (formatter._encryptMD5(key) === preKeyInfo.md5) {
        const privKey = formatter.xxteaDecrypt(preKeyInfo.pri, key)
        const pubKey = formatter.xxteaDecrypt(preKeyInfo.pub, key)
        preKeyInfo.isDecrypted = true
        preKeyInfo.privKey = privKey
        preKeyInfo.pubKey = pubKey
        preKeyInfo.isTransferKeySuccess = true
        profile.preKeyInfo = preKeyInfo
        this._isWaitKeyFromMobile = false
        this.logger(`SYNC_E2E_KEY|save|${JSON.stringify(preKeyInfo)}`)
      } else {
        this.getKeyFromMobile()
        this._isWaitKeyFromMobile = true
        this.onShowDialog(Tinode.DIALOG_TYPE.MOBILE_PASSWORD)
        this.logger(`SYNC_E2E_KEY|show mobile password|${JSON.stringify(preKeyInfo)}`)
      }
    } else {
      this.getKeyFromMobile()
      this._isWaitKeyFromMobile = true
      this.onShowDialog(Tinode.DIALOG_TYPE.MOBILE_PASSWORD)
      this.logger(`SYNC_E2E_KEY|decrypt error|${JSON.stringify(preKeyInfo)}`)
    }
  }

  getKeyFromMobile() {
    const to = `${profile.username}@reeng/reeng`
    const msg = $msg({
      id: MessagesUtil.xmppid(),
      to,
      type: MC_CONST.NODE_TYPE_MESSAGE.CHAT,
      subtype: MC_CONST.NODE_SUBTYPE_MESSAGE.CLIENT_STATE,
    }).c("pc", {
      login: 1,
    }, null)
    this.#send(msg)
  }

  saveMultiMessage(topic, listMessage) {
    window.logger('=========saveMultiMessage', topic.name, listMessage.length)
    this._db.addListMessageIndex(listMessage)
    this._db.addListMessage(listMessage)
  }

  addMessageNotify(topicId, type, data) {
    const { body, timesend, id } = data

    const threadId = Topic.getThreadId(topicId)

    const topic = this.getTopicByName(topicId, {
      threadId,
      isCreateWhenNotExist: true,
    });


    const msg = {
      threadId: threadId,
      content: body,
      id,
      from: 'notify',
      topic: topicId,
      ts: new Date(Number(timesend)),
      type,
      subtype: MC_CONST.NODE_SUBTYPE_MESSAGE.NOTIFY,
    }

    const notifyMsg = Drafty.insertNotify(null, 0, {
      body,
    });
    msg.content = notifyMsg;
    msg.head = { mime: Drafty.getContentType() };

    topic.seq ? (topic.seq += 1) : (topic.seq = 1);
    msg.seq = topic.seq;

    topic._routeData(msg);

    // Cập nhật giao diện chat list
    const sub = {
      topic: msg.topic,
      public: topic.public,
      read: topic.read,
      recv: topic.recv,
      seq: topic.seq,
      touched: topic.touched,
      updated: topic.updated,
    };
    const topicMe = this.getMeTopic();
    topicMe._processMetaSubs([sub]);
  }

  sendRequestCreateGroup = (groupName = 'Group', members, id) => {
    const msg = this.#initPacket(MC_CONST.PACKAGE_TYPE.CREATE_GROUP, {
      id,
      members,
      groupName
    })
    return this.#send(msg, id)
  }

  createGroup = (topicId, threadId, groupName, members) => {
    window.logger("==========createGroup", topicId, threadId, groupName, members);

    const topic = this.getTopicByName(topicId, {
      threadId,
      isCreateWhenNotExist: true,
      public: {
        fn: groupName,
        note: "",
      },
      sub: members.map((mem) => {
        const jid = mem.jid;
        const role = mem.role
        return this.makeGroupMember(jid, role, mem)
      }),
    });

    return new Promise((resolve, reject) => {
      resolve(topic);
    });
  };

  sendRenameGroup = (topicId, newgroupname, id) => {
    const msg = this.#initPacket(MC_CONST.PACKAGE_TYPE.RENAME_GROUP, {
      id,
      newgroupname,
      topicId,
    })
    return this.#send(msg, id)
  }

  sendRequestAddGroupMember = (topicId, membersToAdd, id) => {
    const msg = this.#initPacket(MC_CONST.PACKAGE_TYPE.ADD_GROUP_MEMBER, {
      id,
      topicId,
      membersToAdd,
    })
    return this.#send(msg, id)
  }

  sendRequestLeaveGroup = (topicId, id) => {
    const msg = this.#initPacket(MC_CONST.PACKAGE_TYPE.LEAVE_GROUP, {
      id,
      topicId,
    })
    return this.#send(msg, id)
  }

  sendRequestGroupPrivate = (topicId, keepPrivate, id) => {
    const msg = this.#initPacket(MC_CONST.PACKAGE_TYPE.CHANGE_KEEP_PRIVATE_GROUP, {
      id,
      topicId,
      keepPrivate,
    })
    return this.#send(msg, id)
  }

  sendRequestDissolveGroup = (topicId, id) => {
    const msg = this.#initPacket(MC_CONST.PACKAGE_TYPE.DISSOLVE_GROUP, {
      id,
      topicId,
    })
    return this.#send(msg, id)
  }

  handleEventBlockchat(userBlock, blockedUser, statusBlock) {
    if (userBlock && blockedUser && statusBlock) {
      const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, userBlock)
      const topic = this.getTopicByName(topicId, { isCreateWhenNotExist: true })
      if (statusBlock === '1') {
        if (topic && topic.acs && topic.acs.isWriter()) {
          topic.updateMode(null, '-W')
        }
        topic._processMetaDesc({});
      } else if (statusBlock === '0') {
        topic.updateMode(null, '+W')
        topic._processMetaDesc({});
      } else {
        window.logger("event|blockUser| invalid status block.")
      }
    }
  }

  makeGroupMember = (jid, role, member) => {
    const memTopicId = MessagesUtil.getTopicId(
      MC_CONST.NODE_TYPE_MESSAGE.CHAT,
      jid
    );
    const topic = this.getTopicByName(memTopicId, {
      threadId: jid,
      isCreateWhenNotExist: false,
    });
    if (topic) {
      let acsStr = "JRWPASD";
      if (role === MC_CONST.GROUP_ROLE.ADMIN) acsStr = `${acsStr}O`;
      const acs = new AccessMode({
        given: acsStr,
        want: acsStr,
        mode: acsStr,
      });
      return {
        ...member,
        jid,
        updated: new Date(),
        online: true,
        acs,
        public: topic.public,
        private: topic.private,
        user: memTopicId,
      };
    } else {
      setTimeout(() => this.getUserProfile(jid))
      return {
        ...member,
        updated: new Date(),
        online: true,
        acs: new AccessMode({
          given: "JRWPASD",
          want: "JRWPASD",
          mode: "JRWPASD",
        }),
        public: {
          fn: jid,
        },
        user: memTopicId,
      };
    }
  }

  loadGroupMembers(topicId) {
    const topic = this.getTopicByName(topicId, {
      threadId: Topic.getThreadId(topicId),
      isCreateWhenNotExist: false,
    });
    const subMetaInfo = {
      topic: topicId,
      ts: new Date(),
      sub: topic && topic.sub ? topic.sub.filter(v => {
        //k cập nhật acs
        delete v.acs;
        return v;
      }) : [],
    };
    topic._routeMeta(subMetaInfo);
  }

  sendFakeDissolveOA(topic, from) {
    const groupName = Topic.getTopicName(topic)
    const topicId = Const.TOPIC_MOCHA_OA
    let body = this.formatMessage(messages.oa_dissolve_group_by_others, { adminName: from, groupName })
    if (from === Const.TOPIC_ME || from === profile.username) {
      body = this.formatMessage(messages.oa_dissolve_group_by_me, { groupName })
    } else {
      const topicName = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, from)
      const topicFrom = this.getTopicByName(topicName, { isCreateWhenNotExist: true })
      const adminName = Topic.getTopicName(topicFrom) || from
      body = this.formatMessage(messages.oa_dissolve_group_by_others, { adminName, groupName })
    }

    const msg = {
      threadId: Topic.getThreadId(topicId),
      content: body,
      id: MessagesUtil.xmppid(),
      from: from,
      topic: topicId,
      ts: new Date(),
    }

    const topicOA = this.getTopicByName(Const.TOPIC_MOCHA_OA)
    topicOA.seq ? (topicOA.seq += 1) : (topicOA.seq = 1);
    msg.seq = topicOA.seq;
    topicOA._routeData(msg);

    // Cập nhật giao diện chat list
    const sub = {
      topic: msg.topic,
      read: topicOA.read,
      recv: topicOA.recv,
      seq: topicOA.seq,
      touched: new Date(),
      updated: new Date(),
    };
    const topicMe = this.getMeTopic();
    topicMe._processMetaSubs([sub]);
  }

  // retryMessage(msg, id) {
  //   let pkt = msg.pkt
  //   this.#send(pkt, id)
  // }

  getDataFromStanza = (stanza) => {
    const { children } = stanza;
    const data = {};
    children.forEach((info) => {
      data[info.name] = info.children[0];
    });
    return data;
  };

  updateMessageStatus = (topic, data) => {
    const { delivered, msg } = data;
    let funcType = "";
    switch (delivered) {
      case MC_CONST.MESSAGE_DELIVERED.SENT:
        funcType = "onData";
        break;
      case MC_CONST.MESSAGE_DELIVERED.RECEIVED:
        data.status = "recv";
        funcType = "onInfo";
        break;
      case MC_CONST.MESSAGE_DELIVERED.SEEN_1_MESSAGE:
      case MC_CONST.MESSAGE_DELIVERED.SEEN_MULTI_MESSAGES:
        data.status = "read";
        funcType = "onInfo";
        break;
    }
    switch (funcType) {
      case "onInfo": {
        if (topic.onInfo) {
          topic.onInfo({
            what: data.status,
          });
        }
      }
      case "onData": {
        if (topic.onData) {
          topic.onData(msg);
        }
      }
    }
  };

  updateMessageFailedStatus = (id) => {
    this.getMessageById(id).then((data) => {
      if (data !== null) {
        const { topic, msg } = data
        if (topic && msg) {
          const topicInfo = this.getTopicByName(topic)
          this.updateFailedMessage(topicInfo, topic, msg)
        }
      }
    })
  }

  updateFailedMessage(topicInfo, topic, msg) {
    msg.delivered = MC_CONST.MESSAGE_DELIVERED.FAILED

    this._db.updMessage(topic, msg.seq, msg)

    msg._status = Const.MESSAGE_STATUS_FAILED
    msg._failed = true;
    msg._sending = false;

    if (topicInfo.onData) {
      topicInfo.onData(msg);
    }
  }

  getMessageById = (id) => {
    return new Promise((resolve, reject) => {
      this._db.getMessageIndex(id).then((msgIndex) => {
        if (msgIndex) {
          const topicName = msgIndex.topic
          const topic = this.getTopicByName(topicName)
          if (topic) {
            const seq = msgIndex.seq
            const msg = topic.findMessage(seq)
            if (msg) {
              resolve({
                topic: topicName,
                msg
              })
            }
          }
        }
        resolve(null)
      })
    })
  }

  /**
   *
   * @param {String} topicId : Tên topic
   * @param {Object} data : Thông tin
   * @param {boolean} data.isCreateWhenNotExist : Tạo topic nếu topic chưa tồn tại
   * @returns Thông tin topic
   */
  getTopicByName = (
    topicId,
    data = {
      isCreateWhenNotExist: false,
    }
  ) => {
    if (this._myUID === topicId) {
      topicId = Const.TOPIC_ME
    }

    const isCreateWhenNotExist = data && data.isCreateWhenNotExist ? data.isCreateWhenNotExist : false;

    let topic = this.#cacheGet("topic", topicId);

    if (!topic && isCreateWhenNotExist) {
      topic = this.createTopic(topicId, data);
    }

    return topic;
  };

  getMessageXmpp(topic) {
    const topicInfo = this.getTopicByName(topic);
    return topicInfo.getMessageXmpp();
  }

  createMeTopic = () => {
    const topic = this.getMeTopic();

    const me = profile.username;

    const mode = {
      given: 41,
      mode: 41,
      want: 41,
    };
    topic.acs = new AccessMode(mode);
    const defMode = {
      given: 61,
      mode: 61,
      want: 61,
    };
    topic.defacs = new AccessMode(defMode);
    topic.public = {
      fn: me,
    };
    topic.tags = [me];
    topic.user = this._myUID;
    topic.touched = new Date();
    topic.updated = new Date();
    topic.topic = Const.TOPIC_ME;
    const meta = {
      desc: {
        created: new Date(),
        acs: new AccessMode(mode),
        defacs: new AccessMode(defMode),
        public: {
          fn: me,
        },
        touched: new Date(),
      },
      topic: Const.TOPIC_ME,
      ts: new Date(),
      id: "1",
    };

    topic._routeMeta(meta);

    return topic;
  };

  createTopic = (topicId, data) => {
    const topic = this.getTopic(topicId);

    let acs = data.acs || new AccessMode({
      given: "JRWPASDO",
      want: "JRWPASDO",
      mode: "JRWPASDO",
    });

    const threadId = data && data.threadId ? data.threadId : Topic.getThreadId(topicId)

    let fn = PhoneUtils.formatPhoneNumberToShowLao(threadId)
    let photo = null
    if (data.isGroup && data.groupName) {
      fn = data.groupName
    }
    if (data.isOfficial) {
      if (data.officialName) {
        fn = data.officialName
      }

      const ref = data.officialAvatar ? data.officialAvatar : DOMAIN_IMG_OA_DEFAULT
      const refType = Helpers.getFileExtension(ref)
      photo = {
        ref: ref,
        type: refType,
      }
    }

    topic.user = this._myUID;
    topic.online = false;
    topic.setAccessMode(acs);
    topic.read = 0;
    topic.recv = 0;
    topic.seq = 0;
    topic.topic = topicId;
    topic.touched = new Date();
    topic.updated = new Date();
    topic.isOfficial = !!data.isOfficial;
    topic.public = data && data.public ? data.public : {
      fn,
      photo,
    };
    if (data && data.sub) {
      topic.sub = data.sub;
    }

    const meta = {
      sub: [topic],
    };

    topic._routeMeta(meta);

    return topic;
  };

  syncContact = (hard = false) => {
    const lastUpdateContacts = profile.lastUpdateContacts
    if (hard || !!!lastUpdateContacts || (Number(lastUpdateContacts) + MC_CONST.TIME.HOUR_MILISECS) < new Date().getTime()) {
      ContactService.getContacts().then((res) => {
        console.log(res)
        if (res && res.contacts && res.contacts.length) {
          profile.lastUpdateContacts = new Date().getTime()
          const subs = res.contacts.map((contact) => {
            const cmsisdn = contact.cmsisdn;
            const topicId = MessagesUtil.getTopicId(
              MC_CONST.NODE_TYPE_MESSAGE.CHAT,
              cmsisdn
            );
            const topic = this.getTopicByName(topicId)
            const name = contact.cname;
            // public: tên Mocha
            const pu = Object.assign({}, {
              fn: cmsisdn,
            }, topic && topic.public ? topic.public : {});
            // private: tên lưu danh bạ
            const pr = {
              comment: name,
            };
            if (lodash.has(contact, "lavatar")) {
              pu.photo = {
                ref: Helpers.getAvatarURL(contact.cmsisdn, contact.lavatar),
                type: "png",
              };
            }
            pu.cmsisdn = contact.cmsisdn
            pu.state = contact.state
            if (contact?.currOperator) pu.currOperator = contact.currOperator
            if (contact?.birthday) pu.birthday = contact.birthday
            if (contact?.birthdayStr) pu.birthdayStr = contact.birthdayStr
            if (contact?.gender) pu.gender = contact.gender
            if (contact?.name) pu.name = contact.name
            if (contact?.permission) pu.permission = contact.permission
            if (contact?.desktop) pu.desktop = contact.desktop
            if (contact?.e2e_prekey) pu.e2e_prekey = contact.e2e_prekey

            let sub = {
              // acs,
              public: pu,
              private: pr,
              topic: topicId,
              updated: new Date(),
            };

            // setTimeout(() => this.getUserProfile(cmsisdn))

            return sub;
          });
          const meta = {
            topic: Const.TOPIC_ME,
            sub: subs,
            ts: new Date(),
          };

          const topicMe = this.getMeTopic();
          if (topicMe) {
            topicMe._routeMeta(meta);
          }
        }
      });
    }
  };

  syncGroupChat = () => {
    const isGetMucRoomList = profile.getMucRoomList
    if (!isGetMucRoomList) {
      GroupService.getListGroup().then(res => {
        const listGroup = res.lst_result
        if (Array.isArray(listGroup)) {
          profile.getMucRoomList = true
          listGroup.forEach((group) => {
            /* Example:
              {
                  "id": "+85590210828_1592902320287",
                  "name": "Group",
                  "created_date": "2020-06-23 15:52:00",
                  "last_active": "2024-01-04 11:13:42",
                  "avatar": "",
                  "avatar_path": "",
                  "lst_user": [
                      {
                          "msisdn": "+85590210828"
                      },
                      {
                          "msisdn": "0396783058"
                      },
                      {
                          "msisdn": "0828351153"
                      }
                  ]
              }
            */

            const threadId = group.id
            const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, threadId)

            const topic = this.getTopicByName(topicId)
            if (!topic) {
              const groupName = group.name
              const members = Array.isArray(group.lst_user) ? group.lst_user.map((u) => {
                const jid = u.msisdn
                return this.makeGroupMember(jid, MC_CONST.GROUP_ROLE.MEMBER, {})
              }).filter((m) => m !== null) : []


              this.createGroup(topicId, threadId, groupName, members);
            }
          })
        }
      })
    }
  }

  uploadLog = () => {
    if (profile.logDebbugEnabled) {
      const logRs = []
      this._db.mapLogs((log) => {
        logRs.push(log?.message)
      }).then(() => {
        const logStr = logRs.filter(l => !!l).join('\n')

        const blob = new Blob([logStr], {
          type: 'text/plain'
        });

        const fileName = `${profile.username}_${new Date().getTime()}`
        const file = new File([blob], fileName)

        const baseUrl = Helpers.getDomainUpload() + '/api/log/upload';
        fileService.uploadLog(baseUrl, file).then((res) => {
          if (res?.errorCode === '200') {
            const time = new Date().getTime() - 1 * MC_CONST.TIME.HOUR_MILISECS;
            this.deleteLog(time)
          }
        })
      })
    } else {
      this.deleteLog()
    }
  }

  deleteLog(time) {
    if (!time) {
      time = new Date().getTime() - 2 * MC_CONST.TIME.DAY_MILISECS;
    }
    console.log('============deleteLog', time)
    this._db.remLog(time)
  }

  getUserProfile = async (msisdn, hard = false) => {
    return new Promise((resolve, reject) => {
      try {
        const now = new Date().getTime()
        const topicId = MessagesUtil.getTopicId(
          MC_CONST.NODE_TYPE_MESSAGE.CHAT,
          msisdn
        );
        const topic = this.getTopicByName(topicId, {
          isCreateWhenNotExist: true,
          acs: new AccessMode({
            given: "JRWPASDO",
            want: "JRWPASDO",
            mode: "JRWPASDO"
          })
        })
        let update = true
        if (!hard && topic && topic.last_update && ((now - Number(topic.last_update || 0)) < MC_CONST.TIME.DAY_MILISECS)) {
          update = false
        }
        if (update) {
          ContactService.getNaNProfile(msisdn).then((res) => {
            const desc = {}
            topic.last_update = now

            let pub = null

            if (res) {
              const contacts = res.contacts ? res.contacts : []
              const contact = contacts.length > 0 ? contacts[0] : null

              if (contact) {
                pub = {
                  ...contact,
                  fn: contact.name || contact.cmsisdn,
                }
                if (contact.lavatar) {
                  pub.photo = {
                    ref: Helpers.getAvatarURL(contact.cmsisdn, contact.lavatar),
                    type: 'png'
                  }
                }
                desc.public = pub
              }
            }
            topic._processMetaDesc(desc)
            resolve(pub)
          })
        } else {
          resolve(topic.public)
        }
      } catch (e) {
        console.error(e)
        reject(null)
      }
    })
  }

  getMyUserProfile = () => {
    ContactService.getProfile().then((res) => {
      if (res && res.errorCode === 200) {
        const topicMe = this.getTopicByName(Const.TOPIC_ME)
        delete res.code
        delete res.errorCode

        res.fn = res.name

        const pub = Object.assign({}, topicMe.public, res)
        topicMe.public = pub

        const desc = {
          public: pub,
        }

        topicMe._processMetaDesc(desc)
      }

    })
  }

  getStickerCollection = () => {
    StickerService.getStickers().then((res) => {
      window.logger('getStickerCollection', res)
      if (res && Array.isArray(res.stickerCollection)) {
        const listCollection = res.stickerCollection;
        const current = stickers.sticker;
        stickers.sticker = listCollection.map((collection) => {
          const collectionId = collection.collectionId;
          const cCollection = current.filter(
            (c) => c.collectionId === collectionId
          );
          const currentCollection =
            cCollection.length > 0 ? cCollection[0] : {};
          return {
            ...collection,
            ...currentCollection,
          };
        });

        stickers.save();
        window.logger(`|Storage.save stickerCollections success`);
      }
    });
  };

  getSettingApp = () => {
    SettingsService.getConfigApp().then((settings) => {
      profile.settings = settings
    })
  }

  getListUserBlock = () => {
    BlockChatServices.getListBlock().then((res) => {
      if (res && res.blockChat && res.blockChat.length > 0) {
        profile.listBlockChat = res.blockChat
        window.logger(`|Storage.save getListUserBlock success`);
      }
    });
  };


  getSettingApp = () => {
    SettingsService.getConfigApp().then((settings) => {
      profile.settings = settings
    })
  }

  /**
   * Out of band notification: notify topic that an external (push) notification was recived by the client.
   *
   * @param {object} data - notification payload.
   * @param {string} data.what - notification type, 'msg', 'read', 'sub'.
   * @param {string} data.topic - name of the updated topic.
   * @param {number=} data.seq - seq ID of the affected message.
   * @param {string=} data.xfrom - UID of the sender.
   * @param {object=} data.given - new subscription 'given', e.g. 'ASWP...'.
   * @param {object=} data.want - new subscription 'want', e.g. 'RWJ...'.
   */
  oobNotification(data) {
    this.logger(
      "oob: " +
      (this._trimLongStrings ? JSON.stringify(data, jsonLoggerHelper) : data)
    );

    switch (data.what) {
      case "msg":
        if (!data.seq || data.seq < 1 || !data.topic) {
          // Server sent invalid data.
          break;
        }

        if (!this.isConnected()) {
          // Let's ignore the message if there is no connection: no connection means there are no open
          // tabs with Tinode.
          break;
        }

        const topic = this.#cacheGet("topic", data.topic);
        if (!topic) {
          // TODO: check if there is a case when a message can arrive from an unknown topic.
          break;
        }

        if (topic.isSubscribed()) {
          // No need to fetch: topic is already subscribed and got data through normal channel.
          break;
        }

        if (topic.maxMsgSeq() < data.seq) {
          if (topic.isChannelType()) {
            topic._updateReceived(data.seq, "fake-uid");
          }

          // New message.
          if (data.xfrom && !this.#cacheGet("user", data.xfrom)) {
            // Message from unknown sender, fetch description from the server.
            // Sending asynchronously without a subscription.
            this.getMeta(
              data.xfrom,
              new MetaGetBuilder().withDesc().build()
            ).catch((err) => {
              this.logger("Failed to get the name of a new sender", err);
            });
          }

          topic
            .subscribe(null)
            .then((_) => {
              return topic.getMeta(
                new MetaGetBuilder(topic)
                  .withLaterData(24)
                  .withLaterDel(24)
                  .build()
              );
            })
            .then((_) => {
              // Allow data fetch to complete and get processed successfully.
              topic.leaveDelayed(false, 1000);
            })
            .catch((err) => {
              this.logger("On push data fetch failed", err);
            })
            .finally((_) => {
              this.getMeTopic()._refreshContact("msg", topic);
            });
        }
        break;

      case "read":
        this.getMeTopic()._routePres({
          what: "read",
          seq: data.seq,
        });
        break;

      case "sub":
        if (!this.isMe(data.xfrom)) {
          // TODO: handle updates from other users.
          break;
        }

        const mode = {
          given: data.modeGiven,
          want: data.modeWant,
        };
        const acs = new AccessMode(mode);
        const pres =
          !acs.mode || acs.mode == AccessMode._NONE
            ? // Subscription deleted.
            {
              what: "gone",
              src: data.topic,
            }
            : // New subscription or subscription updated.
            {
              what: "acs",
              src: data.topic,
              dacs: mode,
            };
        this.getMeTopic()._routePres(pres);
        break;

      default:
        this.logger("Unknown push type ignored", data.what);
    }
  }

  /**
   * @typedef GetQuery
   * @type {Object}
   * @property {GetOptsType=} desc - If provided (even if empty), fetch topic description.
   * @property {GetOptsType=} sub - If provided (even if empty), fetch topic subscriptions.
   * @property {GetDataType=} data - If provided (even if empty), get messages.
   */

  /**
   * @typedef GetOptsType
   * @type {Object}
   * @property {Date=} ims - "If modified since", fetch data only it was was modified since stated date.
   * @property {number=} limit - Maximum number of results to return. Ignored when querying topic description.
   */

  /**
   * @typedef GetDataType
   * @type {Object}
   * @property {number=} since - Load messages with seq id equal or greater than this value.
   * @property {number=} before - Load messages with seq id lower than this number.
   * @property {number=} limit - Maximum number of results to return.
   */

  /**
   * Request topic metadata
   *
   * @param {string} topic - Name of the topic to query.
   * @param {GetQuery} params - Parameters of the query. Use {@link Tinode.MetaGetBuilder} to generate.
   *
   * @returns {Promise} Promise which will be resolved/rejected on receiving server reply.
   */
  getMeta(topic, params) {
    // const pkt = this.#initPacket('get', topic);
    // pkt.get = mergeObj(pkt.get, params);
    // return this.#send(pkt, pkt.get.id);
    return new Promise((resolve, reject) => {
      resolve(null)
    })
  }

  /**
   * Update topic's metadata: description, subscribtions.
   *
   * @param {string} topic - Topic to update.
   * @param {SetParams} params - topic metadata to update.
   * @returns {Promise} Promise which will be resolved/rejected on receiving server reply.
   */
  setMeta(topic, params) {
    if (params && params.sub) {
      if (topic) {
        const cont = this.getTopic(topic);
        const given = cont.getAccessMode().updateMode(params.sub.mode);
        const ctrl = this.setMuteFake(topic, given);
        return ctrl;
      }
    } else {
      return new Promise((resolve, reject) => {
        resolve({
          ctrl: {
            code: 200,
            topic: Const.TOPIC_FND,
            text: "ok",
            ts: new Date(),
          },
        });
      });
    }
  }

  setMuteFake(topicName, acsMode) {
    return new Promise((resolve, reject) => {
      resolve({
        ctrl: {
          topic: topicName,
          params: {
            acs: acsMode,
          },
          code: 200,
          text: "ok",
          ts: new Date(),
        },
      });
    });
  }

  /**
   * Range of message IDs to delete.
   *
   * @typedef DelRange
   * @type {Object}
   * @property {number} low - low end of the range, inclusive (closed).
   * @property {number=} hi - high end of the range, exclusive (open).
   */
  /**
   * Delete some or all messages in a topic.
   *
   * @param {string} topic - Topic name to delete messages from.
   * @param {DelRange[]} list - Ranges of message IDs to delete.
   * @param {boolean=} hard - Hard or soft delete
   *
   * @returns {Promise} Promise which will be resolved/rejected on receiving server reply.
   */
  async delMessages(topicName, ranges, hard) {
    const topic = this.getTopic(topicName);

    const del = ranges.hi ? ranges.hi : ranges.low;

    let isRemoveMsg = true;

    if (hard) {
      const msg = topic.findMessage(del);
      if (msg) {
        const result = await this.recallMessage(msg);
        isRemoveMsg = result;
      }
    }

    return new Promise((resolve, reject) => {
      if (isRemoveMsg) {
        const del = ranges.hi ? ranges.hi : ranges.low;
        const rs = {
          params: {
            del,
          },
        };
        resolve(rs);
      } else {
        reject("Recall Message Fail");
      }
    });
  }

  /**
   * Delete the topic alltogether. Requires Owner permission.
   *
   * @param {string} topicName - Name of the topic to delete
   * @param {boolean} hard - hard-delete topic.
   * @returns {Promise} Promise which will be resolved/rejected on receiving server reply.
   */
  delTopic(topicName, hard) {
    return new Promise((resolve, reject) => {
      const rs = {
        ctrl: {
          topic: topicName,
          ts: new Date(),
        },
      };
      resolve(rs);
    });
  }

  getHidePassword = () => {
    try {
      if (profile && profile.settings && profile.settings.hide_thread && profile.settings.hide_thread.pin) {
        return formatter.xxteaDecrypt(profile.settings.hide_thread.pin, profile.username)
      }
    } catch (e) {
      console.error('getHidePassword', e)
    }

    return null
  }

  hideTopic(topicName, isHide) {
    return new Promise((resolve, reject) => {
      try {
        const threadId = Topic.getThreadId(topicName)
        const objConfig = profile.settings
        const hideThread = objConfig.hide_thread
        const thread = hideThread.thread
        if (isHide) {
          if (Array.isArray(thread) && !thread.includes(threadId)) {
            hideThread.thread = thread.concat(threadId)
          } else {
            hideThread.thread = [threadId]
          }
        } else {
          if (Array.isArray(thread) && thread.includes(threadId)) {
            hideThread.thread = thread.filter(t => t !== threadId)
          } else {
            hideThread.thread = []
          }
        }

        objConfig.hide_thread = hideThread
        SettingsService.setConfigApp(objConfig).then((res) => {
          const topicMe = this.getTopicByName(Const.TOPIC_ME)
          const sub = {
            topic: topicName,
            isHide: isHide,
            updated: new Date(),
          };
          topicMe._processMetaSubs([sub])

          profile.settings = objConfig

          resolve({
            errorCode: MC_CONST.ERROR_CODE.SUCCESS,
            threadId,
          })
        })
      } catch (e) {
        console.error(e)
        resolve({
          errorCode: MC_CONST.ERROR_CODE.EXTERNAL_ERROR,
          error: e,
        })
      }

    })
  }

  setNewHidePassword(pin) {
    return new Promise((resolve) => {
      try {
        const objConfig = profile.settings
        objConfig.hide_thread = {
          pin: formatter.xxteaEncrypt(pin, profile.username),
        }

        SettingsService.setConfigApp(objConfig).then((res) => {
          profile.settings = objConfig

          resolve({
            errorCode: MC_CONST.ERROR_CODE.SUCCESS,
          })
        })
      } catch (e) {
        console.error('setNewHidePassword error', e)
        resolve({
          errorCode: MC_CONST.ERROR_CODE.EXTERNAL_ERROR,
          error: e,
        })
      }
    })
  }

  resetHidePassword() {
    return new Promise((resolve) => {
      try {
        const objConfig = profile.settings
        const listHideThread = objConfig.hide_thread && Array.isArray(objConfig.hide_thread.thread) ? objConfig.hide_thread.thread : []
        objConfig.hide_thread = {}

        SettingsService.setConfigApp(objConfig).then((res) => {
          listHideThread.forEach((threadId) => {
            const type = Topic.isGroupThread(threadId) ? MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT : MC_CONST.NODE_TYPE_MESSAGE.CHAT
            const topicName = MessagesUtil.getTopicId(type, threadId)
            const topic = this.getTopicByName(topicName)
            if (topic) {
              topic.delMessagesAll(true)
              topic.isHide = false
              this._db.updTopic(topic)
            }
          })

          resolve({
            errorCode: MC_CONST.ERROR_CODE.SUCCESS,
            listHideThread,
          })
        })
      } catch (e) {
        console.error('resetHidePassword error', e)
        resolve({
          errorCode: MC_CONST.ERROR_CODE.EXTERNAL_ERROR,
          error: e,
        })
      }
    })
  }

  async recallMessage(message) {
    const threadId = Topic.getThreadId(message.topic);
    const res = await ChatServices.recallMessage(threadId, message);
    return res.code === 200;
  }

  async getGroupDetail(groupId) {
    const groupInfo = await GroupService.getGroupDetail(groupId)
    console.log(groupInfo);
    return groupInfo
  }

  async showGroupInfo(url) {
    const position = url.indexOf('/g/');
    const groupIdEnc = url.slice(position + 3);
    const groupId = formatter.xxteaDecrypt(groupIdEnc, XXTEA_KEY_DEFAULT)

    const groupInfo = await this.getGroupDetail(groupId)
    if (groupInfo?.code === 200) {
      const { state } = groupInfo
      if (state === JOIN_GROUP_STATE.ALREADY_MEMBER) {
        const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, groupId)
        this.handleTopicSelected(topicId)
      } else {
        const data = {
          subject: groupInfo.subject,
          member: groupInfo.member,
          owner: groupInfo.owner,
          state: groupInfo.state,
          total_member: groupInfo.total_member,
          groupId: groupId,
        }
        this.onShowDialog(Tinode.DIALOG_TYPE.JOIN_GROUP_LINK, data)
      }

    } else {
      Helpers.showWarningToasts(this.formatMessage(messages.group_invite_link_expired))
    }
  }

  async addPendingMember(groupId) {

  }

  /**
   * Delete subscription. Requires Share permission.
   *
   * @param {string} topicName - Name of the topic to delete
   * @param {string} user - User ID to remove.
   * @returns {Promise} Promise which will be resolved/rejected on receiving server reply.
   */
  delSubscription(topicName, user) {
    const pkt = this.#initPacket("del", topicName);
    pkt.del.what = "sub";
    pkt.del.user = user;

    return this.#send(pkt, pkt.del.id);
  }

  /**
   * Delete credential. Always sent on <code>'me'</code> topic.
   *
   * @param {string} method - validation method such as <code>'email'</code> or <code>'tel'</code>.
   * @param {string} value - validation value, i.e. <code>'alice@example.com'</code>.
   * @returns {Promise} Promise which will be resolved/rejected on receiving server reply.
   */
  delCredential(method, value) {
    const pkt = this.#initPacket("del", Const.TOPIC_ME);
    pkt.del.what = "cred";
    pkt.del.cred = {
      meth: method,
      val: value,
    };

    return this.#send(pkt, pkt.del.id);
  }

  /**
   * Request to delete account of the current user.
   *
   * @param {boolean} hard - hard-delete user.
   * @returns {Promise} Promise which will be resolved/rejected on receiving server reply.
   */
  delCurrentUser(hard) {
    const pkt = this.#initPacket("del", null);
    pkt.del.what = "user";
    pkt.del.hard = hard;

    return this.#send(pkt, pkt.del.id).then((_) => {
      this._myUID = null;
    });
  }

  /**
   * Notify server that a message or messages were read or received. Does NOT return promise.
   *
   * @param {string} topicName - Name of the topic where the mesage is being aknowledged.
   * @param {string} what - Action being aknowledged, either <code>"read"</code> or <code>"recv"</code>.
   * @param {number} seq - Maximum id of the message being acknowledged.
   */
  note(topicName, what, data) {
    switch (what) {
      case "read": {
        const { listUnreadMessageId } = data;
        if (listUnreadMessageId.length > 0) {
          const threadId = Topic.getThreadId(topicName);
          const type = Topic.getMessageType(topicName);
          if (profile.isSendDeliveredSeen) {
            this.sendDeliveredSeen(threadId, {
              type,
              member: profile.username,
              listId: listUnreadMessageId,
              status: MC_CONST.MESSAGE_DELIVERED.SEEN_MULTI_MESSAGES,
            });
          }
        }
      }
    }
  }

  /**
   * Broadcast a key-press notification to topic subscribers. Used to show
   * typing notifications "user X is typing...".
   *
   * @param {string} topicName - Name of the topic to broadcast to.
   * @param {string=} type - notification to send, default is 'kp'.
   */
  noteKeyPress(topic) {
    const pkt = this.#initPacket(`${MC_CONST.NODE_TYPE_MESSAGE.CHAT}_${MC_CONST.NODE_SUBTYPE_MESSAGE.TYPING}`, topic);
    // pkt.note.what = type || 'kp';
    this.#send(pkt);
  }

  /**
   * Send a video call notification to topic subscribers (including dialing,
   * hangup, etc.).
   *
   * @param {string} topicName - Name of the topic to broadcast to.
   * @param {int} seq - ID of the call message the event pertains to.
   * @param {string} evt - Call event.
   * @param {string} payload - Payload associated with this event (e.g. SDP string).
   *
   * @returns {Promise} Promise (for some call events) which will
   *                    be resolved/rejected on receiving server reply
   */
  videoCall(topicName, seq, evt, payload) {
    // const pkt = this.#initPacket('note', topicName);
    // pkt.note.seq = seq;
    // pkt.note.what = 'call';
    // pkt.note.event = evt;
    // pkt.note.payload = payload;
    // this.#send(pkt, pkt.note.id);
  }

  /**
   * Get a named topic, either pull it from cache or create a new instance.
   * There is a single instance of topic for each name.
   *
   * @param {string} topicName - Name of the topic to get.
   *
   * @returns {Topic} Requested or newly created topic or <code>undefined</code> if topic name is invalid.
   */
  getTopic(topicName) {
    let topic = this.#cacheGet("topic", topicName);
    if (!topic && topicName) {
      if (topicName == Const.TOPIC_ME) {
        topic = new TopicMe();
      } else if (topicName == Const.TOPIC_FND) {
        topic = new TopicFnd();
      } else {
        topic = new Topic(topicName);
      }
      // Cache management.
      this.#attachCacheToTopic(topic);
      topic._cachePutSelf();
      // Don't save to DB here: a record will be added when the topic is subscribed.
    }
    return topic;
  }

  /**
   * Get a named topic from cache.
   *
   * @param {string} topicName - Name of the topic to get.
   *
   * @returns {Topic} Requested topic or <code>undefined</code> if topic is not found in cache.
   */
  cacheGetTopic(topicName) {
    return this.#cacheGet("topic", topicName);
  }

  /**
   * Remove named topic from cache.
   *
   * @param {string} topicName - Name of the topic to remove from cache.
   */
  cacheRemTopic(topicName) {
    this.#cacheDel("topic", topicName);
  }

  /**
   * Iterate over cached topics.
   *
   * @param {Function} func - callback to call for each topic.
   * @param {Object} context - 'this' inside the 'func'.
   */
  mapTopics(func, context) {
    this.#cacheMap("topic", func, context);
  }

  /**
   * Check if named topic is already present in cache.
   *
   * @param {string} topicName - Name of the topic to check.
   * @returns {boolean} true if topic is found in cache, false otherwise.
   */
  isTopicCached(topicName) {
    return !!this.#cacheGet("topic", topicName);
  }

  /**
   * Generate unique name like <code>'new123456'</code> suitable for creating a new group topic.
   *
   * @param {boolean} isChan - if the topic is channel-enabled.
   * @returns {string} name which can be used for creating a new group topic.
   */
  newGroupTopicName(isChan) {
    return (
      (isChan ? Const.TOPIC_NEW_CHAN : Const.TOPIC_NEW) + this.getNextUniqueId()
    );
  }

  /**
   * Instantiate <code>'me'</code> topic or get it from cache.
   *
   * @returns {TopicMe} Instance of <code>'me'</code> topic.
   */
  getMeTopic() {
    const me = this.getTopic(Const.TOPIC_ME);
    return me;
  }

  /**
   * Instantiate <code>'fnd'</code> (find) topic or get it from cache.
   *
   * @returns {Topic} Instance of <code>'fnd'</code> topic.
   */
  getFndTopic() {
    return this.getTopic(Const.TOPIC_FND);
  }

  /**
   * Create a new {@link LargeFileHelper} instance
   *
   * @returns {LargeFileHelper} instance of a {@link Tinode.LargeFileHelper}.
   */
  getLargeFileHelper() {
    return new LargeFileHelper(this, Const.PROTOCOL_VERSION);
  }

  /**
   * Get the UID of the the current authenticated user.
   *
   * @returns {string} UID of the current user or <code>undefined</code> if the session is not yet
   * authenticated or if there is no session.
   */
  getCurrentUserID() {
    return this._myUID;
  }

  /**
   * Check if the given user ID is equal to the current user's UID.
   *
   * @param {string} uid - UID to check.
   *
   * @returns {boolean} true if the given UID belongs to the current logged in user.
   */
  isMe(uid) {
    return this._myUID === uid;
  }

  /**
   * Get login used for last successful authentication.
   *
   * @returns {string} login last used successfully or <code>undefined</code>.
   */
  getCurrentLogin() {
    return this._login;
  }

  /**
   * Return information about the server: protocol version and build timestamp.
   *
   * @returns {Object} build and version of the server or <code>null</code> if there is no connection or
   * if the first server response has not been received yet.
   */
  getServerInfo() {
    return this._serverInfo;
  }

  /**
   * Report a topic for abuse. Wrapper for {@link Tinode#publish}.
   *
   * @param {string} action - the only supported action is 'report'.
   * @param {string} target - name of the topic being reported.
   *
   * @returns {Promise} Promise to be resolved/rejected when the server responds to request.
   */
  report(action, target) {
    return this.publish(
      Const.TOPIC_SYS,
      Drafty.attachJSON(null, {
        action: action,
        target: target,
      })
    );
  }

  /**
   * Return server-provided configuration value.
   *
   * @param {string} name of the value to return.
   * @param {Object} defaultValue to return in case the parameter is not set or not found.
   *
   * @returns {Object} named value.
   */
  getServerParam(name, defaultValue) {
    return (this._serverInfo && this._serverInfo[name]) || defaultValue;
  }

  /**
   * Toggle console logging. Logging is off by default.
   *
   * @param {boolean} enabled - Set to <code>true</code> to enable logging to console.
   * @param {boolean} trimLongStrings - Set to <code>true</code> to trim long strings.
   */
  enableLogging(enabled, trimLongStrings) {
    this._loggingEnabled = enabled;
    this._trimLongStrings = enabled && trimLongStrings;
  }

  /**
   * Set UI language to report to the server. Must be called before <code>'hi'</code> is sent, otherwise it will not be used.
   *
   * @param {string} hl - human (UI) language, like <code>"en_US"</code> or <code>"zh-Hans"</code>.
   */
  setHumanLanguage(hl) {
    if (hl) {
      this._humanLanguage = hl;
    }
  }

  /**
   * Check if given topic is online.
   *
   * @param {string} name of the topic to test.
   * @returns {boolean} true if topic is online, false otherwise.
   */
  isTopicOnline(name) {
    const topic = this.#cacheGet("topic", name);
    return topic && topic.online;
  }

  /**
   * Get access mode for the given contact.
   *
   * @param {string} name of the topic to query.
   * @returns {AccessMode} access mode if topic is found, null otherwise.
   */
  getTopicAccessMode(name) {
    const topic = this.#cacheGet("topic", name);
    return topic ? topic.acs : null;
  }

  /**
   * Include message ID into all subsequest messages to server instructin it to send aknowledgemens.
   * Required for promises to function. Default is <code>"on"</code>.
   *
   * @param {boolean} status - Turn aknowledgemens on or off.
   * @deprecated
   */
  wantAkn(status) {
    if (status) {
      this._messageId = Math.floor(Math.random() * 0xffffff + 0xffffff);
    } else {
      this._messageId = 0;
    }
  }

  backupMsg(tinode) {
    window.logger('=================backupMsg')
    RestoreServices.restoreBackupMessages(tinode, 0)
  }

  getTopicName(msisdn) {
    try {
      const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, msisdn)
      const topic = this.getTopicByName(topicId)
      if (topic) {
        return Topic.getTopicName(topic)
      }
    } catch (e) {
      console.error(e)
    }
    return msisdn
  }

  // Callbacks:
  /**
   * Callback to report when the websocket is opened. The callback has no parameters.
   *
   * @type {onWebsocketOpen}
   */
  onWebsocketOpen = undefined;

  /**
   * @typedef ServerParams
   *
   * @type {Object}
   * @property {string} ver - Server version
   * @property {string} build - Server build
   * @property {string=} sid - Session ID, long polling connections only.
   */

  /**
   * @callback onConnect
   * @param {number} code - Result code
   * @param {string} text - Text epxplaining the completion, i.e "OK" or an error message.
   * @param {ServerParams} params - Parameters returned by the server.
   */
  /**
   * Callback to report when connection with Tinode server is established.
   * @type {onConnect}
   */
  onConnect = undefined;

  /**
   * Callback to report when connection is lost. The callback has no parameters.
   * @type {onDisconnect}
   */
  onDisconnect = undefined;

  /**
   * @callback onLogin
   * @param {number} code - NUmeric completion code, same as HTTP status codes.
   * @param {string} text - Explanation of the completion code.
   */
  /**
   * Callback to report login completion.
   * @type {onLogin}
   */
  onLogin = undefined;

  /**
   * Callback to receive <code>{ctrl}</code> (control) messages.
   * @type {onCtrlMessage}
   */
  onCtrlMessage = undefined;

  /**
   * Callback to recieve <code>{data}</code> (content) messages.
   * @type {onDataMessage}
   */
  onDataMessage = undefined;

  /**
   * Callback to receive <code>{pres}</code> (presence) messages.
   * @type {onPresMessage}
   */
  onPresMessage = undefined;

  /**
   * Callback to receive all messages as objects.
   * @type {onMessage}
   */
  onMessage = (pkt) => {
    switch (pkt.name) {
      case MC_CONST.NODE_NAME.STREAM:
        this.authenticate(pkt.attrs);
        break;
      case MC_CONST.NODE_NAME.IQ:
        this.onIqMessage(pkt);
        break;
      case MC_CONST.NODE_NAME.PRESENCE:
        this.onPresenceMessage(pkt);
        break;
      case MC_CONST.NODE_NAME.MESSAGE:
        this.onMessageMessage(pkt);
        break;
      default:
        break;
    }
  };

  /**
   * Callback to receive all messages as unparsed text.
   * @type {onRawMessage}
   */
  onRawMessage = undefined;

  /**
   * Callback to receive server responses to network probes. See {@link Tinode#networkProbe}
   * @type {onNetworkProbe}
   */
  onNetworkProbe = undefined;

  /**
   * Callback to be notified when exponential backoff is iterating.
   * @type {onAutoreconnectIteration}
   */
  onAutoreconnectIteration = undefined;

  /**
   * Callback when login XMPP Success.
   * @type {onLoginSuccessfully}
   */
  onLoginSuccessfully = undefined;

  /**
   * Callback khi người dùng click vào thông báo
   * @type {onNotificationClick}
   */
  onNotificationClick = undefined

  onMessageHide = undefined

  showBackupSuccess() {
    Helpers.showSuccessToasts(this.formatMessage(messages.backup_success_message))
  }

  showBackupLoading = (isShow) => {
    if (this.onShowBackupLoading) {
      const data = {
        progressType: PROGRESS_TYPE.INFINITY,
      }
      this.onShowBackupLoading(isShow, data)
    }
  }
}

// Exported constants
Tinode.MESSAGE_STATUS_NONE = Const.MESSAGE_STATUS_NONE;
Tinode.MESSAGE_STATUS_QUEUED = Const.MESSAGE_STATUS_QUEUED;
Tinode.MESSAGE_STATUS_SENDING = Const.MESSAGE_STATUS_SENDING;
Tinode.MESSAGE_STATUS_FAILED = Const.MESSAGE_STATUS_FAILED;
Tinode.MESSAGE_STATUS_FATAL = Const.MESSAGE_STATUS_FATAL;
Tinode.MESSAGE_STATUS_SENT = Const.MESSAGE_STATUS_SENT;
Tinode.MESSAGE_STATUS_RECEIVED = Const.MESSAGE_STATUS_RECEIVED;
Tinode.MESSAGE_STATUS_READ = Const.MESSAGE_STATUS_READ;
Tinode.MESSAGE_STATUS_TO_ME = Const.MESSAGE_STATUS_TO_ME;

// Unicode [del] symbol.
Tinode.DEL_CHAR = Const.DEL_CHAR;

// Names of keys to server-provided configuration limits.
Tinode.MAX_MESSAGE_SIZE = "maxMessageSize";
Tinode.MAX_SUBSCRIBER_COUNT = "maxSubscriberCount";
Tinode.MAX_TAG_COUNT = "maxTagCount";
Tinode.MAX_FILE_UPLOAD_SIZE = "maxFileUploadSize";
Tinode.REQ_CRED_VALIDATORS = "reqCred";

Tinode.MESSAGE_EMOTIONS = MC_CONST.MESSAGE_EMOTIONS;
Tinode.DIALOG_TYPE = MC_CONST.DIALOG_TYPE;
Tinode.DIALOG_SETTING_TYPE = MC_CONST.DIALOG_SETTING_TYPE;
Tinode.LANGUAGE_SUPPORT = MC_CONST.LANGUAGE_SUPPORT;
Tinode.OPTIONS_SEARCH = MC_CONST.OPTIONS_SEARCH;
Tinode.DEEPLINK_SUPPORT = MC_CONST.DEEPLINK_SUPPORT